jQuery(document).ready(function(){
	documentReady();
	jQuery('.tipso_tooltip').tipso({ background:'#444444',color:'#ffffff'});
	jQuery(".txtInteger").on('keydown',fun_Integer);

	jQuery(".mobinav .trigger-menu").click(function (e) {
		jQuery(".concan-menu").slideToggle(150);
	});

	jQuery('.help_btn').tipso({background: '#ffffff',color: '#000000',tooltipHover: true});
	jQuery('.tipso_tooltip_adultchild').tipso({ background:'#444',color:'#ffffff',width:'100'});
	jQuery('.tooltip-offer').tipso({ titleBackground:'#037d09',titleColor: '#ffffff',background:'#ffffff',color:'#111111',width:'200',AddClass:'tipso_title_offer', TextAlign:'left'});  //Jemin - RES-2230
	jQuery('.tipso-tooltip-roomlist').tipso({background:'#444444',color:'#ffffff', width: '',maxWidth: 300,TextAlign:'left',tooltipHover: true}); //Chandrakant - 28 July 2021, Purpose - RES-2803
	//Prashant Patel - 23 March 2021  Start[RES-2714]
	//Purpose : Input Field jQuery validations.
	var disableHtml=function(element){element.value=element.value.replace(/[<>]/g,"")};
	var NonSpecialCharacter=function(element){element.value=element.value.replace(/[<>,!={}|#$%^&*()[\]@_+]/g,"")};
	var mobileno=function(element){element.value=element.value.replace(/[<>,?'";:~`\\/=!{}|#$%^&*[\]@_a-zA-Z]/g,"")};
	jQuery(".txtarea").on('focusout',function(){disableHtml(this)});
	jQuery(".nonspecialchar").on('focusout',function(){NonSpecialCharacter(this)}); 
	jQuery(".txtInteger2").on('focusout',function(){mobileno(this)}); 

	var addcitystatevarify = function(element){element.value=element.value.replace(/[\\+()$!~%^;.'":*?<>{}]/g,"")};
	jQuery(".addcitystate").on('focusout',function(){addcitystatevarify(this)});
	
	//Prashant Patel - 23 March 2021  End
});

function documentReady()
{
	try
	{
		jQuery(".viewrows").click(function(){
			jQuery(this).toggleClass("triggered");
			jQuery(this).parent().parent().parent().siblings(".toggletypes").slideToggle(150);
			return false;
		});
		
		jQuery("#booking_enquiry").click(function(){
			jQuery("#booking_enquiry").addClass("active");
			jQuery("#card_detail").removeClass("active");
			jQuery("#online_payment").removeClass("active");
			
			jQuery("#enquiry_field").show();
			jQuery("#card_field").hide();
			jQuery("#pg_field").hide();
		});
		
		jQuery("#card_detail").click(function(){
			jQuery("#booking_enquiry").removeClass("active");
			jQuery("#card_detail").addClass("active");
			jQuery("#online_payment").removeClass("active");
			
			jQuery("#enquiry_field").hide();
			jQuery("#card_field").show();
			jQuery("#pg_field").hide();
		});
		
		jQuery("#online_payment").click(function(){
			jQuery("#booking_enquiry").removeClass("active");
			jQuery("#card_detail").removeClass("active");
			jQuery("#online_payment").addClass("active");
			
			jQuery("#enquiry_field").hide();
			jQuery("#card_field").hide();
			jQuery("#pg_field").show();
		});
		
		jQuery("#number-card").keydown(function(e)
		{
			jQuery('#number-card').validateCreditCard(function(result)
			{
				var JSONobject = eval(result);
				if (JSONobject.card_type!=null)
				{
					jQuery('#number-card').next("span").removeClass("confirm");
					jQuery('#number-card').attr("class","be-input error_cno cardNo-text");
					var cardtype=JSONobject.card_type['name'];
					jQuery('#cc_cardtype').val(cardtype);
				  
					if(cardtype=='American Express')
						cardtype="AmericanExpress";
					else if(cardtype=='Diners Club')
						cardtype='DinersClub';
					else if (cardtype=='Visa Electron')
						cardtype='VisaElectron';
					else if (cardtype=='China UnionPay')
						cardtype='ChinaUnionPay';
				  
					jQuery("#number-card").addClass("cardNo-"+cardtype)
					
					if (JSONobject.valid==true && JSONobject.luhn_valid==true && JSONobject.length_valid==true)
						jQuery('#number-card').next("span").addClass("confirm");
				}
				else
				{
					jQuery('#number-card').attr("class","be-input error_cno cardNo-text");
					jQuery('#number-card').next("span").removeClass("confirm");
				}
			});
		});
		
		jQuery("#PGCCBlockcc_cardnumber").keydown(function(e)
		{
			jQuery('#PGCCBlockcc_cardnumber').validateCreditCard(function(result)
			{
				var JSONobject = eval(result);
				if (JSONobject.card_type!=null)
				{
					jQuery('#PGCCBlockcc_cardnumber').next("span").removeClass("confirm");
					jQuery('#PGCCBlockcc_cardnumber').attr("class","be-input error_cno cardNo-text");
					var cardtype=JSONobject.card_type['name'];
					jQuery('#pgcc_cardtype').val(cardtype);
				  
					if(cardtype=='American Express')
						cardtype="AmericanExpress";
					else if(cardtype=='Diners Club')
						cardtype='DinersClub';
					else if (cardtype=='Visa Electron')
						cardtype='VisaElectron';
					else if (cardtype=='China UnionPay')
						cardtype='ChinaUnionPay';
				  
					jQuery("#PGCCBlockcc_cardnumber").addClass("cardNo-"+cardtype)
					
					if (JSONobject.valid==true && JSONobject.luhn_valid==true && JSONobject.length_valid==true)
						jQuery('#PGCCBlockcc_cardnumber').next("span").addClass("confirm");
				}
				else
				{
					jQuery('#PGCCBlockcc_cardnumber').attr("class","be-input error_cno cardNo-text");
					jQuery('#PGCCBlockcc_cardnumber').next("span").removeClass("confirm");
				}
			});
		});
		
		jQuery("#makeanotherbooking").click(function(){
			var crsaccount = jQuery("#crsaccount").val();
			var serverurl = jQuery("#loadingurl").val();
			var language = jQuery("#selectedLang").val();
			
			if(language == '')
				language = '-be';
			
			if(crsaccount == '1')
				window.location=jQuery("#loadingurl").val()+"chain-"+jQuery("#groupcode").val()+language;
			else
				window.location=jQuery("#loadingurl").val()+"roomlist-"+jQuery("#hotel_code").val()+language;
		});
		
		jQuery("#returnwebsite,#returnwebsite1").click(function(){
			
			var crsaccount = jQuery("#crsaccount").val();
			var serverurl = jQuery("#loadingurl").val();
			var language = jQuery("#selectedLang").val();
			
			if(language == '')
				language = '-be';
			
			if(crsaccount == '1')
			{
				if(jQuery('#website').val() == '')
					window.location=jQuery("#loadingurl").val()+"chain-"+jQuery("#groupcode").val()+language;
				else
					window.location=jQuery('#website').val();
			}
			else
			{
				if(jQuery('#website').val() == '')
					window.location=jQuery("#loadingurl").val()+"roomlist-"+jQuery("#hotel_code").val()+language;
				else
					window.location=jQuery('#website').val();
			}
		});
		jQuery(".hide_addon").click(function(){
			jQuery(this).toggleClass("triggered");
			jQuery(this).parent().siblings(".extra-list").slideToggle(150);
			return false;
		});
		
		//Chinmay Gandhi - 25th Oct 2019 - Transport Information [ RES-2176 ] - Start
		jQuery(".hide_transpot").click(function(){
			jQuery(this).toggleClass("triggered");
			jQuery(this).parent().siblings(".transpot-list").slideToggle(150);
			return false;
		});
		//Chinmay Gandhi - 25th Oct 2019 - Transport Information [ RES-2176 ] - End
		//Prashant -5 june  2021 - purpose : hide show toggle in checkout page [RES-2799] --START 
		jQuery(".hide_identity").click(function(){
			jQuery(this).toggleClass("triggered");
			jQuery(this).parent().siblings(".identity-list").slideToggle(150);
			return false;
		});
		jQuery(".hide_guestprefrence").click(function(){
			jQuery(this).toggleClass("triggered");
			jQuery(this).parent().siblings(".guestpreferences-list").slideToggle(150);
			return false;
		});
		jQuery(".hide_address").click(function(){
			jQuery(this).toggleClass("triggered");
			jQuery(this).parent().siblings(".address-list").slideToggle(150);
			return false;
		});

	}
	catch(err){
		console.log("Error - documentReady - "+err.message);
	}
}
//kishan Tailor 22 March 2019 :Click search if after change checkin/checkout data if guest not click on search START
function seeavalibleroom(foldername, hotelname, WebExommerceClassicView)
{
	if(typeof(WebExommerceClassicView)=='undefined' || WebExommerceClassicView=='') {
		var WebExommerceClassicView=''; 
	}
	if(typeof(hotelname)=='undefined' || hotelname=='') {
		var hotelname=''; 
	}
	if(jQuery("#searchbtnclicked").val()==1)
	{
		var message_title = js_stripslashes(langjs[0]["lblHangon"]);
		var message = js_stripslashes(langjs[0]["L_forgotsearch"]);
		var message_btn =js_stripslashes(langjs[0]["L_ClickSearch"]);

		swal({
			title: message_title,
			text: message,
			type: "warning",
			confirmButtonText: message_btn,
			showCancelButton: false,
			//cancelButtonText:"No",
			confirmButtonColor: "#DD6B55",
			animation:false				
			},
			function(){
				jQuery('#searchhotel').trigger('click');
			}
		);
	}
	else
	{
		_loader('Show');
		var checkin=jQuery('.src-dates #checkin').val();
		var checkout=jQuery('.src-dates #checkout').val();
		if(WebExommerceClassicView != '' && WebExommerceClassicView == 5){
			addDataLayerSearchHotel(checkin,checkout,hotelname);
		}

		var serverurl=jQuery('#loadingurl').val();
		var GroupCode = jQuery("#groupcode").val();
		window.location.href = serverurl+"roomlisting-"+GroupCode+"-"+foldername+jQuery('#selectedLang').val();
	}
}
//kishan Tailor 22 March 2019 :Click search if after change checkin/checkout data if guest not click on search END
function isValidEmailAddress(emailAddress) {
	var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}

function isValidMobileNo(number) {
	var pattern = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return pattern.test(number);
}

function _loader(operation)
{
	try
	{
		if(operation == 'Show')
			jQuery('#fs_loader').show();
		else if(operation == 'Hide')
			jQuery('#fs_loader').hide();

		//Jemin - RES-2230 - START
		jQuery('.tipso_tooltip').tipso({ background:'#444444',color:'#ffffff'});
		jQuery(".txtInteger").on('keydown',fun_Integer);
		jQuery('.help_btn').tipso({background: '#ffffff',color: '#000000',tooltipHover: true});
		jQuery('.tipso_tooltip_adultchild').tipso({ background:'#444',color:'#ffffff',width:'100'});
		jQuery('.tooltip-offer').tipso({ titleBackground:'#037d09',titleColor: '#ffffff',background:'#ffffff',color:'#111111',width:'200',AddClass:'tipso_title_offer', TextAlign:'left'});  
		// Jemin END
		jQuery('.tipso-tooltip-roomlist').tipso({background:'#444444',color:'#ffffff', width: '',maxWidth: 300,TextAlign:'left',tooltipHover: true}); //Chandrakant - 28 July 2021, Purpose - RES-2803

	}
	catch(err){
		console.log("Error - _loader - "+err.message);
	}
}

function _hotellistchangeview(displaystyle)
{
	try
	{
		if(displaystyle == 1)
		{
			jQuery('#main-wrap .hotel-list').show();
			jQuery('#main-wrap .hotel-grid').hide();
			jQuery(".crs-views .list-view").addClass("active");
			jQuery(".crs-views .grid-view").removeClass("active");
		}
		else
		{
			jQuery('#main-wrap .hotel-grid').show();
			jQuery('#main-wrap .hotel-list').hide();
			jQuery(".crs-views .grid-view").addClass("active");
			jQuery(".crs-views .list-view").removeClass("active");
		}
	}
	catch(err){
		console.log("Error - _hotellistchangeview - "+err.message);
	}
}

function _toggleOperation()
{
	try
	{
		jQuery(".guestperroom").click(function(){
			jQuery(".guestperroom .dropdown-box").toggleClass("toggle_effect");
		});
		
		jQuery(".dropdown .ctrl-item").click(function (e) {
			if(jQuery('.review-critique-list:visible').length == 1)
				jQuery(".review-critique-list").hide();
			else
				jQuery(this).next(".dropdown-box").slideToggle(150);
		});
		jQuery(".dropdown #managepromotion").on( "click", function (e) {
			setTimeout(function(e){
				if (jQuery(".dd-promocode").is(":visible")){
						jQuery("#promotion").focus();
				}
			}, 200);
		});
		
		jQuery(".lvl2").click(function (e) {
			if(jQuery(e.target).attr("value") != '')
			{
				jQuery('#destination').val(jQuery(e.target).text());
				jQuery('#destination').attr('option',jQuery(e.target).attr('value'));
				jQuery("#destination").removeClass('error');
				jQuery(this).next(".dropdown-box").slideToggle(150);
			}
		});
		//focusin by daksh
		jQuery("#destination").keypress(function(event){
			var keycode = (event.keyCode ? event.keyCode : event.which);
			if(keycode == '13'){
				jQuery(".dropdown-box").slideUp(150);
				jQuery(this).parent(".ctrl-item").next(".dropdown-box").slideDown(150);
			}
		});
		jQuery(document).keyup(function(e){
			if (e.keyCode === 27) jQuery(".dropdown-box").slideUp(150);
			if(jQuery(".start-date").is(":focus")) jQuery(".dropdown-box").slideUp(150);
		});

		jQuery(document).on("click",function(e) {
			if(!jQuery(e.target).hasClass("managedestination") && !jQuery(e.target).hasClass("destin-wrap") && jQuery('.destinationList:visible').length !== 0 && !jQuery(e.target).hasClass("material-icons") && !jQuery(e.target).hasClass("fz14"))
				jQuery('.dropdown .ctrl-item').next(".destinationList").slideToggle(150);
				
			if(!jQuery(e.target).hasClass("managesorting") && jQuery('.sortList:visible').length != 0)
				jQuery('.dropdown .ctrl-item').next(".sortList").slideToggle(150);
			
			if(!jQuery(e.target).hasClass("managefilter") && !jQuery(e.target).hasClass("lnk-reset") && !jQuery(e.target).hasClass("filtlist") && !jQuery(e.target).hasClass("dd-title") && !jQuery(e.target).hasClass("dd-filters") && !jQuery(e.target).hasClass("list-title") && jQuery('.filterList:visible').length != 0 && !jQuery(e.target).hasClass("mngfilter"))
				jQuery('.dropdown .ctrl-item').next(".filterList").slideToggle(150);
				
			if(!jQuery(e.target).hasClass("managelanguage") && jQuery('.languagelist:visible').length != 0)
				jQuery('.dropdown .ctrl-item').next(".languagelist").slideToggle(150);	
	
			if(!jQuery(e.target).is(".managecurrency") && jQuery('.currencylist:visible').length != 0)
				jQuery('.dropdown .ctrl-item').next(".currencylist").slideToggle(150);
				
			if(!jQuery(e.target).hasClass("managepromotion") && !jQuery(e.target).hasClass("promo-applied") && jQuery('.dd-promocode:visible').length != 0 && !jQuery(e.target).hasClass("promotion"))
				jQuery('.dropdown .ctrl-item').next(".dd-promocode").slideToggle(150);
				
			if(!jQuery(e.target).hasClass("bap_managedestination") && !jQuery(e.target).hasClass("fz14") && !jQuery(e.target).hasClass("book_another_property_popup") && jQuery('.bap_destinationList:visible').length !== 0)
				jQuery('.dropdown .ctrl-item').next(".bap_destinationList").slideToggle(150);
			
			if(!$(e.target).is(".review-rating, .lbl_rating, .ratings") && $(e.target).parents(".review-critique-list").length === 0)
				jQuery('.dropdown .ctrl-item').next(".review-critique-list").slideUp(150);
		});
		
		jQuery('#editsearchdata').click(function(){
			jQuery('#editcheckinOut').show();
			jQuery('#editguestroom').show();
			jQuery('#searchbtnres').show();
			jQuery('.closesearch').show();
			jQuery('#checkInOutRes').hide();
			jQuery('#guestroomres').hide();
			jQuery('#editbtnres').hide();
		});
		jQuery('.closesearch').click(function(){
			jQuery('.rooms_guest').text(jQuery('#guestperroom').text());
			jQuery('.arrival').text(jQuery('#checkin').val());
			jQuery('.departure').text(jQuery('#checkout').val());
			jQuery('#editcheckinOut').hide();
			jQuery('#editguestroom').hide();
			jQuery('#searchbtnres').hide();
			jQuery('.closesearch').hide();
			jQuery('#checkInOutRes').show();
			jQuery('#guestroomres').show();
			jQuery('#editbtnres').show();
		});
		
		jQuery('.destinationList .destin-wrap').click(function(){
			if(jQuery('#destination').val() != '')
			{
				jQuery('.clearSelection').show();
				jQuery('.destidown').hide();
			}
			else
			{
				jQuery('.destidown').show();
				jQuery('.clearSelection').hide();
			}
		});
		
		jQuery('.clearSelection').click(function(){
			jQuery('#destination').val('');
			jQuery('.destidown').show();
			jQuery('.clearSelection').hide();
			jQuery('#destination').attr('option','');
		});
	}
	catch(err){
		console.log("Error - _toggleOperation - "+err.message);
	}
}

//Pinal - 15 January 2019 - START
//Purpose : Multiple property listing language datepicker.
function _setBoxdata(datesetting,timezone,getLocalDateTime,languagecode,fullflag,pageinfo)
{
	try
	{
		languagecode=languagecode || '';
		
		if(fullflag == 0)//Chinmay Gandhi - Book another property [ RES-1992 ]
			_toggleOperation();
			
		var currentDate = moment(getLocalDateTime, 'MM-DD-YYYY').format(datesetting);
		
		jQuery('.src-dates #checkin').daterangepicker({
			timeZone : timezone,
			singleDatePicker: true,
			locale:{format:datesetting,
			daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
			monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
			},
			minDate: currentDate,
			opens: 'right' //opens: 'center'

		}, function(start, end, label) {
			var diff_co_date = moment(jQuery('.src-dates #checkout').val(), datesetting).format('YYYY-MM-DD');
			var diff = (new Date(diff_co_date) - new Date(start.format('YYYY-MM-DD')));
			
			//Chandrakant - 27 September 2022 - START
			//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
			ariaDateCheckIn = start.format("dddd, MMMM D, YYYY");
			jQuery('.src-dates #checkin').attr("aria-label", ariaDateCheckIn);
			//Chandrakant - 27 September 2022 - END

			if(diff > 0)
			{
				jQuery('.src-dates #checkin').data('daterangepicker').setStartDate(start.format(datesetting));
				jQuery('.src-dates #checkin').data('daterangepicker').setEndDate(start.format(datesetting));
			}
			else
			{
				var startdate = start.format(datesetting);
				var new_date = moment(startdate, datesetting).add(1, 'd');

				//Chandrakant - 27 September 2022 - START
				//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
				ariaDateCheckout = new_date.format("dddd, MMMM D, YYYY");
				jQuery('.src-dates #checkout').attr("aria-label", ariaDateCheckout);
				//Chandrakant - 27 September 2022 - END

				var date = new_date.format('DD') + '-' + new_date.format('MM') + '-' + new_date.format('YYYY');
				var diffformet = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
				var diff = (new Date(diffformet) - new Date(start.format('YYYY-MM-DD')));
				jQuery('.src-dates #checkin').data('daterangepicker').setStartDate(start.format(datesetting));
				jQuery('.src-dates #checkin').data('daterangepicker').setEndDate(start.format(datesetting));
				jQuery('.src-dates #checkout').data('daterangepicker').setStartDate(moment(date, 'DD-MM-YYYY').format(datesetting));
				jQuery('.src-dates #checkout').data('daterangepicker').setEndDate(moment(date, 'DD-MM-YYYY').format(datesetting));
			}
			jQuery('.cnt-nights span').html(diff/1000/60/60/24);
		});
		
		jQuery('.src-dates #checkout').daterangepicker({
			timeZone : timezone,
			singleDatePicker: true,
			locale:{format:datesetting,
			daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
			monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
			},
			minDate: currentDate,
			opens: 'left' //opens: 'center'
		}, function(start, end, label) {
			jQuery("#searchbtnclicked").val(1);//kishan Tailor 22 March 2019
			var diff_ci_date = moment(jQuery('.src-dates #checkin').val(), datesetting).format('YYYY-MM-DD');
			var diff = (new Date(start.format('YYYY-MM-DD')) - new Date(diff_ci_date));

			//Chandrakant - 27 September 2022 - START
			//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
			ariaDateCheckout = start.format("dddd, MMMM D, YYYY");
			jQuery('.src-dates #checkout').attr("aria-label", ariaDateCheckout);
			//Chandrakant - 27 September 2022 - END
			
			if(diff > 0)
			{
				jQuery('.src-dates #checkout').data('daterangepicker').setStartDate(start.format(datesetting));
				jQuery('.src-dates #checkout').data('daterangepicker').setEndDate(start.format(datesetting));
			}
			else
			{
				var startdate = start.format(datesetting);
				var new_date = moment(startdate, datesetting).add(1, 'd');
				var date = new_date.format('DD') + '-' + new_date.format('MM') + '-' + new_date.format('YYYY');
				var diffformet = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
				var diff = (new Date(diffformet) - new Date(start.format('YYYY-MM-DD')));
				jQuery('.src-dates #checkin').data('daterangepicker').setStartDate(start.format(datesetting));
				jQuery('.src-dates #checkin').data('daterangepicker').setEndDate(start.format(datesetting));
				jQuery('.src-dates #checkout').data('daterangepicker').setStartDate(moment(date, 'DD-MM-YYYY').format(datesetting));
				jQuery('.src-dates #checkout').data('daterangepicker').setEndDate(moment(date, 'DD-MM-YYYY').format(datesetting));
			}
			jQuery('.cnt-nights span').html(diff/1000/60/60/24);
		});
		
		jQuery('#checkin').on('hide.daterangepicker', function(ev, picker) {
			jQuery(this).on('apply.daterangepicker', function(ev, picker) {
				
				//Pinal - 2 March 2019 - START
				//Purpose : Multiple property listing set min date on checkout on change of checkin
				var currentDate = moment(jQuery('.src-dates #checkin').val(), datesetting).add(1,'days');
				jQuery("#searchbtnclicked").val(1);
				//jQuery('#checkout').daterangepicker({
				//	timeZone : timezone,
				//	singleDatePicker: true,
				//	locale:{format:datesetting,},
				//	minDate: currentDate,
				//});
				
				jQuery('.src-dates #checkout').daterangepicker({
					timeZone : timezone,
					singleDatePicker: true,
					locale:{format:datesetting,
					daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
					monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
					},
					minDate: currentDate,
					opens: 'left' //opens: 'center'
				}, function(start, end, label) {
					
					var diff_ci_date = moment(jQuery('.src-dates #checkin').val(), datesetting).format('YYYY-MM-DD');
					var diff = (new Date(start.format('YYYY-MM-DD')) - new Date(diff_ci_date));

					//Chandrakant - 27 September 2022 - START
					//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
					ariaDateCheckout = start.format("dddd, MMMM D, YYYY");
					jQuery('.src-dates #checkout').attr("aria-label", ariaDateCheckout);
					//Chandrakant - 27 September 2022 - END
					
					if(diff > 0)
					{
						jQuery('.src-dates #checkout').data('daterangepicker').setStartDate(start.format(datesetting));
						jQuery('.src-dates #checkout').data('daterangepicker').setEndDate(start.format(datesetting));
					}
					else
					{
						var startdate = start.format(datesetting);
						var new_date = moment(startdate, datesetting).add(1, 'd');
						var date = new_date.format('DD') + '-' + new_date.format('MM') + '-' + new_date.format('YYYY');
						var diffformet = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
						var diff = (new Date(diffformet) - new Date(start.format('YYYY-MM-DD')));
						jQuery('.src-dates #checkin').data('daterangepicker').setStartDate(start.format(datesetting));
						jQuery('.src-dates #checkin').data('daterangepicker').setEndDate(start.format(datesetting));
						jQuery('.src-dates #checkout').data('daterangepicker').setStartDate(moment(date, 'DD-MM-YYYY').format(datesetting));
						jQuery('.src-dates #checkout').data('daterangepicker').setEndDate(moment(date, 'DD-MM-YYYY').format(datesetting));
					}
					jQuery('.cnt-nights span').html(diff/1000/60/60/24);
				});
				
				//Pinal - 2 March 2019 - END
				
				jQuery('#checkout').trigger( "click" );
			});
		});

		if(pageinfo == 1)
			storevar(1);//Chinmay Gandhi - Book another property [ RES-1992 ]

		//Chandrakant - 27 September 2022 - START
		//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
		var chekIndate = moment(jQuery('.src-dates #checkin').val(), datesetting).format('dddd, MMMM D, YYYY');
		jQuery('.src-dates #checkin').attr("aria-label", chekIndate);

		var chekOutdate = moment(jQuery('.src-dates #checkout').val(), datesetting).format('dddd, MMMM D, YYYY');
		jQuery('.src-dates #checkout').attr("aria-label", chekOutdate);
		//Chandrakant - 27 September 2022 - END
	}
	catch(err){
		console.log("Error - _setBoxdata - "+err.message);
	}
}
//Pinal - 15 January 2019 - END

//Chinmay Gandhi - 25th Oct 2019 - Transport Information [ RES-2176 ] - Start
function _setDateTransportation_Mode(datesetting,timezone,getLocalDateTime,languagecode,id)
{
	try{
		var currentDate = getLocalDateTime;
		jQuery('.form-wrap #'+id).daterangepicker({
			timeZone : timezone,
			singleDatePicker: true,
			autoUpdateInput: false,
			locale:{
				format:datesetting,
				daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
				monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
			},
			minDate: currentDate,
			opens: 'right'
		}, function(start, end, label) {
			
		});
		jQuery('.form-wrap #'+id).on('apply.daterangepicker', function(ev, picker) {
			jQuery(this).val(picker.startDate.format(datesetting));
			jQuery(this).removeClass('error');
			jQuery(this).attr('aria-invalid','false');
			
				jQuery("[id^=billerror_]").each(function() {
					if(jQuery(this).hasClass('er_'+id)===true)
						jQuery(this).remove();
				});
		});
	}
	catch(err){
		console.log("Error - _setDateTransportation_Mode - "+err.message);
	}
}
//Chinmay Gandhi - 25th Oct 2019 - Transport Information [ RES-2176 ] - End

//Prashant - 29 may 2021 - Identity Information [ RES-2799 ] - Start
function _setDateIdentity_Mode(datesetting,timezone,languagecode,id)
{
	try{
		jQuery('.form-wrap #'+id).daterangepicker({
			timeZone : timezone,
			singleDatePicker: true,
			autoUpdateInput: false,
			showDropdowns: true,
			locale:{
				format:datesetting,
				daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
				monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
			},
			opens: 'right'
		}, function(start, end, label) {
			
		});
		jQuery('.form-wrap #'+id).on('apply.daterangepicker', function(ev, picker) {
			jQuery(this).val(picker.startDate.format(datesetting));
			jQuery(this).removeClass('error');
			jQuery(this).attr('aria-invalid','false');
			
				jQuery("[id^=billerror_]").each(function() {
					if(jQuery(this).hasClass('er_'+id)===true)
						jQuery(this).remove();
				});
		});
	}
	catch(err){
		console.log("Error - _setDateIdentity_Mode - "+err.message);
	}
}
//Prashant - 29 may 2021 - Identity Information [ RES-2799 ] - End

function _roomselection(crsaccount)
{
	try
	{
		var totcnt = jQuery('.roomguest-dropdown #roomscnt').val();
		var totadult = totchild = totguest = 0;
		for(var i=1; i<=totcnt; i++){
			totadult+= parseFloat(jQuery('#adult_'+i).val());
			totchild+= parseFloat(jQuery('#child_'+i).val());
		}
		
		totguest = totadult + totchild;
		var gurest_per_room =totcnt + ' '+langjs[0]["L_Room"]+', '+totguest+' '+langjs[0]["L_Guest"]+' <i class="caret down"></i>';
		jQuery('#guestperroom').html(gurest_per_room);
		jQuery('#manageGuest .ctrl-item').next(".dropdown-box").toggle(150);
		jQuery('.row #no_of_room').val(totcnt);
		jQuery('.row #adult').val(totadult);
		jQuery('.row #child').val(totchild);
	}
	catch(err){
		console.log("Error - _roomselection - "+err.message);
	}
}

function _removeroom(crsaccount)
{
	try{
		_checksession('',crsaccount);
		var roomcount =jQuery('.roomguest-dropdown #roomscnt').val();
		jQuery('.roomrow-wrapper #roomcontent_'+roomcount).remove();
		roomcount--; jQuery('.roomguest-dropdown #roomscnt').val(roomcount);
	}
	catch(err){
		console.log("Error - _removeroom - "+err.message);
	}
}

function _searchhotel(crsaccount,isroomsearch,datesetting,WebExommerceClassicView) //Prashant Patel - 21/09/2021 - Purpose : Add datesetting parameter [RES-2881]
{
	try
	{
		if(typeof(WebExommerceClassicView)=='undefined' || WebExommerceClassicView=='') {
			 var WebExommerceClassicView=''; 
		}
		jQuery("#searchbtnclicked").val(0);//kishan Tailor 22 March 2019 
		_checksession('',crsaccount);
	
		//This is to remove destination from mandatory selection , in future we might need it so do not remove below commented code - Pinal
		//if(crsaccount == 1 && isroomsearch == 0)
		//{
		//	if(jQuery("#destination").val() == '')
		//	{
		//		jQuery("#destination").addClass('error');
		//		return false;
		//	}
		//}
	
		_loader('Show');
		
		var serverurl=jQuery('#loadingurl').val();
		var GroupCode = jQuery("#groupcode").val();
		var HotelId = jQuery("#hotel_code").val();
		var config_token=jQuery("input#restoken").val();
		
		if(typeof(config_token)=='undefined') { var config_token=''; }
		
		if(crsaccount == 1)
			var param1 = 'GroupCode='+GroupCode+'&action=checktoken&config_token='+config_token;
		else
			var param1 = 'HotelId='+HotelId+'&action=checktoken&config_token='+config_token;
		
		jQuery.ajax({
			type: "POST",		
			url: serverurl+'multiproperty_service.php',			  
			data: param1,
			success: function(response) {
				
			},
			complete: function(response)
			{
				if(jQuery.trim(response.responseText)==1 || config_token=='')
				{
					var checkin=jQuery('.src-dates #checkin').val();
					var checkout=jQuery('.src-dates #checkout').val();
					//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --START
					var startDate = new Date(moment(checkin,datesetting).format('YYYY-MM-DD'));
					var endDate = new Date(moment(checkout,datesetting).format('YYYY-MM-DD'));
					
					var difference = (endDate - startDate) / (86400000);
					if(difference > 90)
					{
						_loader('Hide');
							var message = langjs[0]["SWAL_morenightsnotallowed"];                                     
							var title_message = langjs[0]["SWAL_lblAccessRestricted"];
							swal({
								title: title_message,
								text: message,
								type: 'warning',
								animation:false	
							},function(){          
								var date = startDate;
								date.setDate(date.getDate() + 90);
								jQuery('.src-dates #checkout').data('daterangepicker').setStartDate(moment(startDate).format(datesetting));
								jQuery('.src-dates #checkout').data('daterangepicker').setEndDate(moment(startDate).format(datesetting));
								jQuery("#searchbtnclicked").val(1);
								jQuery('.cnt-nights span').html(90);
							});									 
							return false;
					}
					//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --END
					if(new Date(checkout) < new Date(checkin))
					{
						_loader('Hide');
						var message = langjs[0]["L_checkinout_msg"];
						swal({
							title: langjs[0]["L_InvRequest"],
							text: message,
							type: "warning",
							confirmButtonColor: "#DD6B55",
							animation:false
						},
						function(data){
							location.reload();
						});
						return false;
					}
					else
					{
						if(crsaccount == 1 && isroomsearch == 0)
						{
							var parm = 'GroupCode='+jQuery("#groupcode").val()+'&destination='+jQuery("#destination").attr('option')+'&checkIn='+checkin+'&checkOut='+checkout;
							var getUrl = serverurl+'multihotellist.php';
						}
						else
						{
							In_date = checkin.replace(/-| |,|_/g,'_');
							Out_date = checkout.replace(/-| |,|_/g,'_');
							
							if(crsaccount == 1)
								var parm = 'GroupCode='+jQuery("#groupcode").val()+'&HotelId='+jQuery("#foldername").val()+'&checkIn='+In_date+'&checkOut='+Out_date+'&isroomsearch='+isroomsearch;
							else
								var parm = 'HotelId='+jQuery("#hotel_code").val()+'&checkIn='+In_date+'&checkOut='+Out_date+'&isroomsearch='+isroomsearch;
								
							var getUrl = serverurl+'roomlisting.php';
						}
						
						jQuery.ajax({
							url: getUrl,
							type: "POST",
							dataType: "html",
							data: parm,
							success: function(response){
								if(isroomsearch == 0)
								{
									var _result = jQuery(response).find('.body-content');
									jQuery('.body-content').html(_result);
									jQuery("#_roomdetail_popup").html(jQuery(response).find('#_roomdetail_popup'));
									jQuery('.remodal-wrapper').remove();
									jQuery('.remodal').remodal();
									insertHotelBEstats(serverurl); //Pinal - 21 January 2019 - Purpose : Multiple property listing statistics data.
									_applysorting(0,1);
									jQuery(".dd-sorting a.active").removeClass("active");
									jQuery('#new').addClass("active");
								}
								else
								{
									var jQmanager = $(response);
									
									var _result = jQmanager.find('#manage_search_data');
									var manage_bar = jQmanager.find('#hotel_managebar').html();
									var popup_result = jQmanager.find('#_roomdetail_popup').html();
									var detail_info_popup = jQmanager.find('#detail_info_popup').html();
									var mapData = jQmanager.find('#mapData').html();
									var book_another_box = jQmanager.find('#book_another_box').html();//Chinmay Gandhi - Book another property [ RES-1992 ]
									var roomgalary = jQmanager.find('#roomgalary').html();
									var roomdata = jQuery(_result).find('.roomlist');
									
									jQuery('#_roomdetail_popup').html(popup_result);
									jQuery('#detail_info_popup').html(detail_info_popup);
									jQuery('#mapData').html(mapData);
									jQuery('#book_another_box').html(book_another_box);//Chinmay Gandhi - Book another property [ RES-1992 ]
									jQuery('#roomgalary').html(roomgalary);
									jQuery('.remodal-wrapper').remove();
									jQuery('.remodal').remodal();
									jQuery('#hotel_managebar').html(manage_bar);
									jQuery('#manage_search_data').html(_result);
									getMap(jQuery('#hcode').val());
									
									if(roomdata.length > 0)
									{
										jQuery('.data-exist').show();
										jQuery('#nofound_Roomlist').hide();
									}
									else
									{
										jQuery('.data-exist').hide();
										jQuery('#nofound_Roomlist').show();
										jQuery('#nofound_Roomlist .notfound').css('margin-top','');
									}
									
									insertstatsdata(); //Pinal - 22 January 2019 - Purpose : Multiple property listing statistics data.
									_applysorting(1,1);
									jQuery(".matchboth a.active").removeClass("active");
									jQuery("#nosort").addClass("active");
									
									//Pinal - 21 February 2019 - START
									//Purpose : Multiple property listing below code is for getting updated variable.
									var dom = $(response);
									dom.filter('script').each(function(){
										
										var text=this.text;
										if(text.indexOf("var Date_Range=")>-1 && text.indexOf("var resgrid=")>-1)
										{
											$.globalEval(text);
										}
									});
									//promoresult={};
									//apply_promotion('0');//Apply Promotion
									//Pinal - 21 February 2019 - END
								}
							},
							complete: function(response){
								if(isroomsearch == 0)
								{
									if(jQuery('.list-view').hasClass('active'))
										_hotellistchangeview(1);
									else
										_hotellistchangeview(0);
									
									//Chinmay Gandhi - 22nd OCT 2019 - Fixing Minor Display issue of MHBE [ MHBE_Display_Issue ] - Start
									jQuery(".dropdown .review-rating").click(function (e) {
										if(jQuery('.review-critique-list:visible').length == 1)
											jQuery(".review-critique-list").hide();
										else
											jQuery(this).next(".dropdown-box").slideToggle(150);
									});
									//Chinmay Gandhi - 22nd OCT 2019 - Fixing Minor Display issue of MHBE [ MHBE_Display_Issue ] - End
										
									_getRoomsRatesAvailability();
								}
								else
								{
									jQuery(".promodd .ctrl-item").click(function (e) {
										if(!jQuery(e.target).hasClass("material-icons") && jQuery('.currencylist:visible').length == 0)
											jQuery(this).next(".dropdown-box").slideToggle(150);
									});
									
									convertcurrencyroomlisting(conversion_rate); //Pinal - 12 February 2019 - Purpose : Multiple property listing currency conversion
									
									if(jQuery('#ratesview').hasClass('active'))
										_roomlistchangeview(1,'');
									else
										_roomlistchangeview(0,'');
									
									jQuery(".viewrows").click(function(){
										jQuery(this).toggleClass("triggered");
										jQuery(this).parent().parent().parent().siblings(".toggletypes").slideToggle(150);
										return false;
									});
									jQuery('.closesearch').click();
									
									if(jQuery('#RoomDetailsSize').val() == 0 && closest_ava_flag == 1)
										find_closest_availability(closest_param,1,currency_prefixsuffix)//Chinmay Gandhi - Closest Availability Tool [ RES-2079 ]

									storevar(1);//Chinmay Gandhi - Book another property [ RES-1992 ]
									_Update_CartItem('',2,crsaccount,'');
								}
								reset_filter(0,'',1);	
								_loader('Hide');
							}
						});
					}
					if(WebExommerceClassicView != '' && WebExommerceClassicView == 5){
						addDataLayerSearchHotel(checkin,checkout,jQuery("#destination").attr('option'));
					}
				}
				else
				{
					_loader('Hide');
					swal({
							title: langjs[0]["L_InvRequest"],
							text: langjs[0]["L_InvRequest"],
							type: "warning",
							showCancelButton: false,
							confirmButtonColor: "#DD6B55",
							animation:false				
						},
						function(){
							location.reload();
						});
					return false;
				}
			}
		});
	}
	catch(err){
		console.log("Error - _searchhotel - "+err.message);
	}
}

function _bookroom(identifier,viewstyle,maxadult,maxchild,crsaccount,seladultchild,taxdetail,childagesetting,roomlist_grid,max_occupancy)
{
	try
	{
		//kishan Tailor 22 March 2019 :Click search if after change checkin/checkout data if guest not click on search START
		if(jQuery("#searchbtnclicked").val()==1)
		{
			var message_title = js_stripslashes(langjs[0]["lblHangon"]);
			var message = js_stripslashes(langjs[0]["L_forgotsearch"]);
			var message_btn =js_stripslashes(langjs[0]["L_ClickSearch"]);

				swal({
					title: message_title,
					text: message,
					type: "warning",
					confirmButtonText: message_btn,
					showCancelButton: false,
					//cancelButtonText:"No",
					confirmButtonColor: "#DD6B55",
					animation:false				
					},
					function(){
						jQuery('#searchhotel').trigger('click');
					}
				);
			return false;
		}
		//kishan Tailor 22 March 2019 :Click search if after change checkin/checkout data if guest not click on search END

		if(viewstyle == 0)
		{
			var rmcnt = (parseFloat(jQuery('.rcnt_'+identifier).html()) + 1);
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#RoomTypeId_'+room_identity).val();
			
			if(rmcnt > Number(jQuery('.avi-room_'+roomtypeid).html()))
				return false;
			
			if(jQuery('.avi-room_'+roomtypeid).html() != jQuery('.maxbookRoom_'+roomtypeid).val())
			{
				_isHackattemt(crsaccount);
				return false;
			}
			
			jQuery('#RoomType_RoomView_'+identifier).hide();
			jQuery('#RateType_RoomView_'+identifier).show();
		}
		else if(viewstyle == 1)
		{
			var rmcnt = (parseFloat(jQuery('.rmcnt_'+identifier).html()) + 1);
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#Rate-RoomTypeId_'+identifier).val();
			
			if(rmcnt > Number(jQuery('.rate-aviroom_'+roomtypeid).html()))
				return false;
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() != jQuery('.maxbookRate_'+roomtypeid).val())
			{
				_isHackattemt(crsaccount);
				return false;
			}
			
			jQuery('#RateType_RateView_'+identifier).hide();
			jQuery('#RoomType_RateView_'+identifier).show();
		}
		_addmoreroom(identifier,viewstyle,maxadult,maxchild,crsaccount,seladultchild,taxdetail,childagesetting,roomlist_grid,max_occupancy);
	}
	catch(err){
		console.log("Error - _bookroom - "+err.message);
	}
}

function _roomlistchangeview(displaystyle,focusId)//Maintain focus when click on edit option
{
	try
	{
		if(displaystyle == 1)
		{
			jQuery('#main-wrap .viewbyRooms').hide();
			jQuery('#main-wrap .viewbyRates').show();
			jQuery(".toggleRRviews #ratesview").addClass("active");
			jQuery(".toggleRRviews #roomsview").removeClass("active");
			var focusclass = '#RoomType_RateView_'+focusId;
		}
		else
		{
			jQuery('#main-wrap .viewbyRooms').show();
			jQuery('#main-wrap .viewbyRates').hide();
			jQuery(".toggleRRviews #roomsview").addClass("active");
			jQuery(".toggleRRviews #ratesview").removeClass("active");
			var focusclass = '#RateType_RoomView_'+focusId;
		}
		
		//Maintain focus when click on edit option - Start
		if(focusId != '')
		{
			setTimeout(function() { 
				jQuery('html, body').animate({
					scrollTop: parseInt(jQuery(focusclass).offset().top)
				}, 500);
				jQuery(focusclass).addClass("focus-div");
			}, 500);
			
			setTimeout(function() { jQuery(focusclass).removeClass("focus-div"); }, 2500);
		}
		//Maintain focus when click on edit option - End
	}
	catch(err){
		console.log("Error - _roomlistchangeview - "+err.message);
	}
}

function _addnewroom(crsaccount)
{
	try
	{
		_checksession('',crsaccount);
		var roomcount =jQuery('.roomguest-dropdown #roomscnt').val();
		
		roomcount++;
		var addroomtxt = '<div class="d-flex roomrow" id="roomcontent_'+roomcount+'"><label class="room-lbl">'+langjs[0]["L_Room"]+' '+roomcount+'</label><div class="cstm-select"><select class="be-input" name="adult_'+roomcount+'" id="adult_'+roomcount+'"><option value="1">1 '+langjs[0]["L_Adult"]+'</option><option value="2">2 '+langjs[0]["L_Adult"]+'</option><option value="3">3 '+langjs[0]["L_Adult"]+'</option><option value="4">4 '+langjs[0]["L_Adult"]+'</option><option value="5">5 '+langjs[0]["L_Adult"]+'</option><option value="6">6 '+langjs[0]["L_Adult"]+'</option><option value="7">7 '+langjs[0]["L_Adult"]+'</option></select></div><div class="cstm-select"><select class="be-input" name="child_'+roomcount+'" id="child_'+roomcount+'"><option value="0">0 '+langjs[0]["L_Child"]+'</option><option value="1">1 '+langjs[0]["L_Child"]+'</option><option value="2">2 '+langjs[0]["L_Child"]+'</option><option value="3">3 '+langjs[0]["L_Child"]+'</option><option value="4">4 '+langjs[0]["L_Child"]+'</option><option value="5">5 '+langjs[0]["L_Child"]+'</option></select></div><a class="room-remove" onclick="_removeroom('+crsaccount+')">'+langjs[0]["L_Remove"]+'</a></div>';
		
		jQuery('.roomrow-wrapper').append(addroomtxt);
		jQuery('.roomguest-dropdown #roomscnt').val(roomcount);
	}
	catch(err){
		console.log("Error - _addnewroom - "+err.message);
	}
}

function _removemoreroom(identifier,viewstyle,crsaccount,taxdetail,roomlist_grid,childagesetting)
{
	try
	{
		//_checksession('1',crsaccount);
		if(viewstyle == 0)
		{
			if(parseFloat(jQuery('.rcnt_'+identifier).html()) <= 1)
			{
				jQuery('#RoomType_RoomView_'+identifier).show();
				jQuery('#RateType_RoomView_'+identifier).hide();
			}
			
			var rmcnt = (parseFloat(jQuery('.rcnt_'+identifier).html()) - 1);
			
			jQuery('#addroom_'+identifier+'_'+parseFloat(jQuery('.rcnt_'+identifier).html())).remove();
			jQuery('.rcnt_'+identifier).html(rmcnt);
			
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#RoomTypeId_'+room_identity).val();
			jQuery('.avi-room_'+roomtypeid).html(Number(jQuery('.avi-room_'+roomtypeid).html()) + 1);
			jQuery('.maxbookRoom_'+roomtypeid).val(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) + 1);
			jQuery('.rate-aviroom_'+roomtypeid).html(Number(jQuery('.rate-aviroom_'+roomtypeid).html()) + 1);
			jQuery('.maxbookRate_'+roomtypeid).val(Number(jQuery('.maxbookRate_'+roomtypeid).val()) + 1);
			
			if(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
				
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
				
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
			}
		}
		else if(viewstyle == 1)
		{
			if(parseFloat(jQuery('.rmcnt_'+identifier).html()) <= 1)
			{
				jQuery('#RateType_RateView_'+identifier).show();
				jQuery('#RoomType_RateView_'+identifier).hide();
			}
			var rmcnt = (parseFloat(jQuery('.rmcnt_'+identifier).html()) - 1);
			
			jQuery('#addrate_'+identifier+'_'+parseFloat(jQuery('.rmcnt_'+identifier).html())).remove();
			jQuery('.rmcnt_'+identifier).html(parseFloat(jQuery('.rmcnt_'+identifier).html()) - 1);
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#Rate-RoomTypeId_'+identifier).val();
			jQuery('.avi-room_'+roomtypeid).html(Number(jQuery('.avi-room_'+roomtypeid).html()) + 1);
			jQuery('.maxbookRoom_'+roomtypeid).val(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) + 1);
			jQuery('.rate-aviroom_'+roomtypeid).html(Number(jQuery('.rate-aviroom_'+roomtypeid).html()) + 1);
			jQuery('.maxbookRate_'+roomtypeid).val(Number(jQuery('.maxbookRate_'+roomtypeid).val()) + 1);
			
			if(Number(jQuery('.maxbookRate_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
				
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
				
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
			}
		}
		_addroomincart(identifier,viewstyle,crsaccount,1,1,taxdetail,roomlist_grid,childagesetting);
	}
	catch(err){
		console.log("Error - _removemoreroom - "+err.message);
	}
}

function _addmoreroom(identifier,viewstyle,maxadult,maxchild,crsaccount,seladultchild,taxdetail,childagesetting,roomlist_grid,max_occupancy)
{
	try
	{
		if(jQuery("#searchbtnclicked").val()==1)
		{
			var message_title = js_stripslashes(langjs[0]["lblHangon"]);
			var message = js_stripslashes(langjs[0]["L_forgotsearch"]);
			var message_btn =js_stripslashes(langjs[0]["L_ClickSearch"]);

				swal({
					title: message_title,
					text: message,
					type: "warning",
					confirmButtonText: message_btn,
					showCancelButton: false,
					//cancelButtonText:"No",
					confirmButtonColor: "#DD6B55",
					animation:false				
					},
					function(){
						jQuery('#searchhotel').trigger('click');
					}
				);
			return false;
		}
		
		//Chinmay Gandhi - Max Occupancy module for Multi Hotel Booking Engine[ RES-2010 ] - Start
		if(RunOnMaximumOccupanySettings == 1)
		{
			maxadult = max_occupancy;
			maxchild = max_occupancy;
		}
		//Chinmay Gandhi - Max Occupancy module for Multi Hotel Booking Engine[ RES-2010 ] - End
		
		//_checksession('1',crsaccount);
		if(viewstyle == 0)
		{
			var rmcnt = (parseFloat(jQuery('.rcnt_'+identifier).html()) + 1);
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#RoomTypeId_'+room_identity).val();
			
			if(1 > Number(jQuery('.avi-room_'+roomtypeid).html()))
				return false;
			
			if(jQuery('.avi-room_'+roomtypeid).html() != jQuery('.maxbookRoom_'+roomtypeid).val())
			{
				_isHackattemt(crsaccount);
				return false;
			}
				
			jQuery('.avi-room_'+roomtypeid).html(jQuery('.avi-room_'+roomtypeid).html() - 1);
			jQuery('.maxbookRoom_'+roomtypeid).val(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) - 1);
			jQuery('.rate-aviroom_'+roomtypeid).html(jQuery('.rate-aviroom_'+roomtypeid).html() - 1);
			jQuery('.maxbookRate_'+roomtypeid).val(jQuery('.maxbookRate_'+roomtypeid).val() - 1);
			
			if(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() == 0)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.Hurry_'+roomtypeid).hide();
				jQuery('.No-room_'+roomtypeid).show();
				jQuery('.avi-room_'+roomtypeid).hide();
			}
			else if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
					
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() == 0)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.rate-hurry-'+roomtypeid).hide();
				jQuery('.rate-noroom_'+roomtypeid).show();
				jQuery('.rate-aviroom_'+roomtypeid).hide();
			}
			else if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
					
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
			}
			
			var addroom_contect = '';
			$.each(jQuery.parseJSON(atob(seladultchild)), function(Index,Item) {
				var sel_adult = Item.adult;
				var sel_child = Item.child;
	
				jQuery('.rcnt_'+identifier).html(rmcnt);
				
				addroom_contect += '<div class="be-addedRoomrow d-flex" id="addroom_'+identifier+'_'+rmcnt+'"><h5>'+langjs[0]["L_Room"]+'<span class="lblrm"> '+rmcnt+'</span></h5><div class="ac-count"><div class="cstm-select"><select class="be-input adult_'+rmcnt+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'");>';
				
				for(var adult=1; adult<=maxadult; adult++)
				{
					addroom_contect += '<option value="'+adult+'" '+((sel_adult == adult)?'selected="selected"':"")+'>'+adult+'</option>';
				}
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_Adult"]+'</label></div></div><div class="ac-count"><div class="cstm-select"><select class="be-input child_'+rmcnt+'" onchange=child_age_setting("'+seladultchild+'","'+childagesetting+'","'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'",1,"'+roomlist_grid+'");>';
				
				for(var child=0; child<=maxchild; child++)
					addroom_contect += '<option value="'+child+'" '+((sel_child == child)?'selected="selected"':"")+'>'+child+'</option>';
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+'</label></div><span class="age-info lbladdrm">('+langjs[0]["L_Age"]+' : '+langjs[0]["Roomlist_ChildAge"]+' '+langjs[0]["L_Years"]+')</span></div>'; //Prashant Patel - 20/05/2022 - Added dynamic language caption - [RES-3023]
				
				var child_setting = atob(childagesetting).split('<:>');
				
				if(child_setting[0] == '0')
					addroom_contect += '<div class="wrap-childage d-flex" id="room_childage_'+identifier+'_'+rmcnt+'"></div><div class="age-message">'+langjs[0]["L_childage"]+'</div>';
				
				addroom_contect += '</div>';
			});
			jQuery('#RateType_RoomView_'+identifier).append(addroom_contect);
		}
		else if(viewstyle == 1)
		{
			var rmcnt = (parseFloat(jQuery('.rmcnt_'+identifier).html()) + 1);
			var room_identity = identifier.split('_')[1];
			var roomtypeid = jQuery('#Rate-RoomTypeId_'+identifier).val();
			
			if(1 > Number(jQuery('.rate-aviroom_'+roomtypeid).html()))
				return false;
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() != jQuery('.maxbookRate_'+roomtypeid).val())
			{
				_isHackattemt(crsaccount);
				return false;
			}
				
			jQuery('.avi-room_'+roomtypeid).html(jQuery('.avi-room_'+roomtypeid).html() - 1);
			jQuery('.maxbookRoom_'+roomtypeid).val(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) - 1);
			jQuery('.rate-aviroom_'+roomtypeid).html(jQuery('.rate-aviroom_'+roomtypeid).html() - 1);
			jQuery('.maxbookRate_'+roomtypeid).val(jQuery('.maxbookRate_'+roomtypeid).val() - 1);
			
			if(Number(jQuery('.maxbookRate_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() == 0)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.Hurry_'+roomtypeid).hide();
				jQuery('.No-room_'+roomtypeid).show();
				jQuery('.avi-room_'+roomtypeid).hide();
			}
			else if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
					
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() == 0)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.rate-hurry-'+roomtypeid).hide();
				jQuery('.rate-noroom_'+roomtypeid).show();
				jQuery('.rate-aviroom_'+roomtypeid).hide();
			}
			else if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
					
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
			}
			
			var addroom_contect = '';
			$.each(jQuery.parseJSON(atob(seladultchild)), function(Index,Item) {
				var sel_adult = Item['adult'];
				var sel_child = Item['child'];
				jQuery('.rmcnt_'+identifier).html(rmcnt);
				
				addroom_contect += '<div class="be-addedRoomrow d-flex" id="addrate_'+identifier+'_'+rmcnt+'"><h5>'+langjs[0]["L_Room"]+' <span class="lblrm"> '+rmcnt+'</span></h5><div class="ac-count"><div class="cstm-select"><select class="be-input adult_'+rmcnt+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'");>';
				
				for(var adult=1; adult<=maxadult; adult++)
				{
					addroom_contect += '<option value="'+adult+'" '+((sel_adult == adult)?'selected="selected"':"")+'>'+adult+'</option>';
				}

				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_Adult"]+'</label></div></div><div class="ac-count"><div class="cstm-select"><select class="be-input child_'+rmcnt+'" onchange=child_age_setting("'+seladultchild+'","'+childagesetting+'","'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'",1,"'+roomlist_grid+'");>';
				
				for(var child=0; child<=maxchild; child++)
				{
					addroom_contect += '<option value="'+child+'" '+((sel_child == child)?'selected="selected"':"")+'>'+child+'</option>';
				}
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+'</label></div><span class="age-info lbladdrm">('+langjs[0]["L_Age"]+' : '+langjs[0]["Roomlist_ChildAge"]+' '+langjs[0]["L_Years"]+')</span></div>'; //Prashant Patel - 20/05/2022 - Added dynamic language caption - [RES-3023]
				
				var child_setting = atob(childagesetting).split('<:>');
				
				if(child_setting[0] == '0')
					addroom_contect += '<div class="wrap-childage d-flex" id="rate_childage_'+identifier+'_'+rmcnt+'"></div><div class="age-message">'+langjs[0]["L_childage"]+'</div>';
				
				addroom_contect += '</div>';
			});
			
			jQuery('#RoomType_RateView_'+identifier+' .appendcontent').append(addroom_contect);
		}
		child_age_setting(seladultchild,childagesetting,identifier,viewstyle,crsaccount,rmcnt,'0','','0',roomlist_grid);
		_addroomincart(identifier,viewstyle,crsaccount,1,1,taxdetail,roomlist_grid,childagesetting);
	}
	catch(err){
		console.log("Error - _addmoreroom - "+err.message);
	}
}

function child_age_setting(seladultchild,childagesetting,identifier,viewstyle,crsaccount,rmcnt,flag,taxdetail,iscartupdate,roomlist_grid)
{
	try
	{
		var child_setting = atob(childagesetting).split('<:>');
		var addroom_contect = '';
		
		if(viewstyle == '0')
			var tot_child = jQuery('#addroom_'+identifier+'_'+rmcnt+' .child_'+rmcnt).val();
		else if(viewstyle == '1')
			var tot_child = jQuery('#addrate_'+identifier+'_'+rmcnt+' .child_'+rmcnt).val();
			
		if(tot_child == null)
			tot_child = JSON.parse(atob(seladultchild))['room_1']['child']
			
		if(child_setting[0] == '0' && tot_child != '0')
		{
			addroom_contect += '<h5 class="label bold">Child Age</h5><div class="count-wrap">';
	
			for(var child=1; child<=tot_child; child++)
			{
				addroom_contect += '<div class="cnt-child"><div class="cstm-select"><select class="be-input roomwise-age childage_'+child+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'")><option value="">'+langjs[0]["L_Age"]+'</option><option value="0">0</option>';
				
				for(var childage=1; childage<=child_setting[3]; childage++)
				{
					addroom_contect += '<option value="'+childage+'">'+childage+'</option>';
				}
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+' '+child+'</label></div></div>';
			}
			addroom_contect += '</div>';
		}
		
		if(viewstyle == '0')
			jQuery('#room_childage_'+identifier+'_'+rmcnt).html(addroom_contect);
		else if(viewstyle == '1')
			jQuery('#rate_childage_'+identifier+'_'+rmcnt).html(addroom_contect);
		
		if(iscartupdate == '1')
			_addroomincart(identifier,viewstyle,crsaccount,rmcnt,0,taxdetail,roomlist_grid,childagesetting);
	}
	catch(err){
		console.log("Error - child_age_setting - "+err.message);
	}
}

function _addroomperload(identifier,viewstyle,maxadult,maxchild,crsaccount,AdultChileDetail,taxdetail,childagesetting,roomlist_grid,childageroomwise,max_occupancy)
{
	try
	{
		//Chinmay Gandhi - Max Occupancy module for Multi Hotel Booking Engine[ RES-2010 ] - Start
		if(RunOnMaximumOccupanySettings == 1)
		{
			maxadult = max_occupancy;
			maxchild = max_occupancy;
		}
		//Chinmay Gandhi - Max Occupancy module for Multi Hotel Booking Engine[ RES-2010 ] - End
		
		if(viewstyle == 0)
		{
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#RoomTypeId_'+room_identity).val();
			
			jQuery('.avi-room_'+roomtypeid).html(jQuery('.avi-room_'+roomtypeid).html() - Number(jQuery('.rcnt_'+identifier).html()));
			jQuery('.maxbookRoom_'+roomtypeid).val(jQuery('.maxbookRoom_'+roomtypeid).val() - Number(jQuery('.rcnt_'+identifier).html()));
			jQuery('.rate-aviroom_'+roomtypeid).html(jQuery('.rate-aviroom_'+roomtypeid).html() - Number(jQuery('.rcnt_'+identifier).html()));
			jQuery('.maxbookRate_'+roomtypeid).val(jQuery('.maxbookRate_'+roomtypeid).val() - Number(jQuery('.rcnt_'+identifier).html()));
			
			if(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() == 0)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.Hurry_'+roomtypeid).hide();
				jQuery('.No-room_'+roomtypeid).show();
				jQuery('.avi-room_'+roomtypeid).hide();
			}
			else if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
					
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() == 0)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.rate-hurry-'+roomtypeid).hide();
				jQuery('.rate-noroom_'+roomtypeid).show();
				jQuery('.rate-aviroom_'+roomtypeid).hide();
			}
			else if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
					
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
			}
			
			var rmcnt = (parseFloat(jQuery('.rcnt_'+identifier).html()));
			var addroom_contect = '';
			jQuery('.rcnt_'+identifier).html(rmcnt);
				
			for(var totrm = 1; totrm<=rmcnt; totrm++)
			{
				var occu = (AdultChileDetail[totrm - 1]).split('<:>');
				
				addroom_contect += '<div class="be-addedRoomrow d-flex" id="addroom_'+identifier+'_'+totrm+'"><h5>'+langjs[0]["L_Room"]+'<span class="lblrm"> '+totrm+'</span></h5><div class="ac-count"><div class="cstm-select"><select class="be-input adult_'+totrm+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+totrm+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'");>';
				
				for(var adult=1; adult<=maxadult; adult++)
				{
					addroom_contect += '<option value="'+adult+'" '+((occu[0] == adult)?'selected="selected"':"")+'>'+adult+'</option>';
				}
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_Adult"]+'</label></div></div><div class="ac-count"><div class="cstm-select"><select class="be-input child_'+totrm+'" onchange=child_age_setting("","'+childagesetting+'","'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+totrm+'",0,"'+taxdetail+'",1,"'+roomlist_grid+'");>';
				
				for(var child=0; child<=maxchild; child++)
				{
					addroom_contect += '<option value="'+child+'" '+((occu[1] == child)?'selected="selected"':"")+'>'+child+'</option>';
				}

				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+'</label></div><span class="age-info lbladdrm">('+langjs[0]["L_Age"]+' : '+langjs[0]["Roomlist_ChildAge"]+' '+langjs[0]["L_Years"]+')</span></div>'; //Prashant Patel - 20/05/2022 - Added dynamic language caption - [RES-3023]
				
				var child_setting = atob(childagesetting).split('<:>');
				
				if(child_setting[0] == '0')
				{
					addroom_contect += '<div class="wrap-childage d-flex" id="room_childage_'+identifier+'_'+totrm+'">';
					if(child_setting[0] == '0' && occu[1] != '0')
					{
						addroom_contect += '<h5 class="label bold">Child Age</h5><div class="count-wrap">';
						for(var child=1; child<=occu[1]; child++)
						{
							addroom_contect += '<div class="cnt-child"><div class="cstm-select"><select class="be-input roomwise-age childage_'+child+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'")><option value="">'+langjs[0]["L_Age"]+'</option><option value="0"'+((childageroomwise[totrm-1][child-1] == '0')?'selected="selected"':"")+'>0</option>';
							
							for(var childage=1; childage<=child_setting[3]; childage++)
							{
								addroom_contect += '<option value="'+childage+'" '+((childageroomwise[totrm-1][child-1] == childage)?'selected="selected"':"")+' >'+childage+'</option>';
							}
							
							addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+' '+child+'</label></div></div>';
						}
						addroom_contect += '</div>';
					}
					addroom_contect += '</div><div class="age-message">'+langjs[0]["L_childage"]+'</div>';
				}
				addroom_contect += '</div>';
			}
			jQuery('#RateType_RoomView_'+identifier).append(addroom_contect);
		}
		else if(viewstyle == 1)
		{
			var room_identity = identifier.split('_')[0];
			var roomtypeid = jQuery('#Rate-RoomTypeId_'+identifier).val();
			jQuery('.avi-room_'+roomtypeid).html(jQuery('.avi-room_'+roomtypeid).html() - Number(jQuery('.rmcnt_'+identifier).html()));
			jQuery('.maxbookRoom_'+roomtypeid).val(jQuery('.maxbookRoom_'+roomtypeid).val() - Number(jQuery('.rmcnt_'+identifier).html()));
			jQuery('.rate-aviroom_'+roomtypeid).html(jQuery('.rate-aviroom_'+roomtypeid).html() - Number(jQuery('.rmcnt_'+identifier).html()));
			jQuery('.maxbookRate_'+roomtypeid).val(jQuery('.maxbookRate_'+roomtypeid).val() - Number(jQuery('.rmcnt_'+identifier).html()));
			
			if(Number(jQuery('.maxbookRate_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() == 0)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.Hurry_'+roomtypeid).hide();
				jQuery('.No-room_'+roomtypeid).show();
				jQuery('.avi-room_'+roomtypeid).hide();
			}
			else if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
					
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() == 0)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').addClass('min-avi-room-hurry');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').removeClass('min-avi-room');
				jQuery('.rate-hurry-'+roomtypeid).hide();
				jQuery('.rate-noroom_'+roomtypeid).show();
				jQuery('.rate-aviroom_'+roomtypeid).hide();
			}
			else if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
					
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
			}
			
			var rmcnt = parseFloat(jQuery('.rmcnt_'+identifier).html());
			var addroom_contect = '';
			jQuery('.rmcnt_'+identifier).html(rmcnt);
			
			for(var totrm = 1; totrm<=rmcnt; totrm++)
			{
				var occu = (AdultChileDetail[totrm - 1]).split('<:>');
				
				addroom_contect += '<div class="be-addedRoomrow d-flex" id="addrate_'+identifier+'_'+totrm+'"><h5>'+langjs[0]["L_Room"]+' <span class="lblrm"> '+totrm+'</span></h5><div class="ac-count"><div class="cstm-select"><select class="be-input adult_'+totrm+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+totrm+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'");>';
				
				for(var adult=1; adult<=maxadult; adult++)
				{
					addroom_contect += '<option value="'+adult+'" '+((occu[0] == adult)?'selected="selected"':"")+'>'+adult+'</option>';
				}
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_Adult"]+'</label></div></div><div class="ac-count"><div class="cstm-select"><select class="be-input child_'+totrm+'" onchange=child_age_setting("","'+childagesetting+'","'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+totrm+'",0,"'+taxdetail+'",1,"'+roomlist_grid+'");>';
				
				for(var child=0; child<=maxchild; child++)
				{
					addroom_contect += '<option value="'+child+'" '+((occu[1] == child)?'selected="selected"':"")+'>'+child+'</option>';
				}
				
				addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+'</label></div><span class="age-info lbladdrm">('+langjs[0]["L_Age"]+' : '+langjs[0]["Roomlist_ChildAge"]+' '+langjs[0]["L_Years"]+')</span></div>'; //Prashant Patel - 20/05/2022 - Added dynamic language caption - [RES-3023]
				
				var child_setting = atob(childagesetting).split('<:>');
				
				if(child_setting[0] == '0')
				{
					addroom_contect += '<div class="wrap-childage d-flex" id="rate_childage_'+identifier+'_'+totrm+'">';
					if(child_setting[0] == '0' && occu[1] != '0')
					{
						addroom_contect += '<h5 class="label bold">Child Age</h5><div class="count-wrap">';
						for(var child=1; child<=occu[1]; child++)
						{
							addroom_contect += '<div class="cnt-child"><div class="cstm-select"><select class="be-input roomwise-age childage_'+child+'" onchange=_addroomincart("'+identifier+'","'+viewstyle+'","'+crsaccount+'","'+rmcnt+'",0,"'+taxdetail+'","'+roomlist_grid+'","'+childagesetting+'")><option value="">'+langjs[0]["L_Age"]+'</option><option value="0" '+((childageroomwise[totrm-1][child-1] == '0')?'selected="selected"':"")+'>0</option>';
							
							for(var childage=1; childage<=child_setting[3]; childage++)
							{
								addroom_contect += '<option value="'+childage+'" '+((childageroomwise[totrm-1][child-1] == childage)?'selected="selected"':"")+'>'+childage+'</option>';
							}
							
							addroom_contect += '</select><label class="be-inputLabel">'+langjs[0]["L_sel_child"]+' '+child+'</label></div></div>';
						}
						addroom_contect += '</div>';
					}
					addroom_contect += '</div><div class="age-message">'+langjs[0]["L_childage"]+'</div>';
				}
				
				addroom_contect += '</div>';
			}
			jQuery('#RoomType_RateView_'+identifier+' .appendcontent').append(addroom_contect);
		}
	}
	catch(err){
		console.log("Error - _addroomperload - "+err.message);
	}
}

function _checksession(page,crsaccount)
{
	try{
		var HotelId = jQuery('#hotel_code').val();
		var serverurl = jQuery('#loadingurl').val();
		var groupcode = jQuery('#groupcode').val();
		
		if(crsaccount == 1)
		{
			getUrl=serverurl+'multiproperty_service.php?GroupCode='+groupcode;
			perm = 'action=chksession&GroupCode='+groupcode+'&selectedLang=en&crsaccount='+crsaccount;
		}
		else
		{
			getUrl=serverurl+'multiproperty_service.php?HotelId='+HotelId;
			perm = 'action=chksession&HotelId='+HotelId+'&selectedLang=en&crsaccount='+crsaccount;
		}
	
		var message_title = js_stripslashes(langjs[0]["lblHangon"]);
		var message =js_stripslashes(langjs[0]["lblSessionExpired"]);
		var message_btn =js_stripslashes(langjs[0]["L_Pleaserefreshpage"]);
		
		$.ajax({
			url: getUrl,
			type: "POST",
			dataType: "html",
			data: perm,
			error: function(e){
				console.log( "AJAX - error() _init "+ e);
			},
			success: function( data ){
				if(jQuery.trim(data) != 1) {
					swal({
						title: message_title,
						text: message,
						type: "warning",
						confirmButtonText: message_btn,
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						animation:false
						},
						function(){
							var selectedLang = jQuery('#selectedLang').val();
							if(crsaccount == 0)
							{
								window.location.href=serverurl+'roomlist-'+HotelId+selectedLang;
							}
							else if(crsaccount == 1)
							{
								if(page == 1)
									window.location.href=serverurl+'roomlisting-'+groupcode+'-'+HotelId+selectedLang;
								else
									window.location.href=serverurl+'chain-'+groupcode+selectedLang;
							}
						}
					);
					return false;
				}
				else
				{
					return true;
				}
			}
		});
	}
	catch(err){
		console.log("Error - _checksession - "+err.message);
	}
}

function _addroomincart(identifier,viewstyle,crsaccount,roomId,flag,taxdetail,resgrid_roomdetail,childagesetting)
{
	try
	{
		storevar('');
		var resgrid_roomdetail=resgrid;
		if(resgrid_roomdetail!='')
			resgrid_roomdetail=resgrid_roomdetail;
		
		var taxdetail=atob(tax_detail_datewise);
		if(typeof roomId === "undefined" || roomId === null) {
			roomId = 1; 
		}
		
		if(typeof flag === "undefined" || flag === null) {
			flag = 0; 
		}
		
		var serverurl = jQuery('#loadingurl').val();
		var hotelId = jQuery("#foldername").val();
		var hotelcode = jQuery('#hotel_code').val();
		var groupcode = jQuery('#groupcode').val();
		var slabbeforediscount = jQuery("#slabbeforediscount").val();
		var _totalBookingAmount=0;
		var _totalBookingAmountbase_roomwise = [];
		var _totalBookingAmountbasebd_roomwise = [];
		var _totalamount_roomwise = [];
		var _totaltax_roomwise = [];
		var _taxbd_roomwise = [];
		var _totaltax_roomwise_decimal = [];
		var _taxbd_roomwise_decimal = [];
		var tax=0;
		var tax_decimal=0;
		var totalBookingAmountbase=0.00;
		var totalBookingAmountbasebd=0.00;
		var ratemode=RateMode;//jQuery("#ratemode").val();
		if(viewstyle == 0)
		{
			//var roomrate_daywise = jQuery('#room_daywise_'+identifier).val();
			var id_start="#RateType_RoomView_";
			var id_start2="_Roomwise_";
			var totroom = jQuery(id_start+identifier+' .rcnt_'+identifier).html();
		}
		else
		{
			//var roomrate_daywise = jQuery('#rate_daywise_'+identifier).val();
			var id_start="#RoomType_RateView_";
			var id_start2="_Ratewise_";
			var totroom = jQuery(id_start+identifier+' .rmcnt_'+identifier).html();
		}
		
		var roomtype = jQuery('#RoomTypeName'+id_start2+identifier).val();
		var roomrate = jQuery('#RateTypeName'+id_start2+identifier).val();
		
		var RateTypeId = jQuery('#RoomRateUnkId'+id_start2+identifier).val();
		var PkgRate = jQuery('#PackageRate'+id_start2+identifier).val();
		
		var basedata = (jQuery('#Base'+id_start2+identifier).val()).split('-');
		var extra_price = [];//(jQuery('#exPrice'+id_start2+identifier).val()).split('-');
		//extra_price[0]=0;
		//extra_price[1]=0;
		var extax = (jQuery('#extax'+id_start2+identifier).val()).split('-');
		var seladult = selchild = exadultchild = 0
		var adultchildroomwise = [];var tax = 0;
		var night = Date_Range.length-1;//roomrate_daywise.split('-').length;
		var roomwisebaserate=[];
		var taxbd = 0;
		var taxbd_decimal = 0;
		var required_flag = 0;
		var promo_result = jQuery('#promoflag').val();
		child_age=[];
		//Priyanka Maurya - 08 March 2021 - Purpose : For Extra Charge Flat Percentage Calculation - RES-2736 - START
		var daywiseroomcharge = [];
		var daywiseroomtax = [];
		//Priyanka Maurya - END
		for(var guest=1; guest<=totroom; guest++)
		{
			child_age[guest-1]=[];
			extra_price[guest-1]=[];
			extra_price[guest-1][0]=0;
			extra_price[guest-1][1]=0;
			
			//Priyanka Maurya - 08 March 2021 - Purpose : For Extra Charge Flat Percentage Calculation - RES-2736 - START
			daywiseroomcharge[guest-1] = [];
			daywiseroomtax[guest-1] = [];
			//Priyanka Maurya - END

			var inc_aduprice = inc_chilprice = 0;
			
			seladult+= parseFloat(jQuery(id_start+identifier+' .adult_'+guest+' option:selected').text());
			selchild+= parseFloat(jQuery(id_start+identifier+' .child_'+guest+' option:selected').text());
			
			adultchildroomwise.push(parseFloat(jQuery(id_start+identifier+' .adult_'+guest+' option:selected').text())+"<:>"+parseFloat(jQuery(id_start+identifier+' .child_'+guest+' option:selected').text()));
			
			var adultcnt = parseFloat(jQuery(id_start+identifier+' .adult_'+guest+' option:selected').text());
			var childcnt = parseFloat(jQuery(id_start+identifier+' .child_'+guest+' option:selected').text());
			
			//Chinmay Gandhi - Child Age - End
			var child_setting = atob(childagesetting).split('<:>');
			if(child_setting[0] == '0')
			{
				var show_msg = 0;
				for(var childnum=1; childnum<=childcnt; childnum++)
				{
					if(viewstyle == 0)
					{
						if(jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).val() == '')
						{
							jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).addClass('error');
							jQuery('#addroom_'+identifier+'_'+guest+' .age-message').show();
							show_msg++;required_flag++;
						}
						else
						{
							jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).removeClass('error');
							child_age[guest-1].push(jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).val());
						}
					}
					else
					{
						if(jQuery('#rate_childage_'+identifier+'_'+guest+' .childage_'+childnum).val() == '')
						{
							jQuery('#rate_childage_'+identifier+'_'+guest+' .childage_'+childnum).addClass('error');
							jQuery('#addrate_'+identifier+'_'+guest+' .age-message').show();
							show_msg++;required_flag++;
						}
						else
						{
							jQuery('#rate_childage_'+identifier+'_'+guest+' .childage_'+childnum).removeClass('error');
							child_age[guest-1].push(jQuery('#rate_childage_'+identifier+'_'+guest+' .childage_'+childnum).val());
						}
					}
				}
				
				if(show_msg == 0)
				{
					if(viewstyle == 0)
						jQuery('#addroom_'+identifier+'_'+guest+' .age-message').hide();
					else
						jQuery('#addrate_'+identifier+'_'+guest+' .age-message').hide();
				}
			}
			//Chinmay Gandhi - Child Age - End
			
			var roomrateunkid=roomrate.split("<:>")[1];
			var roomtypeunkid=roomtype.split("<:>")[1];
			
			var promorule='';
			if(viewstyle == 0)
			{
				roomtypeunkid=roomtypeunkid.replace("room_","");
				var rateplan_details=resgrid_roomdetail.RoomTypeWise[roomtypeunkid][roomrateunkid];
				
				promoresult = resgrid_roomdetail.promotion_rule_room;
			}
			else
			{
				roomtypeunkid=roomtypeunkid.replace("rate_","");
				var rateplan_details=resgrid_roomdetail.RateTypeWise[roomtypeunkid][roomrateunkid];
				
				promoresult = resgrid_roomdetail.promotion_rule_rate;
			}
			
			//Chinmay Gandhi - Max Occupancy module for Multi Hotel Booking Engine[ RES-2010 ] - Start
			if(RunOnMaximumOccupanySettings == 1)
			{
				var totguest = parseInt(adultcnt) + parseInt(childcnt);
				if(totguest > parseInt(rateplan_details.Max_Occupancy) || parseInt(adultcnt) > parseInt(rateplan_details.Max_Adult) || parseInt(childcnt) > parseInt(rateplan_details.Max_Child))
				{
					if(totguest > parseInt(rateplan_details.Max_Occupancy))
						var msg_text = js_stripslashes(langjs[0]["L_Max_Occu_Alert"])+' '+parseInt(rateplan_details.Max_Occupancy)+' '+js_stripslashes(langjs[0]["L_Guest"])+'.';
					else if(parseInt(adultcnt) > parseInt(rateplan_details.Max_Adult))
						var msg_text = js_stripslashes(langjs[0]["L_max_occu_msg"])+' '+parseInt(rateplan_details.Max_Adult)+' '+js_stripslashes(langjs[0]["L_Adult"])+'.';
					else if(parseInt(childcnt) > parseInt(rateplan_details.Max_Child))
						var msg_text = js_stripslashes(langjs[0]["L_max_occu_msg"])+' '+parseInt(rateplan_details.Max_Child)+' '+js_stripslashes(langjs[0]["L_Child"])+'.';
					
					swal({
						title: js_stripslashes(langjs[0]["L_Promo_Msg6"]),
						text: msg_text,
						type: "warning",
						confirmButtonText: js_stripslashes(langjs[0]["L_Swal_Ok"]),
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						animation:false
					},
					function(){
						if(ResUIPaxOnMaximumOccupancy == 0)
						{
							jQuery(id_start+identifier+' .adult_'+guest).val(basedata[0]).trigger('change');
							jQuery(id_start+identifier+' .child_'+guest).val(basedata[1]).trigger('change');
						}
						else
						{
							jQuery(id_start+identifier+' .adult_'+guest).val(parseInt(rateplan_details.Max_Adult)).trigger('change');
							jQuery(id_start+identifier+' .child_'+guest).val(parseInt(rateplan_details.Max_Occupancy) - parseInt(rateplan_details.Max_Adult)).trigger('change');
						}
					});
					return false;
				}
			}
			//Chinmay Gandhi - Max Occupancy module for Multi Hotel Booking Engine[ RES-2010 ] - End
			
			if(promo_result == 1)
			{
				if(promoresult!={} && promoresult!==undefined && promoresult!='' && promoresult[roomtypeunkid] !== undefined && promoresult[roomtypeunkid][roomrateunkid] !== undefined)//Chinmay
					promorule=promoresult[roomtypeunkid][roomrateunkid];
					
				var IsPromotion = rateplan_details.IsPromotion;
			}
			else
			{
				var IsPromotion = false;
			}
			
			var extra_adult = extra_child = 0;
			if(ratemode=='NONLINEAR')
			{
				if(adultcnt > 7)
					extra_adult = parseInt(adultcnt) - 7;
				
				//Chinmay - Child age calculation - Start
				if(child_setting[0] == 0)
				{
					var childagelimit=child_setting[2];
					for(var childnum=1; childnum<=childcnt; childnum++)
					{
						var childage=jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).val();
						if(parseInt(childage) > parseInt(childagelimit) && childage!='')
							extra_child++;
					}
				}
				else
				{
					extra_child = parseInt(childcnt);//Chinmay Gandhi - Rate Issue when child age is anable for nonlinear mode [ RES-2469 ]
				}
				//Chinmay - Child age calculation - End
			}
			else
			{
				if(adultcnt > rateplan_details.Base_Adult)
					extra_adult = parseInt(adultcnt) - parseInt(rateplan_details.Base_Adult);
						
				//Chinmay - Child age calculation - Start
				if(child_setting[0] == 0 && child_setting[1] == 1)
				{
					if(parseInt(childcnt) > parseInt(rateplan_details.Base_Child))
					{
						var childagelimit=child_setting[2];
						chkchild_cnt=1;
						for(var childnum=1; childnum<=childcnt; childnum++)
						{
							var childage=jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).val();
							if(parseInt(childage) > parseInt(childagelimit) && childage!='' && parseInt(chkchild_cnt)>parseInt(rateplan_details.Base_Child))
								extra_child++;
							chkchild_cnt++;    
						}
					}
				}
				else if(child_setting[0] == 0)
				{
					var childagelimit=child_setting[2];
					for(var childnum=1; childnum<=childcnt; childnum++)
					{			
						var childage=jQuery('#room_childage_'+identifier+'_'+guest+' .childage_'+childnum).val();
						if(parseInt(childage) > parseInt(childagelimit) && childage!='')
							extra_child++;
					}
				}
				else
				{
					if(childcnt > rateplan_details.Base_Child)
						extra_child = parseInt(childcnt) - parseInt(rateplan_details.Base_Child);
				}
				//Chinmay - Child age calculation - End
			}
			
			var extra_child_rate=0;
			var extra_adult_rate=0;
			
			var extra_child_rate_gst=0; //Pinal - 15 May 2019 - Purpose : RES-1825
			var extra_adult_rate_gst=0; //Pinal - 15 May 2019 - Purpose : RES-1825
			
			var d=0;
			var totalBookingAmountroombase=0;
			var totalroundoff=0;
			var d_beforediscount=0;
			var d_gst_beforediscount=0;
			var total_tax_decimalplaces=0; //Falguni Rana - Round Off
			var total_tax_bd_decimalplaces=0; //Falguni Rana - Round Off
			var multiplereturn = (_decimal!=_bookingrate_decimal) ? '1' : '0'; //Falguni Rana - Round Off
			if(taxdetail!=null && taxdetail!="null" && taxdetail!="0" && taxdetail!=0)
			{
				var tax_detail=JSON.parse(taxdetail);
			}
			
			var rm_totBookAmount = 0;var rm_totBookAmountbasebd = 0;var rm_totalamount = 0;var rm_totaltax = 0;var rm_taxbd = 0;
			var rm_totaltax_decimal = 0, rm_taxbd_decimal = 0;
			for(var n=0;n<night;n++)
			{
				if(ratemode=='NONLINEAR')
				{
					if(adultcnt > 7)
					{
						d = parseFloat(rateplan_details.Non_Linear_Rates[n+1].adult7);
						d_beforediscount = parseFloat(rateplan_details.Non_Linear_Rates_Beforediscount[n+1].adult7);
						d_gst_beforediscount = parseFloat(rateplan_details.Non_Linear_Rates_BeforediscountGST[n+1].adult7);
						extra_adult_rate =  extra_adult * parseFloat(rateplan_details.Extra_Adult_Rates[Date_Range[n]]);
						
						//Pinal - 15 May 2019 - START
						//Purpose : RES-1825
						if(rateplan_details.Extra_Adult_Rates_GST!==undefined && rateplan_details.Extra_Adult_Rates_GST[Date_Range[n]]!==undefined)
						{
							extra_adult_rate_gst =  extra_adult * parseFloat(rateplan_details.Extra_Adult_Rates_GST[Date_Range[n]]);
						}
						else
						{
							extra_adult_rate_gst =  extra_adult_rate;
						}
					}
					else
					{
						d = parseFloat(rateplan_details.Non_Linear_Rates[n+1]['adult'+adultcnt]);
						d_beforediscount = parseFloat(rateplan_details.Non_Linear_Rates_Beforediscount[n+1]['adult'+adultcnt]);
						d_gst_beforediscount = parseFloat(rateplan_details.Non_Linear_Rates_BeforediscountGST[n+1]['adult'+adultcnt]);
					}
					if(extra_child>0)//Chinmay Gandhi - Rate Issue when child age is anable for nonlinear mode [ RES-2469 ]
					{
						if(extra_child > 7)//Chinmay Gandhi - Rate Issue when child age is anable for nonlinear mode [ RES-2469 ]
						{
							d += parseFloat(rateplan_details.Non_Linear_Rates[n+1].child7);
							extra_child_rate =  (extra_child-7) * parseFloat(rateplan_details.Extra_Child_Rates[Date_Range[n]]);//Chinmay Gandhi - Rate Issue when child age is anable for nonlinear mode [ RES-2469 ]
							
							if(rateplan_details.Extra_Child_Rates_GST!==undefined && rateplan_details.Extra_Child_Rates_GST[Date_Range[n]]!==undefined)
								extra_child_rate_gst =  (extra_child-7) * parseFloat(rateplan_details.Extra_Child_Rates_GST[Date_Range[n]]);
							else
								extra_child_rate_gst =  extra_child_rate;
						
							d_beforediscount += parseFloat(rateplan_details.Non_Linear_Rates_Beforediscount[n+1].child7);
							d_gst_beforediscount += parseFloat(rateplan_details.Non_Linear_Rates_BeforediscountGST[n+1].child7);
						}
						else
						{
							//Chinmay Gandhi - 7th May 2019 - Start
							//Purpose : Non Linear for Package deal for Hotel listing [ RES-1943 ]
							var rate_childcnt = 0;
							
							if(child_setting[0] == 0)
								rate_childcnt = extra_child;
							else
								rate_childcnt = childcnt;
							
							if(rate_childcnt > 0){
								d += parseFloat(rateplan_details.Non_Linear_Rates[n+1]['child'+rate_childcnt]);
								d_beforediscount += parseFloat(rateplan_details.Non_Linear_Rates_Beforediscount[n+1]['child'+rate_childcnt]);
								d_gst_beforediscount += parseFloat(rateplan_details.Non_Linear_Rates_BeforediscountGST[n+1]['child'+rate_childcnt]);
							}
							//Chinmay Gandhi - 7th May 2019 - End
						}
					}
					
					d_beforediscount=parseFloat(d_beforediscount)+parseFloat(extra_child_rate)+parseFloat(extra_adult_rate);
					d_gst_beforediscount=parseFloat(d_gst_beforediscount)+parseFloat(extra_child_rate_gst)+parseFloat(extra_adult_rate_gst);
					
					//If promotion is applied than apply promotion rule and than calculate - START
					if(promorule!='' && promorule!=undefined)
					{
						var promos=promorule.nightrule.split(":");
						var drate=parseFloat(promos[3]);
						
						if(d>0 && promorule.raterule['night_'+n]=='N')
						{
							switch(promos[1]){
								case "AE":
									ae=parseInt(promos[2])+1;
									if((n+1) % ae ==0){
										if(promos[4]=="AMT"){
											d=d-drate;
										}
										else if(promos[4]=="PER"){
											d=(d*(100-drate))/(100);
										}
									}
								break;                            
							}
						}
					}
					//If promotion is applied than apply promotion rule and than calculate - END
				}
				else
				{
					//console.log(rateplan_details.Extra_Adult_Rates);
					//console.log(rateplan_details.Extra_Child_Rates);
					extra_adult_rate =  extra_adult * parseFloat(rateplan_details.Extra_Adult_Rates[Date_Range[n]]);
					extra_child_rate =  extra_child * parseFloat(rateplan_details.Extra_Child_Rates[Date_Range[n]]);
					
					if(rateplan_details.Extra_Adult_Rates_GST!==undefined && rateplan_details.Extra_Adult_Rates_GST[Date_Range[n]]!==undefined)
					{
						extra_adult_rate_gst =  extra_adult * parseFloat(rateplan_details.Extra_Adult_Rates_GST[Date_Range[n]]);
					}
					else
					{
						extra_adult_rate_gst =  extra_adult_rate;
					}
					
					if(rateplan_details.Extra_Child_Rates_GST!==undefined && rateplan_details.Extra_Child_Rates_GST[Date_Range[n]]!==undefined)
					{
						extra_child_rate_gst =  extra_child * parseFloat(rateplan_details.Extra_Child_Rates_GST[Date_Range[n]]);
					}
					else
					{
						extra_child_rate_gst =  extra_child_rate;
					}
					
					d=parseFloat(rateplan_details['Base_Rates'][Date_Range[n]]);
					d_beforediscount=parseFloat(rateplan_details['before_discount_rate_bd'][n])+parseFloat(extra_child_rate)+parseFloat(extra_adult_rate);//Apply Promotion [ Set Rate Before Discount ]
					d_gst_beforediscount=parseFloat(rateplan_details['day_wise_beforediscount'][n])+parseFloat(extra_child_rate_gst)+parseFloat(extra_adult_rate_gst);
				}
				//Pinal - 15 May 2019 - END

				totalBookingAmountroombase+=parseFloat(d);
				d=parseFloat(d)+parseFloat(extra_child_rate)+parseFloat(extra_adult_rate);
				
				extra_price[guest-1][0]+=parseFloat(extra_adult_rate);
				extra_price[guest-1][1]+=parseFloat(extra_child_rate);
				totalBookingAmountbase+=parseFloat(d);
				rm_totBookAmount+=parseFloat(d);
				totalBookingAmountbasebd+=parseFloat(d_beforediscount);
				rm_totBookAmountbasebd+=parseFloat(d_beforediscount);
				//totalBookingAmountbase+=parseFloat(d.toFixed(4));
				//totalBookingAmountbase=parseFloat(totalBookingAmountbase.toFixed(4));
				daywiseroomcharge[guest-1][n] = parseFloat(d); //Priyanka Maurya - 08 March 2021 - Purpose : For Extra Charge Flat Percentage Calculation - RES-2736

				var rackratetax_extra_adult=0;
				var rackratetax_extra_child=0;
				if(adultcnt > rateplan_details.Base_Adult)
					rackratetax_extra_adult=(parseInt(adultcnt)- parseInt(rateplan_details.Base_Adult));
					
				if(childcnt > rateplan_details.Base_Child)
					rackratetax_extra_child=(parseInt(childcnt)- parseInt(rateplan_details.Base_Child));
				
				//console.log(rateplan_details.Rack_Rate);
				if(taxdetail!=null && taxdetail!="null" && taxdetail!="0" && taxdetail!=0)
				{
					var tax_formula=tax_detail[n];
					
					if(FindSlabForGSTIndia==1)
					{
						var total_tax=getTax2(d_gst_beforediscount,tax_formula,_bookingrate_decimal,0,rateplan_details.Rack_Rate[n].RackRate,rateplan_details.Rack_Rate[n].EARate,rateplan_details.Rack_Rate[n].ECRate,adultcnt,childcnt,'base',rackratetax_extra_adult,rackratetax_extra_child,multiplereturn,_decimal);
						
						//Chinmay - Apply Promotion - Start
						if(promo_result == '1')
							var total_tax_bd = total_tax;
						//Chinmay - Apply Promotion - End
					}
					else
					{
						var total_tax=getTax2(d,tax_formula,_bookingrate_decimal,0,rateplan_details.Rack_Rate[n].RackRate,rateplan_details.Rack_Rate[n].EARate,rateplan_details.Rack_Rate[n].ECRate,adultcnt,childcnt,'base',rackratetax_extra_adult,rackratetax_extra_child,multiplereturn,_decimal);
						
						//Chinmay - Apply Promotion - Start
						if(promo_result == '1')
							var total_tax_bd=getTax2(d_beforediscount,tax_formula,_bookingrate_decimal,0,rateplan_details.Rack_Rate[n].RackRate,rateplan_details.Rack_Rate[n].EARate,rateplan_details.Rack_Rate[n].ECRate,adultcnt,childcnt,'base',rackratetax_extra_adult,rackratetax_extra_child,multiplereturn,_decimal);
						//Chinmay - Apply Promotion - End
					}
					if(parseInt(multiplereturn) && total_tax!=0) {
						var taxarr = total_tax.split('<>');
						total_tax_decimalplaces = taxarr[0];
						if(taxarr.length==2) total_tax = taxarr[1];
						else total_tax = taxarr[0];
						
						if(promo_result == '1') {
							var taxarr = total_tax_bd.split('<>');
							total_tax_bd_decimalplaces = taxarr[0];
							if(taxarr.length==2) total_tax_bd = taxarr[1];
							else total_tax_bd = taxarr[0];
						}
					} else {
						total_tax_decimalplaces = total_tax;
						if(promo_result == '1') {
							total_tax_bd_decimalplaces = total_tax_bd;
						}
					}
					
					tax+=parseFloat(total_tax);
					rm_totaltax+=parseFloat(total_tax);
					tax_decimal+=parseFloat(total_tax_decimalplaces);
					rm_totaltax_decimal+=parseFloat(total_tax_decimalplaces);
					daywiseroomtax[guest-1][n] = parseFloat(total_tax); //Priyanka Maurya - 08 March 2021 - Purpose : For Extra Charge Flat Percentage Calculation - RES-2736

					//Chinmay - Apply Promotion - Start
					if(promo_result == '1')
					{
						taxbd+=parseFloat(total_tax_bd);
						rm_taxbd+=parseFloat(total_tax_bd);
						taxbd_decimal+=parseFloat(total_tax_bd_decimalplaces);
						rm_taxbd_decimal+=parseFloat(total_tax_bd_decimalplaces);
					}
					else
					{
						taxbd+=parseFloat(total_tax);
						rm_taxbd+=parseFloat(total_tax);
						taxbd_decimal+=parseFloat(total_tax_decimalplaces);
						rm_taxbd_decimal+=parseFloat(total_tax_decimalplaces);
					}
					//Chinmay - Apply Promotion - End
					
					d=(parseFloat(d)+parseFloat(total_tax));//Chinmay Gandhi - Set discount amount properly.[ MPBE_REQUIRECHANGES ]
					
					//if(promorule!='' && promorule!=undefined)
					//{
					//	if(FindSlabForGSTIndia==1)
					//		var total_tax=getTax2(d_gst_beforediscount,tax_formula,_decimal,0,rateplan_details.Rack_Rate[n].RackRate,rateplan_details.Rack_Rate[n].EARate,rateplan_details.Rack_Rate[n].ECRate,adultcnt,childcnt,'base',rackratetax_extra_adult,rackratetax_extra_child);
					//	else
					//		var total_tax=getTax2(d_beforediscount,tax_formula,_decimal,0,rateplan_details.Rack_Rate[n].RackRate,rateplan_details.Rack_Rate[n].EARate,rateplan_details.Rack_Rate[n].ECRate,adultcnt,childcnt,'base',rackratetax_extra_adult,rackratetax_extra_child);
					//	
					//	taxbd+=parseFloat(total_tax);
					//	rm_taxbd+=parseFloat(total_tax);
					//	//d_beforediscount=getroundval((parseFloat(d_beforediscount)+parseFloat(total_tax)),jQuery("#RoundOffType").val());
					//	//console.log("before dicpoint with tax : "+d_beforediscount);
					//}
				}
				 
				if(d<0) d=0;                                       
				
				_totalBookingAmount+=getroundval(d,jQuery("#RoundOffType").val());
				
				rm_totalamount+=d;//Chinmay Gandhi - Set discount amount properly.[ MPBE_REQUIRECHANGES ]
				//if(promorule!='' && promorule!=undefined)
				//{
				//	console.log("promorule122222------------------------------");
				//	_totalBookingAmountbeforediscount+=getroundval(d_beforediscount,jQuery("#RoundOffType").val());
				//}
			}
			
			_totalBookingAmountbase_roomwise.push(rm_totBookAmount); 
			_totalBookingAmountbasebd_roomwise.push(rm_totBookAmountbasebd);
			_totalamount_roomwise.push(rm_totalamount);
			_totaltax_roomwise.push(rm_totaltax);
			_taxbd_roomwise.push(rm_taxbd);
			_totaltax_roomwise_decimal.push(rm_totaltax_decimal);
			_taxbd_roomwise_decimal.push(rm_taxbd_decimal);
			
			roomwisebaserate.push(totalBookingAmountroombase);
			//exadultchild += parseFloat(inc_aduprice) + parseFloat(inc_chilprice);
		}
		
		if(required_flag != 0)
			return false;
		
		//if(!(promorule!='' && promorule!=undefined))
		//{
		//	totalBookingAmountbasebd=totalBookingAmountbase;
		//	_totalBookingAmountbasebd_roomwise = _totalBookingAmountbase_roomwise;
		//	taxbd=tax;
		//	_taxbd_roomwise = _totaltax_roomwise;
		//}

		var Special_Condition = jQuery('#Special_Condition'+id_start2+identifier).val(); //Chandrakant - 11 June 2021, Purpose - RES-2803
		var Highlighted_Text = jQuery('#Highlighted_Text'+id_start2+identifier).val(); //Chandrakant - 11 June 2021, Purpose - RES-2803
		
		if(crsaccount == 1)
		{
			var param='GroupCode='+groupcode+'&HotelId='+hotelcode+'&action=cart_setting&roomtype='+encodeURIComponent(roomtype)+'&roomrate='+encodeURIComponent(roomrate)+'&extra_price='+JSON.stringify(extra_price)+'&totroom='+totroom+'&seladult='+seladult+'&selchild='+selchild+'&rateid='+RateTypeId+'&RateIdenty='+PkgRate+'&crsaccount='+crsaccount+'&exadultchild='+exadultchild+'&RoomIdentity='+identifier+'&viewstyle='+viewstyle+'&adultchildroomwise='+JSON.stringify(adultchildroomwise)+'&basedata='+JSON.stringify(basedata)+'&tax='+tax+'&totalroomprice='+_totalBookingAmount+"&roomwisebaserate="+JSON.stringify(roomwisebaserate)+"&totalBookingAmountbase="+totalBookingAmountbase+"&totalBookingAmountbasebd="+totalBookingAmountbasebd.toFixed(_decimal)+"&taxbd="+taxbd+"&childage="+JSON.stringify(child_age)+"&totalroomprice_roomwise="+JSON.stringify(_totalamount_roomwise)+"&totalBookingAmountbase_roomwise="+JSON.stringify(_totalBookingAmountbase_roomwise)+"&totalBookingAmountbasebd_roomwise="+JSON.stringify(_totalBookingAmountbasebd_roomwise)+"&tax_roomwise="+JSON.stringify(_totaltax_roomwise)+"&taxbd_roomwise="+JSON.stringify(_taxbd_roomwise)+"&IsPromotion="+IsPromotion+'&tax_decimal='+tax_decimal+'&taxbd_decimal='+taxbd_decimal+'&tax_roomwise_decimal='+JSON.stringify(_totaltax_roomwise_decimal)+'&taxbd_roomwise_decimal='+JSON.stringify(_taxbd_roomwise_decimal)+'&daywiseroomcharge='+JSON.stringify(daywiseroomcharge)+'&daywiseroomtax='+JSON.stringify(daywiseroomtax)+'&Special_Condition='+encodeURIComponent(Special_Condition)+'&Highlighted_Text='+encodeURIComponent(Highlighted_Text); //Priyanka Maurya - 08 March 2021 - Purpose : For Extra Charge Flat Percentage Calculation [Added daywiseroomcharge & daywiseroomtax] - RES-2736 //Chandrakant - 11 June 2021, Purpose - RES-2803 - Special_Condition and Highlighted_Text are added
		}
		else
		{
			var param='HotelId='+hotelcode+'&action=cart_setting&roomtype='+encodeURIComponent(roomtype)+'&roomrate='+encodeURIComponent(roomrate)+'&extra_price='+JSON.stringify(extra_price)+'&totroom='+totroom+'&seladult='+seladult+'&selchild='+selchild+'&rateid='+RateTypeId+'&RateIdenty='+PkgRate+'&crsaccount='+crsaccount+'&exadultchild='+exadultchild+'&RoomIdentity='+identifier+'&viewstyle='+viewstyle+'&adultchildroomwise='+JSON.stringify(adultchildroomwise)+'&basedata='+JSON.stringify(basedata)+'&tax='+tax+'&totalroomprice='+_totalBookingAmount+"&roomwisebaserate="+JSON.stringify(roomwisebaserate)+"&totalBookingAmountbase="+totalBookingAmountbase+"&totalBookingAmountbasebd="+totalBookingAmountbasebd.toFixed(_decimal)+"&taxbd="+taxbd.toFixed(_decimal)+"&childage="+JSON.stringify(child_age)+"&totalroomprice_roomwise="+JSON.stringify(_totalamount_roomwise)+"&totalBookingAmountbase_roomwise="+JSON.stringify(_totalBookingAmountbase_roomwise)+"&totalBookingAmountbasebd_roomwise="+JSON.stringify(_totalBookingAmountbasebd_roomwise)+"&tax_roomwise="+JSON.stringify(_totaltax_roomwise)+"&taxbd_roomwise="+JSON.stringify(_taxbd_roomwise)+"&IsPromotion="+IsPromotion+'&tax_decimal='+tax_decimal+'&taxbd_decimal='+taxbd_decimal+'&tax_roomwise_decimal='+JSON.stringify(_totaltax_roomwise_decimal)+'&taxbd_roomwise_decimal='+JSON.stringify(_taxbd_roomwise_decimal)+'&daywiseroomcharge='+JSON.stringify(daywiseroomcharge)+'&daywiseroomtax='+JSON.stringify(daywiseroomtax)+'&Special_Condition='+encodeURIComponent(Special_Condition)+'&Highlighted_Text='+encodeURIComponent(Highlighted_Text); //Priyanka Maurya - 08 March 2021 - Purpose : For Extra Charge Flat Percentage Calculation [Added daywiseroomcharge & daywiseroomtax] - RES-2736 //Chandrakant - 11 June 2021, Purpose - RES-2803 - Special_Condition and Highlighted_Text are added
		}
		
		getUrl=serverurl+'common/multiproperty_function.php';
		$.ajax({
			url: getUrl,
			type: "POST",
			data: param,
			success: function(data){
				if(jQuery.trim(data) != '')
				{
					_Update_CartItem(data,1,crsaccount,1);
				}
				else
				{
					var message_title = js_stripslashes(langjs[0]["lblHangon"]);
					var message = js_stripslashes(langjs[0]["lblSessionExpired"]);
					var message_btn =js_stripslashes(langjs[0]["L_Pleaserefreshpage"]);
					var selectedLang = jQuery('#selectedLang').val();
					
					swal({
						title: message_title,
						text: message,
						type: "warning",
						confirmButtonText: message_btn,
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						animation:false
					},
					function(){
						if(crsaccount == 0)
							window.location.href=serverurl+'roomlist-'+hotelcode+selectedLang;
						else
							window.location.href=serverurl+'roomlisting-'+groupcode+'-'+hotelId+selectedLang;
					});
				}
			}
		});
	}
	catch(err){
		console.log("Error - _addroomincart - ");
		console.log(err);
		
		var message_title = js_stripslashes(langjs[0]["lblHangon"]);
		var message =js_stripslashes(langjs[0]["lblSessionExpired"]);
		var message_btn =js_stripslashes(langjs[0]["L_Pleaserefreshpage"]);
	
		swal({
			title: message_title,
			text: message,
			type: "warning",
			confirmButtonText: message_btn,
			showCancelButton: false,
			confirmButtonColor: "#DD6B55",
			animation:false
			},
			function(){
				location.reload();
			}
		);
	}
}

function _removebookroom(rpid,isRate,hotelcode,parentInOut,roomratetype,Identity,crsaccount)
{
	try
	{
		_loader('Show');
		//_checksession('1',crsaccount);
		var identifire = atob(Identity).split("|");
		if(identifire[1] == 0)
		{
			var rmcnt = parseFloat(jQuery('.rcnt_'+identifire[0]).html());
			var room_identity = identifire[0].split('_')[0];
			var roomtypeid = jQuery('#RoomTypeId_'+room_identity).val();
			jQuery('.avi-room_'+roomtypeid).html(Number(jQuery('.avi-room_'+roomtypeid).html()) + Number(jQuery('.rcnt_'+identifire[0]).html()));
			jQuery('.maxbookRoom_'+roomtypeid).val(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) + Number(jQuery('.rcnt_'+identifire[0]).html()));
			jQuery('.rate-aviroom_'+roomtypeid).html(Number(jQuery('.rate-aviroom_'+roomtypeid).html()) + Number(jQuery('.rcnt_'+identifire[0]).html()));
			jQuery('.maxbookRate_'+roomtypeid).val(Number(jQuery('.maxbookRate_'+roomtypeid).val()) + Number(jQuery('.rcnt_'+identifire[0]).html()));
			
			if(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
				
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
				
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
			}
	
			jQuery('#RateType_RoomView_'+identifire[0]+' .rcnt_'+identifire[0]).html('0');
			jQuery('#RateType_RoomView_'+identifire[0]+' .be-addedRoomrow').remove();
			jQuery('#RateType_RoomView_'+identifire[0]).hide();
			jQuery('#RoomType_RoomView_'+identifire[0]).show();
		}
		else
		{
			var room_identity = identifire[0].split('_')[0];
			var roomtypeid = jQuery('#Rate-RoomTypeId_'+identifire[0]).val();
			jQuery('.avi-room_'+roomtypeid).html(Number(jQuery('.avi-room_'+roomtypeid).html()) + Number(jQuery('.rmcnt_'+identifire[0]).html()));
			jQuery('.maxbookRoom_'+roomtypeid).val(Number(jQuery('.maxbookRoom_'+roomtypeid).val()) + Number(jQuery('.rmcnt_'+identifire[0]).html()));
			jQuery('.rate-aviroom_'+roomtypeid).html(Number(jQuery('.rate-aviroom_'+roomtypeid).html()) + Number(jQuery('.rmcnt_'+identifire[0]).html()));
			jQuery('.maxbookRate_'+roomtypeid).val(Number(jQuery('.maxbookRate_'+roomtypeid).val()) + Number(jQuery('.rmcnt_'+identifire[0]).html()));
			
			if(Number(jQuery('.maxbookRate_'+roomtypeid).val()) == 0)
			{
				jQuery('.setexistRoom_'+roomtypeid).attr('disabled','disabled');
				jQuery('.bookroom_'+room_identity).attr('disabled','disabled');
				jQuery('.bookroom-rate-'+roomtypeid).attr('disabled','disabled');
				jQuery('.setexistRate_'+roomtypeid).attr('disabled','disabled');
			}
			else
			{
				jQuery('.setexistRoom_'+roomtypeid).removeAttr('disabled');
				jQuery('.bookroom_'+room_identity).removeAttr('disabled');
				jQuery('.bookroom-rate-'+roomtypeid).removeAttr('disabled');
				jQuery('.setexistRate_'+roomtypeid).removeAttr('disabled');
			}
			
			if(jQuery('.avi-room_'+roomtypeid).html() >= 1)
			{
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				jQuery('.No-room_'+roomtypeid).hide();
				jQuery('.avi-room_'+roomtypeid).show();
				
				if(jQuery('.avi-room_'+roomtypeid).html() < 4)
					jQuery('.Hurry_'+roomtypeid).show();
				else
					jQuery('.Hurry_'+roomtypeid).hide();
			}
			
			if(jQuery('.rate-aviroom_'+roomtypeid).html() >= 1)
			{
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room-hurry').addClass('min-avi-room');
				jQuery('.Rate-RoomType_'+roomtypeid+' .min-avi-room').removeClass('min-avi-room-hurry');
				jQuery('.rate-noroom_'+roomtypeid).hide();
				jQuery('.rate-aviroom_'+roomtypeid).show();
				
				if(jQuery('.rate-aviroom_'+roomtypeid).html() < 4)
					jQuery('.rate-hurry-'+roomtypeid).show();
				else
					jQuery('.rate-hurry-'+roomtypeid).hide();
			}
			
			jQuery('#RoomType_RateView_'+identifire[0]+' .rmcnt_'+identifire[0]).html('0');
			jQuery('#RoomType_RateView_'+identifire[0]+' .be-addedRoomrow').remove();
			jQuery('#RoomType_RateView_'+identifire[0]).hide();
			jQuery('#RateType_RateView_'+identifire[0]).show();
		}
		
		var serverurl = jQuery('#loadingurl').val();
		var groupcode = jQuery('#groupcode').val();
		
		if(crsaccount == 1)
		{
			var param='GroupCode='+groupcode+'&HotelId='+hotelcode+'&action=cart_removeroom&RatePlanId='+rpid+'&IsRate='+isRate+'&parentInOut='+parentInOut+'&roomratetype='+encodeURIComponent(roomratetype)+'&crsaccount='+crsaccount;
		}
		else
		{
			var param='HotelId='+jQuery('#hotel_code').val()+'&action=cart_removeroom&RatePlanId='+rpid+'&IsRate='+isRate+'&parentInOut='+parentInOut+'&roomratetype='+encodeURIComponent(roomratetype)+'&crsaccount='+crsaccount; //Pinal - 11 January 2019
		}
		
		getUrl=serverurl+'common/multiproperty_function.php';
		$.ajax({
			url: getUrl,
			type: "POST",
			data: param,
			success: function(data){
				_Update_CartItem(data,1,crsaccount,1);
				_loader('Hide');
			}
		});
	}
	catch(err){
		console.log("Error - _removebookroom - "+err.message);
	}
}

function _Isvalidcart(crsaccount,page,WebExommerceClassicView,selected_currency)
{
	try
	{
		var view_room = jQuery('.viewbyRooms');
		var view_rate = jQuery('.viewbyRates');
		var stuck_operation = 0;
		
		view_room.find('.roomwise-age').each(function(e){
			if(jQuery(this).val() == '')
				stuck_operation++;
		});
		
		view_rate.find('.roomwise-age').each(function(e){
			if(jQuery(this).val() == '')
				stuck_operation++;
		});
		
		if(stuck_operation != 0)
			return false;
		
		_loader('Show');//Chinmay Gandhi - 22nd OCT 2019 - Fixing Minor Display issue of MHBE [ MHBE_Display_Issue ]
		_checksession('1',crsaccount);
		var hotelcode = jQuery('#hotel_code').val();
		var serverurl = jQuery('#loadingurl').val();
		var groupcode = jQuery('#groupcode').val();
		var foldername = jQuery('#foldername').val();
					
		var config_token=jQuery("input#restoken").val();
		if(typeof(config_token)=='undefined') { var config_token=''; }
		
		if(crsaccount == 1)
			var param1 = 'GroupCode='+groupcode+'&action=checktoken&config_token='+config_token;
		else
			var param1 = 'HotelId='+hotelcode+'&action=checktoken&config_token='+config_token;
		
		if(WebExommerceClassicView != '' && WebExommerceClassicView == 5){
			addDataLayerRoomSelection(selected_currency);
		}		
		jQuery.ajax({
			type: "POST",		
			url: serverurl+'multiproperty_service.php',			  
			data: param1,
			success: function(response) {
				
			},
			complete: function(response)
			{
				if (jQuery.trim(response.responseText)==1 || config_token=='')
				{
					getUrl=serverurl+'common/multiproperty_function.php';
					
					if(crsaccount == 1)
						var param='GroupCode='+groupcode+'&HotelId='+hotelcode+'&action=Isvalidcart&crsaccount='+crsaccount;
					else
						var param='HotelId='+hotelcode+'&action=Isvalidcart&crsaccount='+crsaccount;
					
					$.ajax({
						url: getUrl,
						type: "POST",
						data: param,
						success: function(data){
							if(data.trim() != "1")
							{
								if(crsaccount == 1)
									window.location.href=serverurl+'checkout-'+groupcode;
								else if(crsaccount == 0)
									window.location.href=serverurl+'checkoutpage-'+hotelcode;
							}
							else
							{
								_loader('Hide');
								var message_title = js_stripslashes(langjs[0]["lblHangon"]);
								var message =js_stripslashes(langjs[0]["lblSessionExpired"]);
								var message_btn =js_stripslashes(langjs[0]["L_Pleaserefreshpage"]);
							
								swal({
									title: message_title,
									text: message,
									type: "warning",
									confirmButtonText: message_btn,
									showCancelButton: false,
									confirmButtonColor: "#DD6B55",
									animation:false
									},
									function(){
										var selectedLang = jQuery('#selectedLang').val();
										if(crsaccount == 0)
										{
											window.location.href=serverurl+'roomlist-'+hotelcode+selectedLang;
										}
										else if(crsaccount == 1)
										{
											if(page == 1)
												window.location.href=serverurl+'roomlisting-'+groupcode+'-'+foldername+selectedLang;
											else
												window.location.href=serverurl+'chain-'+groupcode+selectedLang;
										}
									}
								);
								return false;
							}
						}
					});
				}
				else
				{
					_loader('Hide');
					swal({
							title: 'Invalid Request',
							text: "Invalid Request",
							type: "warning",
							showCancelButton: false,
							confirmButtonColor: "#DD6B55",
							animation:false				
						},
						function(){
							location.reload();
						});
					return false;
				}
			}
		});
	}
	catch(err){
		console.log("Error - _Isvalidcart - "+err.message);
	}
}

function getTax(roomcharge,taxarray,decimalplaces,flag)
{
	try
	{
		if (eval(taxarray)[0]==0 || eval(taxarray)[0] == null) {
				return 0;
			}
		
		var BaseRate=0;
   		var AdultRate=0;
   		var ChldRate=0;
		var callfor='base';
		var	base_adult=0;
		var	base_child=0;
		var v_amount=parseFloat(roomcharge).toFixed(decimalplaces);  
		var realamt=v_amount;
		var cnt=0;
		var JSONobject=eval(taxarray);
		var taxamt=new Array();
		var slab=new Array();
		var potype=new Array();
		var porule=new Array();
		var exrate1=new Array();
		var exrate2=new Array();
		
		var taxapplyafter=new Array();
		var taxunkid=new Array();
		var applyonrackrate=new Array();
		
		if(JSONobject=='')
			return 0;
		
		jQuery.each(JSONobject, function(jsonKey, jsonValue) {
			jQuery.each(jsonValue,  function(Key, Value) {
				jQuery.each(Value, function(k1, v1) {
					if(k1=='amount')
						taxamt.push(Value[k1]);
					if(k1=='slab')
						slab.push(Value[k1]);
					if(k1=='postingtype')
						potype.push(Value[k1]);
					if(k1=='postingrule')
						porule.push(Value[k1]);
					if(k1=='exchange_rate2')
						exrate2.push(Value[k1]);
					if(k1=='exchange_rate1')
						exrate1.push(Value[k1]);
					
					if(k1=='taxapplyafter')
						taxapplyafter.push(Value[k1]);
					if(k1=='taxunkid')
						taxunkid.push(Value[k1]);
					if(k1=='applyonrackrate')
						applyonrackrate.push(Value[k1]);
						
					cnt++;	
				});				
			});	
		});
		
		var exchange_rate1=0;
		var exchange_rate2=0;
		var postingtype;
		var postingrule;
		var v_taxamount=0;
		var v_slab;
		var totaltax=0;
		
		var taxretarr=new Array();
		
		if(typeof(taxamt[0])!='undefined')
		{
			for(i=0;i<taxamt[0].length;i++)
			{			
				v_taxamount=taxamt[0][i];
				postingtype=potype[0][i];
				postingrule=porule[0][i];
				exchange_rate2=exrate2[0][i];
				exchange_rate1=exrate1[0][i];
				v_slab=slab[0][i];
				v_taxapplyafter=taxapplyafter[0][i];
				v_taxunkid=taxunkid[0][i];
				v_applyonrackrate=applyonrackrate[0][i];
				
				
				var v_tamount=0;
				var v_camount=0;
				if(v_taxamount!='undefined' && exchange_rate2!='undefined' && exchange_rate1!='undefined' && postingtype!='undefined' && postingrule!='undefined')
				{
					if(!parseInt(flag))
					{
						if(parseInt(v_applyonrackrate))
						{
							if(callfor=='base') v_amount=BaseRate;
							if(callfor=='extraadult') v_amount=AdultRate;
							if(callfor=='extrachild') v_amount=ChldRate;
							
							v_amount=parseFloat(v_amount).toFixed(decimalplaces);  
						}
						else
						{
							v_amount=realamt;	
						}	
					}

					v_btaxapplyafter=0;
					v_ctaxapplyafter=0;
					if(v_taxapplyafter!='')
					{
						for(taxkey in taxretarr)
						{
							if((","+v_taxapplyafter+",").indexOf(","+taxkey+",")!=-1)
							{
								v_btaxapplyafter+=parseFloat(taxretarr[taxkey][0]);
								v_ctaxapplyafter+=parseFloat(taxretarr[taxkey][1]);
							}
						}
					}
					
					if(postingtype=='FLATPERCENTAGE')
					{
						v_tamount = parseFloat(v_tamount) + parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100;
						v_camount = parseFloat(v_camount) + parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100;
						
						v_camount = roundNumber(v_camount,decimalplaces);
						
						totaltax = parseFloat(totaltax) + parseFloat(v_camount.toFixed(decimalplaces));
						
						taxretarr[v_taxunkid]=new Array(parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100,parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100);
					}
					else if(postingtype=='FLATAMOUNT')
					{
						if(postingrule!='')
						{
							if(postingrule == "PERADULT")
								v_taxamount = parseFloat(v_taxamount) * parseFloat(base_adult);
							
							if(postingrule == "PERCHILD")
								v_taxamount = parseFloat(v_taxamount) * parseFloat(base_child);
								
							if(postingrule == "PERPAX")
								v_taxamount = parseFloat(v_taxamount) * (parseFloat(base_adult) + parseFloat(base_child));	
						}

						v_tamount = parseFloat(v_tamount) + parseFloat(v_taxamount);
						v_camount = parseFloat(v_camount) + (parseFloat(v_tamount) * parseFloat(exchange_rate1)/parseFloat(exchange_rate2));
						totaltax = parseFloat(totaltax) + parseFloat(v_camount.toFixed(decimalplaces));
						
						taxretarr[v_taxunkid]=new Array(v_taxamount,v_camount);
	
					}
					else if(postingtype=='SLAB')
					{
						v_taxslab = v_slab.split(",");	
						for(iSlab=0;iSlab<v_taxslab.length;iSlab++)
						{
							v_taxslab1=v_taxslab[iSlab].split("-");
							v_slabstart	  =  v_taxslab1[0];
							v_slabend 	  =  v_taxslab1[1];
							v_slabpercent =  v_taxslab1[2];
						   
							if((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) >= parseFloat(v_slabstart) && (parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) <= parseFloat(v_slabend))
							{
								v_tamount = ((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100;
								v_camount = ((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100;
							   
								v_camount = roundNumber(v_camount,decimalplaces);
								
								totaltax = parseFloat(totaltax) + parseFloat(v_camount.toFixed(decimalplaces));
								
								//Chandrakant - 30 Oct 2019 - START
								//Purpose : RES-2287 - v_taxamount getting 0. After referring Manual Add Reservation logic, I have replace it to v_slabpercent
								//taxretarr[v_taxunkid]=new Array(parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100,parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100);
								taxretarr[v_taxunkid]=new Array(parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100,parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100);
								//Chandrakant - 30 Oct 2019 - END
							}	
						}
					}	
				}
			}
			var amt=totaltax;
			return amt.toFixed(decimalplaces);
		}
		else
			return 0;
	}
	catch(err)
	{
		console.log("Error - getTax - "+err.message);
	}
}

function getroundval(inval,factor)
{
	try
	{
		if(factor<=0)
			return inval;
		
		var newinval=inval*factor;
		var sign=inval>0?1:inval==0?0:-1;
		var fixtemp=newinval+0.5*sign;
		fixtemp=~~fixtemp;
		
		if(newinval-~~newinval==0.5)
			if(fixtemp/2!=~~(fixtemp/2))
				fixtemp=fixtemp-sign;
				
		return fixtemp/factor
	}
	catch(err){
		console.log("Error - getroundval - "+err.message);
	}
}

function roundNumber(value, exp)
{
	try
	{
		if (typeof exp === 'undefined' || +exp === 0)
		  return Math.round(value);
	  
		value = +value;
		exp = +exp;
	  
		if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
		  return NaN;
	  
		value = value.toString().split('e');
		value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
	  
		value = value.toString().split('e');
		return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
	}
	catch(err){
		console.log("Error - roundNumber - "+err.message);
	}
}

function _editroom(hotelcode,check_In,check_Out,crsaccount,identity)
{
	try
	{
		_loader('Show');
		var serverurl = jQuery('#loadingurl').val();
		var viewtype = encodeURIComponent(atob(identity));//Maintain focus when click on edit option
		var In_date = atob(check_In).replace(/-| |,|_/g,'_');
		var Out_date = atob(check_Out).replace(/-| |,|_/g,'_');
		var edit_link = '';
		
		if(crsaccount == 1)
		{
			var groupcode = jQuery('#groupcode').val();
			edit_link = serverurl+'roomlisting-'+groupcode+'-'+hotelcode+'-'+In_date+'-'+Out_date+'-'+viewtype;
		}
		else if(crsaccount == 0)
		{
			var HotelId = jQuery('#hotel_code').val();
			edit_link = serverurl+'roomlist-'+HotelId+'-'+In_date+'-'+Out_date+'-'+viewtype;
		}
		window.location=edit_link;
	}
	catch(err){
		console.log("Error - _editroom - "+err.message);
	}
}

function apply_filter(flag,roomtypeunkid)
{
	try
	{
		roomtypeunkid = roomtypeunkid || '';
		var $wrapper_room = $('.apply-room-operation');
		var $wrapper_rate = $('.apply-rate-operation');
		
		var amenity = [];var star_ratting = [];var property_type = [];var price_range = [];var room_type = [];var optbooker_type = [];
		jQuery('input[name="amenity"]:checked').each(function() {
			amenity.push(this.value);
		});
		
		if(jQuery('#pricerange').val() != null)
			price_range = jQuery('#pricerange').val().split(';');
		else
			price_range = [];
		
		jQuery('input[name="starrate"]:checked').each(function() {
			star_ratting.push(this.value);
		});
		
		jQuery('input[name="protype"]:checked').each(function() {
			property_type.push(this.value);
		});
		
		jQuery('input[name="roomtype"]:checked').each(function() {
			room_type.push(this.value);
		});
		
		jQuery('input[name="optbooker"]:checked').each(function() {
			optbooker_type.push(this.value);
		});

		if(roomtypeunkid!='')
			room_type.push(roomtypeunkid);
	
		var displaymsg_flag = 0;	
		if(flag == 0)
		{
			var hotel_cnt = $wrapper_room.find('.room-operation_rule').length;
			var hide_cnt = 0;
			$wrapper_room.find('.room-operation_rule').each(function(a,b){
				jQuery(b).css('display', 'block');
				
				var protype_flag = 0;var rating_flag = 0;var amemi_flag = 0;var price_flag = 0;
				if(amenity.length > 0)
				{
					$.each(amenity, function(key, val) {
						$.each(jQuery.parseJSON(decodeURIComponent(jQuery(b).attr("amenity"))), function(amecnt, ameval) {
							if(ameval.replace(/&#39;/g, "'") == val){
								displaymsg_flag = 1;
								amemi_flag = 1;
							}
						});
					});
				}
				else
					amemi_flag = 1;
					
				if(price_range.length > 0)
				{
					if(Number(jQuery(b).attr("roomprice")) >= price_range[0] && Number(jQuery(b).attr("roomprice")) <= price_range[1])
						price_flag = 1;
					else if(jQuery(b).attr("roomprice") == '')
						price_flag = 1;
				}
				else
					price_flag = 1;
					
				if(star_ratting.length > 0)
				{
					$.each(star_ratting, function(key, val) {
						if(jQuery(b).attr("grade") == val){
							displaymsg_flag = 1;
							rating_flag = 1;

						}
					});
				}
				else
					rating_flag = 1;
					
				if(property_type.length > 0)
				{
					$.each(property_type, function(key, val) {
						if(jQuery(b).attr("property") == val)
						{
							protype_flag = 1;
							displaymsg_flag = 1;
						}
					});
				}
				else
					protype_flag = 1;
					
				if(amemi_flag == 0 || price_flag == 0 || rating_flag == 0 || protype_flag == 0)
				{
					jQuery(b).css('display', 'none');
					hide_cnt++;
				}
				
			});
			
			$wrapper_rate.find('.rate-operation-rule').each(function(a,b){
				jQuery(b).css('display', 'block');
				
				var protype_flag = 0;var rating_flag = 0;var amemi_flag = 0;var price_flag = 0;
				if(amenity.length > 0)
				{
					$.each(amenity, function(key, val) {
						$.each(jQuery.parseJSON(decodeURIComponent(jQuery(b).attr("amenity"))), function(amecnt, ameval) {
							if(ameval == val){
								displaymsg_flag = 1;
								amemi_flag = 1;
							}
						});
					});
				}
				else
					amemi_flag = 1;
					
				if(price_range.length > 0)
				{
					//Chandrakant - 11 March 2021, Purpose - RES-2757 - added equal sign in below condition
					//if(Number(jQuery(b).attr("roomprice")) > price_range[0] && Number(jQuery(b).attr("roomprice")) <= price_range[1])
					if(Number(jQuery(b).attr("roomprice")) >= price_range[0] && Number(jQuery(b).attr("roomprice")) <= price_range[1])
						price_flag = 1;
				}
				else
					price_flag = 1;
					
				if(star_ratting.length > 0)
				{
					$.each(star_ratting, function(key, val) {
						if(jQuery(b).attr("grade") == val){
							displaymsg_flag = 1;
							rating_flag = 1;
						}
					});
				}
				else
					rating_flag = 1;
					
				if(property_type.length > 0)
				{
					$.each(property_type, function(key, val) {
						if(jQuery(b).attr("property") == val)
						{
							protype_flag = 1;
							displaymsg_flag = 1;
						}
					});
				}
				else
					protype_flag = 1;
					
				if(amemi_flag == 0 || price_flag == 0 || rating_flag == 0 || protype_flag == 0)
					jQuery(b).css('display', 'none');
			});
			
			if(Number(hide_cnt) == Number(hotel_cnt)){
				jQuery('#nofound_hotellist').show();
			}
			else
				jQuery('#nofound_hotellist').hide();	
		}
		else if(flag == 1)
		{
			$wrapper_room.find('.room-operation_rule').each(function(a,b){
				jQuery(b).css('display', 'block');
				
				var amemi_flag = 0;var roomtype_flag = 0;
				if(amenity.length > 0)
				{
					$.each(amenity, function(key, val) {
						var ameids = jQuery(b).attr("amenity").split(',');
						$.each(ameids, function(amecnt, ameval) {
							if(ameval == val){
								displaymsg_flag = 1;
								amemi_flag = 1;
							}
						});
					});
				}
				else
					amemi_flag = 1;
					
				if(room_type.length > 0)
				{
					$.each(room_type, function(key, val) {
						if(jQuery(b).attr("roomname") == val){
							jQuery.each(jQuery("input[name='roomtype']"), function(key1, val1) {
								if(jQuery(val1).val() == val)
									jQuery(this).attr("checked","checked");
							});
							displaymsg_flag = 1;
							roomtype_flag = 1;
						}
					});
				}
				else
					roomtype_flag = 1;
					
				if(amemi_flag == 0 || roomtype_flag == 0)
					jQuery(b).css('display', 'none');
					
				jQuery(this).find('.rate-plan-wrapper').each(function(c,d){
					jQuery(d).addClass('toggletypes');
					jQuery(d).css('display', 'none');
					
					var optbooker_flag = 0;var price_flag = 0;
					if(optbooker_type.length > 0)
					{
						$.each(optbooker_type, function(key, val) {
							if(jQuery(d).attr("nonrefund") == val){
								displaymsg_flag = 1;
								optbooker_flag = 1;
							}
						});
					}
					else
						optbooker_flag = 1;
						
					if(price_range.length > 0)
					{
						//Chandrakant - 11 March 2021, Purpose - RES-2757 - added equal sign in below condition
						//if(Number(jQuery(d).attr("roomprice")) > price_range[0] && Number(jQuery(d).attr("roomprice")) <= price_range[1])
						if(Number(jQuery(d).attr("roomprice")) >= price_range[0] && Number(jQuery(d).attr("roomprice")) <= price_range[1])
							price_flag = 1;
					}
					else
						price_flag = 1;
					
					if(optbooker_flag == 0 || price_flag == 0)
					{
						jQuery(d).removeClass('toggletypes');
						jQuery(d).css('display', 'none');
					}
				});
				
				if(jQuery(this).find('.toggletypes').length == 0)
					jQuery(b).css('display', 'none');
			});
			
			$wrapper_rate.find('.rate-operation-rule').each(function(cnt,ind){
				jQuery(ind).css('display', 'block');
				
				jQuery(this).find('.room-type-wrapper').each(function(a,b){
					jQuery(b).addClass('toggletypes');
					jQuery(b).css('display', 'block');
					
					var amemi_flag = 0;var roomtype_flag = 0;var price_flag = 0;
					if(amenity.length > 0)
					{
						$.each(amenity, function(key, val) {
							var ameids = jQuery(b).attr("amenity").split(',');
							$.each(ameids, function(amecnt, ameval) {
								if(ameval == val){
									displaymsg_flag = 1;
									amemi_flag = 1;
								}
							});
						});
					}
					else
						amemi_flag = 1;
						
					if(room_type.length > 0)
					{
						$.each(room_type, function(key, val) {
							if(jQuery(b).attr("roomname") == val){
								jQuery.each(jQuery("input[name='roomtype']"), function(key1, val1) {
									if(jQuery(val1).val() == val)
										jQuery(this).attr("checked","checked");
								});
								displaymsg_flag = 1;
								roomtype_flag = 1;
							}
						});
					}
					else
						roomtype_flag = 1;
						
					var optbooker_flag = 0;
					if(optbooker_type.length > 0)
					{
						$.each(optbooker_type, function(key, val) {
							if(jQuery(b).attr("nonrefund") == val){
								displaymsg_flag = 1;
								optbooker_flag = 1;
							}
						});
					}
					else
						optbooker_flag = 1;
						
					if(price_range.length > 0)
					{
						//Chandrakant - 11 March 2021, Purpose - RES-2757 - added equal sign in below condition
						//if(Number(jQuery(b).attr("roomprice")) > price_range[0] && Number(jQuery(b).attr("roomprice")) <= price_range[1])
						if(Number(jQuery(b).attr("roomprice")) >= price_range[0] && Number(jQuery(b).attr("roomprice")) <= price_range[1])
							price_flag = 1;
					}
					else
						price_flag = 1;
						
					if(amemi_flag == 0 || roomtype_flag == 0 || optbooker_flag == 0 || price_flag == 0)
					{
						jQuery(b).css('display', 'none');
						jQuery(b).removeClass('toggletypes');
					}
				});
				
				if(jQuery(this).find('.toggletypes').length == 0)
					jQuery(ind).css('display', 'none');
			});
			if(jQuery('#manage_search_data').find('.dis_roomtype_wise').is(':visible') == false && jQuery('#manage_search_data').find('.dis_ratetype_wise').is(':visible') == false)
			{
				displaymsg_flag = 1;
				jQuery('#nofound_Roomlist').css('display', 'block');
				jQuery('#nofound_Roomlist .notfound').css('margin-top','0');
			}
			else
			{
				jQuery('#nofound_Roomlist').css('display', 'none');
				jQuery('#nofound_Roomlist .notfound').css('margin-top','');
			}
		}
		if(displaymsg_flag == 1){
			jQuery('.applymsg_chain').css('display', 'block');
			jQuery('.applymsg_multichain').css('display', 'block');
		}
		else{
			jQuery('.applymsg_chain').css('display', 'none');
			jQuery('.applymsg_multichain').css('display', 'none');
		}
	}
	catch(err){
		console.log("Error - apply_filter - "+err.message);
	}
}

function reset_filter(type,chaintype,searchflag)
{
	try
	{
		chaintype = chaintype || '';
		searchflag = searchflag || '';
		if(type == 1 || type == 0)
		{
			jQuery('input[name="amenity"]:checked').each(function() {
				jQuery(this).prop('checked', false); 
				jQuery('.applymsg_chain').css('display', 'none');
			});
		}
		
		if(type == 2 || type == 0)
		{
			if(jQuery('.mngfilter').html() != null){
				jQuery("#pricerange").data("ionRangeSlider").reset();
				jQuery('.applymsg_chain').css('display', 'none');
			}
		}
		
		if(type == 3 || type == 0)
		{
			jQuery('input[name="starrate"]:checked').each(function() {
				jQuery(this).prop('checked', false);
				jQuery('.applymsg_chain').css('display', 'none'); 
			});
		}
		
		if(type == 4 || type == 0)
		{
			jQuery('input[name="protype"]:checked').each(function() {
				jQuery(this).prop('checked', false);
				jQuery('.applymsg_chain').css('display', 'none'); 
			});
		}
		
		if(type == 5 || type == 0)
		{
			jQuery('input[name="optbooker"]:checked').each(function() {
				jQuery(this).prop('checked', false);
				jQuery('.applymsg_chain').css('display', 'none'); 
			});
		}
		
		if(type == 6 || type == 0)
		{
			jQuery('input[name="roomtype"]:checked').each(function() {
				jQuery(this).prop('checked', false);
				jQuery('.applymsg_chain').css('display', 'none'); 
			});
		}
		
		if(type == 7 || type == 0)
		{
			jQuery('input[name="ratetype"]:checked').each(function() {
				jQuery(this).prop('checked', false);
				jQuery('.applymsg_chain').css('display', 'none'); 
			});
		}

		if(type == 0){
			jQuery('.filterList').hide();
			jQuery('.applymsg_chain').css('display', 'none');
			if(searchflag != 1){
				if(chaintype!='' && chaintype == 1)
					apply_filter(0);
				else
					apply_filter(1);
			}
		}
	}
	catch(err){
		console.log("Error - reset_filter - "+err.message);
	}
}

function _applysorting(page,reset)
{
	try
	{
		var $wrapper_room = $('.apply-room-operation');
		var $wrapper_rate = $('.apply-rate-operation');
		
		if(page == 0)
		{
			if(reset == 1)
				var sort_type = 'new';
			else
				var sort_type = jQuery(".dd-sorting a.active").attr('id');
		}
		else
		{
			if(reset == 1)
				var sort_type = 'nosort';
			else
				var sort_type = jQuery(".matchboth a.active").attr('id');
		}
	  
		$wrapper_room.find('.room-operation_rule').sort(function(a, b){
			if(sort_type == 'new')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/new_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/new_(\d+)/)[1];
					
				return +bsortNum - +asortNum;
			}
			else if(sort_type == 'highrate')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/score_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/score_(\d+)/)[1];
					
				return +bsortNum - +asortNum;
			}
			else if(sort_type == 'lhp')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/price_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/price_(\d+)/)[1];
					
				return +asortNum - +bsortNum;
			}
			else if(sort_type == 'hlp')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/price_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/price_(\d+)/)[1];
					
				return +bsortNum - +asortNum;
			}
			else if(sort_type == 'nosort')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/rmsort_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/rmsort_(\d+)/)[1];
					
				return +asortNum - +bsortNum;
			}
		}).appendTo($wrapper_room);
		
		$wrapper_rate.find('.rate-operation-rule').sort(function(a, b){
			if(sort_type == 'new')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/new_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/new_(\d+)/)[1];
					
				return +bsortNum - +asortNum;
			}
			else if(sort_type == 'highrate')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/score_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/score_(\d+)/)[1];
					
				return +bsortNum - +asortNum;
			}
			else if(sort_type == 'lhp')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/price_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/price_(\d+)/)[1];
					
				return +asortNum - +bsortNum;
			}
			else if(sort_type == 'hlp')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/price_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/price_(\d+)/)[1];
					
				return +bsortNum - +asortNum;
			}
			else if(sort_type == 'nosort')
			{
				var aclassStr = a.className,
					asortNum = aclassStr.match(/rtsort_(\d+)/)[1];
				var bclassStr = b.className,
					bsortNum = bclassStr.match(/rtsort_(\d+)/)[1];
					
				return +asortNum - +bsortNum;
			}
		}).appendTo($wrapper_rate);
		
		if(page == 1)
		{
			jQuery('.apply-room-operation').find('.room-wrapper').each(function(){
				$(this).find('.toggletypes').sort(function(a, b){
					if(sort_type == 'lhp')
					{
						var aclassStr = a.className,
							asortNum = aclassStr.match(/price_(\d+)/)[1];
						var bclassStr = b.className,
							bsortNum = bclassStr.match(/price_(\d+)/)[1];
							
						return +asortNum - +bsortNum;
					}
					else if(sort_type == 'hlp')
					{
						var aclassStr = a.className,
							asortNum = aclassStr.match(/price_(\d+)/)[1];
						var bclassStr = b.className,
							bsortNum = bclassStr.match(/price_(\d+)/)[1];
							
						return +bsortNum - +asortNum;
					}
					else if(sort_type == 'nosort')
					{
						var aclassStr = a.className,
							asortNum = aclassStr.match(/rtpsort_(\d+)/)[1];
						var bclassStr = b.className,
							bsortNum = bclassStr.match(/rtpsort_(\d+)/)[1];
							
						return +asortNum - +bsortNum;
					}
				}).appendTo($(this));
			});
			
			jQuery('.apply-rate-operation').find('.rates-wrapper').each(function(){
				$(this).find('.toggletypes').sort(function(a, b){
					if(sort_type == 'lhp')
					{
						var aclassStr = a.className,
							asortNum = aclassStr.match(/price_(\d+)/)[1];
						var bclassStr = b.className,
							bsortNum = bclassStr.match(/price_(\d+)/)[1];
							
						return +asortNum - +bsortNum;
					}
					else if(sort_type == 'hlp')
					{
						var aclassStr = a.className,
							asortNum = aclassStr.match(/price_(\d+)/)[1];
						var bclassStr = b.className,
							bsortNum = bclassStr.match(/price_(\d+)/)[1];
							
						return +bsortNum - +asortNum;
					}
					else if(sort_type == 'nosort')
					{
						var aclassStr = a.className,
							asortNum = aclassStr.match(/rtpsort_(\d+)/)[1];
						var bclassStr = b.className,
							bsortNum = bclassStr.match(/rtpsort_(\d+)/)[1];
							
						return +asortNum - +bsortNum;
					}
				}).appendTo($(this));
			});
		}
	}
	catch(err){
		console.log("Error - _applysorting - "+err.message);
	}
}
	
	
//function _ishideextra()
//{
//	try{
//		jQuery('.ishide').slideToggle(1000);
//		jQuery('.isshow').slideToggle(1000);
//	}
//	catch(err){
//		console.log("Error - _ishideextra - "+err.message);
//	}
//}

function getMap(code)
{
	try{
		console.log('getMap');
		var address = atob(jQuery('.'+code+'_modal').attr('id'));
		var map_loaded=false;
		if(!map_loaded){
			var maploc = initMap(code);
			map_loaded=true;
		}
		
		resetMap(false,address,maploc,code);
	}
	catch(err){
		console.log("Error - getMap - "+err.message);
	}
}

function initMap(code)
{
	try{
		var latlngsys = new google.maps.LatLng(parseFloat(jQuery("#"+code+"_latitude").val()), parseFloat(jQuery("#"+code+"_longitude").val())); // Jemin - 29-Jan-2020 - RES-2371 - Google Map issue -START
		var map;
		var latlng = new google.maps.LatLng(10,20);
		var myOptions = {
			zoom: parseInt(15),
			center: latlngsys || latlng,
			streetViewControl: false,
			scrollwheel: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		}
		map = new google.maps.Map(document.getElementById(code+"_map_canvas"), myOptions);
		return map;
	}
	catch(err){
		console.log("Error - initMap - "+err.message);
	}
}

function resetMap(flag,address,maploc,code)
{
	try
	{
		// var _marker_moved=false;
		var lat = jQuery("#"+code+"_latitude").val();
		var lng  = jQuery("#"+code+"_longitude").val();
		if((lat == ''  || lng =='') || flag==true)
		{
			console.log("Geocode Loaded")
			geocoder = new google.maps.Geocoder();
			geocoder.geocode( { 'address': address}, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					setMapLocation(results[0].geometry.location,maploc,code);
				}
			});	
		}
		else
		{
			var latlng = new google.maps.LatLng(lat,lng);
			setMapLocation(latlng,maploc,code);
		}
	}
	catch(err){
		console.log("Error - resetMap - "+err.message);
	}
}
function setMapLocation(location,maploc,code)
{
	try
	{
		var marker;
		if(marker!==undefined)
			marker.setMap(null);
			marker= new google.maps.Marker({
			map: maploc, 
			position: location,
			zoom: parseInt(15),
			draggable: false //sachi desai- purpose: to stop moving marker of map while displaying location
		});
		maploc.panTo(marker.getPosition());
		maploc.setZoom(parseInt(15));
	
		bindListeners(maploc,marker,code);	
		setLatLng(marker,code);
	}
	catch(err){
		console.log("Error - setMapLocation - "+err.message);
	}
}
function bindListeners(maploc,marker,code) {
	try{
		google.maps.event.addListener(marker, 'dragend', function() {
			maploc.panTo(marker.getPosition());
			_marker_moved=true;
			setLatLng(marker,code);
		});
	}catch(err){
		console.log("Error - bindListeners - "+err.message);
	}
}
function setLatLng(marker,code){
	try{
		jQuery("#"+code+"_latitude").val(marker.getPosition().lat().toFixed(6));
		jQuery("#"+code+"_longitude").val(marker.getPosition().lng().toFixed(6));
	}catch(err){
		console.log("Error - setLatLng - "+err.message);
	}
}
function _setcartposition()
{
	try{
		jQuery("#mobile-itinerary .ico-info").click(function (e) {
			jQuery("#PurchaseDeatil").toggleClass("itinry-open");
		});
		jQuery("#PurchaseDeatil .close-btn").click(function (e) {
			jQuery("#PurchaseDeatil").removeClass("itinry-open");
		});
	}
	catch(e)
	{
		console.log("Error in loadbooking summary"+ e);
	}
}


function res_gettoken(crsaccount)
{
	try
	{
		var serverurl = jQuery('#loadingurl').val();
		var groupcode = jQuery('#groupcode').val();
		var hotelcode = jQuery('#hotel_code').val();
		
		if(crsaccount == 1)
			var param1 = 'GroupCode='+groupcode+'&action=gettoken';
		else
			var param1 = 'HotelId='+hotelcode+'&action=gettoken';
		
		getUrl=serverurl+'multiproperty_service.php';
		jQuery.ajax({
			type: "POST",
			url: getUrl,
			data: param1,
			success: function(response) {
				var token_val=$.trim(response);
				jQuery("input[name='restoken']").remove();
				jQuery("header.GetToken").append("<input type='hidden' name='restoken' id='restoken' value=''>");
				jQuery("#restoken").val(token_val);
			},
			complete: function(){
					
			}
		});
	}
	catch(err){
		console.log('error message res_gettoken');
		console.log(err);
	}
}

function changecurrency(tocurrency,forCRSGroup,currentfilename,basecurrency) //Pinal - 8 January 2019 - Purpose : Multiple property listing currency conversion
{
    try
    {
		if(tocurrency != basecurrency)
		{
			jQuery('.sec-price').hide();
			jQuery('.pricefilter').hide();
		}
		else
		{
			jQuery('.sec-price').show();
			jQuery('.pricefilter').show();
		}
		
		if(currentfilename=='roomlisting.php')
		{
			changecurrencyroomlisting(tocurrency);
			return false;
		}
		
		var fromcurrency=jQuery("#selected_curr").text().trim();
		//jQuery(".nav-currency .ctrl-item").click();
		if(fromcurrency==tocurrency)
		{
			return false;
		}
		
		jQuery("#selected_curr").text(tocurrency);
		jQuery("."+tocurrency).addClass("selectedCurr");
		jQuery("."+fromcurrency).removeClass("selectedCurr");
					
		var fromcurrencies='';
		for (var key in hotelgriddata)
		{
			if(hotelgriddata[key].available_room == 1)  /*&& hotelgriddata[key].o_currency_code!=tocurrency*/
			{
				jQuery('#rate_'+key).hide();
				jQuery('#rateview_rate_'+key).hide();
				
				//jQuery('#chk_availability_'+key).hide();
				jQuery(".availcheck").hide();
				//jQuery('#rateview_availability_'+key).hide();
				jQuery('#loader_'+key).show();
				jQuery('#rateview_loader_'+key).show();
				
				fromcurrencies+=hotelgriddata[key].o_currency_code+",";
			}
		}
		
		jQuery(".itn-price").append('<div class="loader"></div');
		jQuery(".itn-total").hide();
		jQuery(".itn-rooms").hide();
		jQuery(".itn-actions").hide();
		jQuery("#cart_proceed").hide();
		
		if(fromcurrencies=="")
		{
			return false;
		}
		
        if(forCRSGroup == '1')
        {
            var GroupCode = jQuery("#groupcode").val();
            var parm = 'GroupCode='+GroupCode+'&crsaccount='+forCRSGroup;
        }
        else
        {
            var HotelId = jQuery("#hotel_code").val();
            var parm = 'HotelId='+HotelId+'&crsaccount='+forCRSGroup;
        }
		
        var serverurl=jQuery('#loadingurl').val();
		
        jQuery.ajax({
            url: serverurl+'multiproperty_service.php?'+parm,
            type: "POST",
            data: {
                action:"getexchangerate",
                from:fromcurrencies,
                to:tocurrency,
                },
            success: function(data){
				var response=JSON.parse(data);
				if (response.length<1)
				{
					swal({
						title: "",
						text: "Sorry , Couldn't find conversion rate for selected currency. Please try again later.",
						type: 'error',
						animation:true	,
						closeOnConfirm: true,
					},
					function(){
						
						//Chinmay Gandhi - 23rd Aug 2019 - Start
						//Purpose : Display Issue When Currency Fail
						for(var key in hotelgriddata)
						{
							if(hotelgriddata[key].available_room == 1)
							{
								jQuery('#chk_availability_'+key).show();
								jQuery('#rate_'+key).show();
								jQuery('#rateview_rate_'+key).show();
							}
						}
						//Chinmay Gandhi - 23rd Aug 2019 - End
						
						//jQuery('.price').show();
						jQuery('.loader').hide();
						jQuery("#selected_curr").text(fromcurrency);
						
						jQuery("."+fromcurrency).addClass("selectedCurr");
						jQuery("."+tocurrency).removeClass("selectedCurr");
						
						//jQuery(".availcheck").show();
						jQuery(".itn-price .loader").remove();
						jQuery(".itn-total").show();
						jQuery(".itn-rooms").show();
						jQuery("#cart_proceed").show();
						jQuery(".itn-actions").show();
					});
				}
				else
				{	
					var currsign=tocurrency;
					for (var key in hotelgriddata)
					{
						if(hotelgriddata[key].available_room == 1)  /*&& hotelgriddata[key].o_currency_code!=tocurrency*/
						{
							var splitted=response[hotelgriddata[key].o_currency_code+"-"+tocurrency].split("|");
							
							if(splitted[0]==0 || splitted[0]==0)
							{
								swal({
								title: "",
								text: "Sorry , Couldn't find conversion rate for selected currency. Please try again later.",
								type: 'error',
								animation:true	,
								closeOnConfirm: true,
								},
								function(){
									jQuery('.price').show();
									jQuery('.loader').hide();
									jQuery("#selected_curr").text(fromcurrency);
									jQuery("."+fromcurrency).addClass("selectedCurr");
									jQuery("."+tocurrency).removeClass("selectedCurr");
									
									jQuery('#chk_availability_'+key).show();
									jQuery('#rateview_availability_'+key).show();
								});
							}
							else
							{
								var conversionvalue=getformattedval((parseFloat(hotelgriddata[key].o_min_rate)*parseFloat(splitted[0])).toFixed(splitted[1]),1);
								
								jQuery('#rate_'+key).show();
								jQuery('#rateview_rate_'+key).show();
								jQuery('#rate_'+key+' #min_rate').text(conversionvalue);
								jQuery('#rateview_rate_'+key+' #min_rate').text(conversionvalue);
								
								jQuery('#chk_availability_'+key).show();
								jQuery('#rateview_availability_'+key).show();
								jQuery('#loader_'+key).hide();
								jQuery('#rateview_loader_'+key).hide();
								
								var maingrid=jQuery('#'+key+'_main_grid');
								if(maingrid.attr('class') != undefined)//Chinmay Gandhi - Change logic 4 by 4 instead of 1 by 1 [ RES-2187 ]
								{
									var classes=maingrid.attr('class').split(" ");
									for(var i=0;i<classes.length;i++)
									{
										if(classes[i].indexOf("price_")>-1)
										{
											maingrid.removeClass(classes[i]);
											break;
										}
									}
									maingrid.attr('roomprice',conversionvalue).addClass('price_'+conversionvalue);
								}
								
								var mainlist=jQuery('#'+key+'_main_list');
								if(maingrid.attr('class') != undefined)//Chinmay Gandhi - Currency Conversion issue in the cart of MHBE. [ CurrencyConvestion_MHBE ]
								{
									var classes=mainlist.attr('class').split(" ");
									for(var i=0;i<classes.length;i++)
									{
										if(classes[i].indexOf("price_")>-1)
										{
											mainlist.removeClass(classes[i]);
											break;
										}
									}
									mainlist.attr('roomprice',conversionvalue).addClass('price_'+conversionvalue);
								}
								
								jQuery(".offer-price .currency").text(splitted[3]);
								hotelgriddata[key].conversion=splitted[0];
								hotelgriddata_general.conversion=splitted[0];
								currsign=splitted[3];
							}
						}
					}
					_Update_CartItem('',2,forCRSGroup,currsign);
				}
            },
            complete: function(response){
                
            }
        });
    }
    catch(e)
    {
        console.log("changecurrency _Error : ");
		console.log(e);
    }
}

function getcurrencyconversion(forCRSGroup,fromcurrency,tocurrency) //Pinal - 8 January 2019 - Purpose : Multiple property listing currency conversion
{
	try
	{
		if(forCRSGroup == '1')
        {
            var GroupCode = jQuery("#groupcode").val();
            var parm = 'GroupCode='+GroupCode+'&crsaccount='+forCRSGroup;
        }
        else
        {
            var HotelId = jQuery("#hotel_code").val();
            var parm = 'HotelId='+HotelId+'&crsaccount='+forCRSGroup;
        }
		
		jQuery.ajax({
            url: serverurl+'multiproperty_service.php?'+parm,
            type: "POST",
            data: {
                action:"getcurrencyconversion",
                from:fromcurrency,
                to:tocurrency,
                },
            success: function(data){
				return data;
            },
            complete: function(response){
                
            }
        });
	}
    catch(e)
    {
        console.log("getcurrencyconversion _Error : "+e);
    }
}

function _isHackattemt(crsaccount)
{
	try
	{
		var HotelId = jQuery('#hotel_code').val();
		var serverurl = jQuery('#loadingurl').val();
		var groupcode = jQuery('#groupcode').val();
			
		var message_title = js_stripslashes(langjs[0]["lblHangon"]);
		var message =js_stripslashes(langjs[0]["lblSessionExpired"]);
		var message_btn =js_stripslashes(langjs[0]["L_Pleaserefreshpage"]);
	
		swal({
			title: message_title,
			text: message,
			type: "warning",
			confirmButtonText: message_btn,
			showCancelButton: false,
			confirmButtonColor: "#DD6B55",
			animation:false
			},
			function(){
				var selectedLang = jQuery('#selectedLang').val();
				if(crsaccount == 1)
					window.location.href=serverurl+'roomlisting-'+groupcode+'-'+HotelId+selectedLang;
				else
					window.location.href=serverurl+'roomlist-'+HotelId+selectedLang;
			}
		);
	}
    catch(e)
    {
        console.log("_isHackattemt _Error : "+e);
    }
}

//Pinal - 15 January 2019 - START
//Purpose : Multiple property listing GDPR
function gdprcookie(crsaccount)
{
	try
	{
		var GroupCode = jQuery("#groupcode").val();
		var HotelId = jQuery("#hotel_code").val();
		
		if(crsaccount == 1)
			var keyname="cookieconsentmulti_"+jQuery("#groupcode").val();
		else
			var keyname="cookieconsentmulti_"+jQuery("#hotel_code").val();
		
		var name = keyname + "=";
		var ca = document.cookie.split(';');
		var cookie_value='';
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {			    
				cookie_value=c.substring(name.length,c.length)
			}
		}
		if(cookie_value!='true')
		{
			jQuery("#cookieconsentmsg").show();
		}
		
		jQuery("#cookieconsent").on('click',function(){
			jQuery("#cookieconsentmsg").hide();
			
			var expiryDate = new Date();
			expiryDate.setDate(expiryDate.getDate() + 365);
			document.cookie = keyname+"="+"true;expires="+expiryDate.toUTCString();
		});
	}
	catch(e)
	{
		console.log("gdprcookie _Error :");
		console.log(e);
	}
}
//Pinal - 15 January 2019 - END

//Pinal - 22 January 2019 - START
//Purpose : Multiple property listing statistics data.
function insertstatsdata(defaultentry)
{
	try
	{
		var checkin=jQuery('.src-dates #checkin').val();
		checkin=(checkin!='' && checkin!=undefined)?checkin:arrival_date;
		
		var checkout=jQuery('.src-dates #checkout').val();
		checkout=(checkout!='' && checkout!=undefined)?checkout:checkout_date;
		
		if(crsaccount=='1')
		{
			$.ajax({
			    url: serverurl+'multiproperty_service.php',
			    type: "POST",
			    data: {
				    action: 'selectHotel',
					GroupCode : jQuery("#groupcode").val(),
				    HotelId: jQuery("#hotel_code").val(),
				    arrival_date:checkin,
					checkout: checkout,
				    adult:1,
				    child:0,
				    offer_rates: '',
				    promotional_code:'',
					_TrackId:'',
					defaultentry:defaultentry
			    },
			    dataType: "html",
			    success: function(data)
			    {
				    
			    }
		    });
		}
		else
		{
			$.ajax({
			    url: serverurl+'multiproperty_service.php',
			    type: "POST",
			    data: {
				    action: 'CheckAvailDataHotel',
				    HotelId: jQuery("#hotel_code").val(),
				    arrival_date:checkin,
					checkout: checkout,
				    adult:1,
				    child:0,
				    offer_rates: '',
				    promotional_code:'',
					_TrackId:''
			    },
			    dataType: "html",
			    success: function(data)
			    {
				    
			    }
		    });
		}
	}
	catch(e)
	{
		console.log("insertstatsdata _Error : ");
		console.log(e);
	}
}
//Pinal - 22 January 2019 - END
function _getHotelPerScroll(cnt)
{
	try{
		var pageIndex = 2;
		jQuery(window).on('scroll', function(){
			if ($(window).scrollTop() == $(document).height() - $(window).height()){
				if (pageIndex < cnt)
				{
					var serverurl=jQuery('#loadingurl').val();
					var GroupCode = jQuery("#groupcode").val();
					var HotelId = jQuery("#hotel_code").val();
					var parm = 'GroupCode='+jQuery("#groupcode").val()+'&scrollflag=1';
					var getUrl = serverurl+'multihotellist.php';
			
					jQuery.ajax({
						url: getUrl,
						type: "POST",
						dataType: "html",
						data: parm,
						success: function(response){
							var room_result = jQuery(response).find('.apply-room-operation');
							var rate_result = jQuery(response).find('.apply-rate-operation');
							var hotel_list = jQuery(response).find('#Hotel_List');
							if(hotel_list.val() != '')
							{
								$.each(JSON.parse(hotel_list.val()), function(key, val) {
									var imageViewer = jQuery(response).find('#lightgallery_'+key);
									jQuery('.demo-gallery').append(imageViewer);
									pageIndex++;
								});
							}
							jQuery('.apply-room-operation').append(room_result.html());
							jQuery('.apply-rate-operation').append(rate_result.html());
							
							jQuery('#Hotel_List').val(hotel_list.val());
						},
						complete: function(response){
							_getRoomsRatesAvailability();
							_loader('Hide');
						}
					});
				}
			}
		});
	}
	catch(e)
	{
		console.log("_getHotelPerScroll _Error : ");
		console.log(e);
	}
}

//Pinal - 21 January 2019 - START
//Purpose : Multiple property listing statistics data.
function insertHotelBEstats(serverurl)
{
	try
	{			
		$.ajax({
			url: serverurl+'multiproperty_service.php',
			type: "POST",
			data: {
				action: 'CheckAvailData',
				HotelId: jQuery('#Hotel_List').val(),
				GroupCode: jQuery('#groupcode').val(),
				arrival_date: jQuery('#CheckIn').val(),
				adult:1,
				child:0,
				nights: jQuery(".cnt-nights .sr-only").text(),
				offer_rates: '',
				promotional_code:'',
				_TrackId:$("#_TrackId").val(),
				destination:(jQuery('#destination').val()!='')?jQuery('#destination').val():'',
				destinationsearch:(jQuery("#destination").attr('option')!='')?jQuery("#destination").attr('option'):'',
			},
			success: function(data)
			{
				$("#_TrackId").val(jQuery.trim(data));
			}
		});
	}
	catch(e)
	{
		console.log("insertHotelBEstats _Error :");
		console.log(e);
	}
}
//Pinal - 21 January 2019 - END

//Pinal - 5 February 2019 - START
//Purpose : Multiple property listing
function getGDPRDetails(gdproemunkid,companyname,websitelink,email,response)
{
	try
	{
		var res=response.trim();
		res = res.replace(/\{companyname}/g,companyname);
		res = res.replace(/\{email}/g,email);
		res = res.replace(/\{websitelink}/g,websitelink);
		
		if(gdproemunkid!='1')
		   res = res.replace(/\{oemhide}/g,"display:none");
		else
		   res = res.replace(/\{oemhide}/g,"");
		
		if(websitelink=='')
		   res = res.replace(/\{websitedisplay}/g,"display:none");
		else
		   res = res.replace(/\{websitedisplay}/g,"");
		
		if(email=='')
		   res = res.replace(/\{displayemail}/g,"display:none");
		else
		   res = res.replace(/\{displayemail}/g,"");
		
		jQuery("#gdprdetail").html(res);
	}
	catch(e)
	{
		console.log("getGDPRDetails _Error :");
		console.log(e);
	}
}
//Pinal - 5 February 2019 - END

//Apply Promotion - Start
function apply_promotion(flag)
{
	try
	{
		var crsaccount = jQuery("#crsaccount").val();
		_checksession('1',crsaccount);
		
		if(jQuery('#promotion').val() == '' && flag!='2')
		{
			swal({
				title:js_stripslashes(langjs[0]["L_Promo_Msg5"]),
				type: "warning",
			});
			return false;
		}
		
		if(flag == '2')
		{
			var serverurl = jQuery('#loadingurl').val();
			var GroupCode = jQuery("#groupcode").val();
			var HotelId = jQuery("#hotel_code").val();
		
			if(jQuery('#crsaccount').val() == '1')
				var parm1 = 'action=updated_session_data&GroupCode='+GroupCode+'&HotelId='+jQuery("#foldername").val()+'&flag=2';
			else
				var parm1 = 'action=updated_session_data&HotelId='+HotelId+'&flag=2';

			$.ajax({
				url: serverurl+'common/multiproperty_function.php',
				type: "POST",
				data: parm1,
				success: function(data){
					if(Object.keys(jQuery.parseJSON(data)).length > 0)
					{
						swal({
							title:js_stripslashes(langjs[0]["L_Promo_Msg6"]),
							text:js_stripslashes(langjs[0]["L_Promo_Msg7"]),
							type: "warning",
							showCancelButton: true,
							confirmButtonClass: "btn-danger",
							confirmButtonText: langjs[0]["L_Swal_Yes"],
							closeOnConfirm: true
						},
						function(result){
							if(result == true)
								manage_promotion(flag);
						});
					}
					else
					{
						manage_promotion(flag);
					}
				}
			});
		}
		else
		{
			manage_promotion(flag);
		}
	}
	catch(e)
	{
		console.log("apply_promotion _Error :");
		console.log(e);
	}
}
	
function manage_promotion(flag)
{
	try
	{
		_loader('Show');
		var serverurl = jQuery('#loadingurl').val();
		var GroupCode = jQuery("#groupcode").val();
		var HotelId = jQuery("#hotel_code").val();
		var crsaccount = jQuery("#crsaccount").val();
		var checkin=jQuery('.src-dates #checkin').val();
		var checkout=jQuery('.src-dates #checkout').val();
		
		In_date = checkin.replace(/-| |,|_/g,'_');
		Out_date = checkout.replace(/-| |,|_/g,'_');

		if(crsaccount == 1)
		{
			var parm = 'checkIn='+In_date+'&checkOut='+Out_date+'&Promotion='+encodeURIComponent(jQuery('#promotion').val())+'&flag='+flag;//Chinmay Gandhi - Add promocode as e urlencode [ PROMO_SPACE_ISSUE ]
			var getUrl = serverurl+'roomlisting-'+GroupCode+'-'+jQuery("#foldername").val()+jQuery('#selectedLang').val();
		}
		else
		{
			var parm = 'checkIn='+In_date+'&checkOut='+Out_date+'&Promotion='+encodeURIComponent(jQuery('#promotion').val())+'&flag='+flag;//Chinmay Gandhi - Add promocode as e urlencode [ PROMO_SPACE_ISSUE ]
			var selectedLang = jQuery('#selectedLang').val();
			var getUrl = serverurl+'roomlist-'+HotelId+selectedLang;
		}
		
		jQuery.ajax({
			url: getUrl,
			type: "POST",
			dataType: "html",
			data: parm,
			success: function(response){
				var dom = $(response);

				var _result = dom.find('#manage_search_data').html();
				var manage_bar = dom.find('#hotel_managebar').html();
				var popup_result = dom.find('#_roomdetail_popup').html();
				var detail_info_popup = dom.find('#detail_info_popup').html();
				var mapData = dom.find('#mapData').html();
				var book_another_box = dom.find('#book_another_box').html();//Chinmay Gandhi - Book another property [ RES-1992 ]
				var roomgalary = dom.find('#roomgalary').html();
				var roomdata = jQuery(_result).find('.roomlist');
				var promo_result = dom.find('#promoflag').val();
				
				if(roomdata.length == 0)
				{
					swal({
						title:js_stripslashes(langjs[0]["L_Promo_Msg3"]),
						text:js_stripslashes(langjs[0]["L_Promo_Msg4"]),
						type: "error",
					});
					_loader('Hide');
					return;
				}
				
				jQuery('#hotel_managebar').html(manage_bar);
				jQuery('#_roomdetail_popup').html(popup_result);
				jQuery('#detail_info_popup').html(detail_info_popup);
				jQuery('#mapData').html(mapData);
				jQuery('#book_another_box').html(book_another_box);//Chinmay Gandhi - Book another property [ RES-1992 ]
				jQuery('#roomgalary').html(roomgalary);
				jQuery('.remodal-wrapper').remove();
				jQuery('.remodal').remodal();
				jQuery('#manage_search_data').html(_result);
				getMap(jQuery('#hcode').val());
				
				insertstatsdata();
				_applysorting(1,0);
				
				var dom = $(response);
				dom.filter('script').each(function(){
					var text=this.text;
					if(text.indexOf("var Date_Range=")>-1 && text.indexOf("var resgrid=")>-1)
					{
						$.globalEval(text);
					}
				});
			},
			complete: function(response){
				
				var roomdata = jQuery(response.responseText).find('.roomlist');
				if(roomdata.length == 0)
					return false;
				
				jQuery(".promodd .ctrl-item").click(function (e) {
					if(!jQuery(e.target).hasClass("material-icons") && jQuery('.currencylist:visible').length == 0)
						jQuery(this).next(".dropdown-box").slideToggle(150);
				});
				var promo_result = jQuery(response.responseText).find('#promoflag').val();
				convertcurrencyroomlisting(conversion_rate);
				
				if(jQuery('#ratesview').hasClass('active'))
					_roomlistchangeview(1,'');
				else
					_roomlistchangeview(0,'');
					
				apply_filter(1);
				jQuery(".viewrows").click(function(){
					jQuery(this).toggleClass("triggered");
					jQuery(this).parent().parent().parent().siblings(".toggletypes").slideToggle(150);
					return false;
				});
				jQuery('.viewbyRates').find('.viewrows').each(function(e) {
					jQuery(this).click();
				});
				jQuery('.closesearch').click();
				
				if(promo_result == '0')
				{
					//jQuery('.old-rate').hide();//kishan Tailor 5th April 2021 [purpose:Comment show strike Rate RES-2619 
					jQuery('.promo_unlock').hide();
				}
				
				if(jQuery('#crsaccount').val() == '1')
					var parm1 = 'action=updated_session_data&GroupCode='+GroupCode+'&HotelId='+jQuery("#foldername").val()+'&flag=1';
				else
					var parm1 = 'action=updated_session_data&HotelId='+HotelId+'&flag=1';
					
				$.ajax({
					url: serverurl+'common/multiproperty_function.php',
					type: "POST",
					data: parm1,
					success: function(data){
						
					},
					complete: function(data){
						var result = data.responseText.trim();
						if(result == 1)
						{
							_loader('Hide');
							swal({
								title:js_stripslashes(langjs[0]["L_Promo_Msg3"]),
								text: js_stripslashes(langjs[0]["L_Promo_Msg4"]),
								type: "error",
							});
						}
						else
						{
							var cartdata = [];
							if(jQuery.parseJSON(result).length != 0)
							{
								cartdata = jQuery.parseJSON(result);
								$.each(cartdata, function(Index,Item) {
									var get_identity = '';
									if(Item['Identity'] == 0)
									{
										if(Item['RateIdenty'] == 0)
											get_identity = jQuery('.viewbyRooms').find('input[name=Rate_'+Item['RateId']+']').attr('id');
										else
											get_identity = jQuery('.viewbyRooms').find('input[name=Package_'+Item['RateId']+']').attr('id');
									}
									else
									{
										if(Item['RateIdenty'] == 0)
											get_identity = jQuery('.viewbyRates').find('input[name=Rate_'+Item['RateId']+']').attr('id');
										else
											get_identity = jQuery('.viewbyRates').find('input[name=Package_'+Item['RateId']+']').attr('id');
									}
									
									var updated_identity = get_identity.split('_');
									Item['Updated_Identity'] = updated_identity[2]+'_'+updated_identity[3];
								});
							}
							
							if(jQuery('#crsaccount').val() == '1')
								var parmup = 'action=after_promo_upcart&GroupCode='+GroupCode+'&HotelId='+jQuery("#foldername").val()+'&cartdata='+JSON.stringify(cartdata);
							else
								var parmup = 'action=after_promo_upcart&HotelId='+HotelId+'&cartdata='+JSON.stringify(cartdata);
								
							$.ajax({
								url: serverurl+'common/multiproperty_function.php',
								type: "POST",
								data: parmup,
								success: function(data){
									
								},
								complete: function(data){
									_Update_CartItem(data.responseText,1,jQuery('#crsaccount').val(),0);
								}
							});
								
							jQuery('#promotion').val('');
							_loader('Hide');
						}
					}
				});
				
				if(flag == '1' && flag != '2' && promo_result == '1')
				{
					_loader('Hide');
					swal({
						title: js_stripslashes(langjs[0]["L_Promo_Msg1"]),
						text:js_stripslashes(langjs[0]["L_Promo_Msg2"]),
						type: "success",
					});
				}
				else if(flag == '1' && flag != '2' && promo_result == '0')
				{
					swal({
						title:js_stripslashes(langjs[0]["L_Promo_Msg3"]),
						text:js_stripslashes(langjs[0]["L_Promo_Msg4"]),
						type: "error",
					});
				}
				_loader('Hide');
			}
		});
	}
	catch(e)
	{
		console.log("manage_promotion _Error :");
		console.log(e);
	}
}
//Apply Promotion - End

//Falguni Rana - Round Off issue, multiplereturn - either 0 or 1, 1 for Round Off
function getTax2(roomcharge,taxarray,decimalplaces,flag,BaseRate,AdultRate,ChldRate,base_adult,base_child,callfor,EA,EC,multiplereturn,display_decimalplace)//,flag=0
{
	try
	{
        multiplereturn = multiplereturn || '0';
        display_decimalplace = display_decimalplace || decimalplaces;
        multiplereturn = parseInt(multiplereturn);
		if (eval(taxarray)[0]==0) {
            return 0;
        }
        
		if (typeof flag == 'undefined')
			flag=0;
		if (typeof BaseRate == 'undefined')
			BaseRate=0;
		if (typeof AdultRate == 'undefined')
			AdultRate=0;
		if (typeof ChldRate == 'undefined')
			ChldRate=0;	
		if (typeof callfor == 'undefined')
			callfor='base';	
		if (typeof EA == 'undefined')
			EA=0;
		if (typeof EC == 'undefined')
			EC=0;	
			
		if (typeof base_adult == 'undefined')
			base_adult=0;
		if (typeof base_child == 'undefined')
			base_child=0;
			
		var v_amount=parseFloat(roomcharge).toFixed(decimalplaces);  
		var realamt=v_amount;
		var cnt=0;
		var JSONobject=eval(taxarray);
		var taxamt=new Array();
		var slab=new Array();
		var potype=new Array();
		var porule=new Array();
		var exrate1=new Array();
		var exrate2=new Array();
		
		var taxapplyafter=new Array();
		var taxunkid=new Array();
		var applyonrackrate=new Array();
		
		if(JSONobject=='')
			return 0;
		   
		jQuery.each(JSONobject, function(jsonKey, jsonValue) {
			jQuery.each(jsonValue,  function(Key, Value) {
					jQuery.each(Value, function(k1, v1) {				
							if(k1=='amount')
								taxamt.push(Value[k1]);
							if(k1=='slab')
								slab.push(Value[k1]);
							if(k1=='postingtype')
								potype.push(Value[k1]);
							if(k1=='postingrule') 
								porule.push(Value[k1]);
							if(k1=='exchange_rate2')
								exrate2.push(Value[k1]);
							if(k1=='exchange_rate1')
								exrate1.push(Value[k1]);
							
							if(k1=='taxapplyafter')
								taxapplyafter.push(Value[k1]);
							if(k1=='taxunkid')
								taxunkid.push(Value[k1]);
							if(k1=='applyonrackrate')
								applyonrackrate.push(Value[k1]);
								
							cnt++;	
					});				
				});	
		});
		
		var exchange_rate1=0;
		var exchange_rate2=0;
		var postingtype;
		var postingrule;
		var v_taxamount=0;
		var v_slab;
		var totaltax=0;
		var rounded_totaltax=0;
		var taxretarr=new Array();
		
		if(typeof(taxamt[0])!='undefined')
		{
			for(i=0;i<taxamt[0].length;i++)
			{			
				v_taxamount=taxamt[0][i];
				postingtype=potype[0][i];
				postingrule=porule[0][i];
				exchange_rate2=exrate2[0][i];
				exchange_rate1=exrate1[0][i];
				v_slab=slab[0][i];
				v_taxapplyafter=taxapplyafter[0][i];
				v_taxunkid=taxunkid[0][i];
				v_applyonrackrate=applyonrackrate[0][i];
				
				var v_tamount=0;
				var v_camount=0;
				if(v_taxamount!='undefined' && exchange_rate2!='undefined' && exchange_rate1!='undefined' && postingtype!='undefined' && postingrule!='undefined')
				{
					if(!parseInt(flag))
					{
						if(parseInt(v_applyonrackrate))
						{
							if(EA==0 && EC==0)
							{
								if(callfor=='base') v_amount=BaseRate;
								if(callfor=='extraadult') v_amount=AdultRate;
								if(callfor=='extrachild') v_amount=ChldRate;
							}
							else
							{
								v_amount=parseFloat(BaseRate)+parseFloat(AdultRate)*parseFloat(EA)+parseFloat(ChldRate)*parseFloat(EC);
							}
							
							v_amount=parseFloat(v_amount).toFixed(decimalplaces);  
						}
						else
						{
							v_amount=realamt;	
						}	
					}
					
					v_btaxapplyafter=0;
					v_ctaxapplyafter=0;
					if(v_taxapplyafter!='')
					{
						for(taxkey in taxretarr)
						{
							if((","+v_taxapplyafter+",").indexOf(","+taxkey+",")!=-1)
							{
								v_btaxapplyafter+=parseFloat(taxretarr[taxkey][0]);
								v_ctaxapplyafter+=parseFloat(taxretarr[taxkey][1]);
							}
						}
					}
					
					if(postingtype=='FLATPERCENTAGE')
					{
						v_tamount = parseFloat(v_tamount) + parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100;
						v_camount = parseFloat(v_camount) + parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100;
						v_camount = roundNumber(v_camount,decimalplaces);
						totaltax = parseFloat(totaltax) + parseFloat(v_camount.toFixed(decimalplaces));
						if(multiplereturn==1) rounded_totaltax = parseFloat(rounded_totaltax) + parseFloat(v_camount.toFixed(display_decimalplace));
						taxretarr[v_taxunkid]=new Array(parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100,parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100);
					}
					else if(postingtype=='FLATAMOUNT')
					{
						if(postingrule!='')
						{
							if(postingrule == "PERADULT")
								v_taxamount = parseFloat(v_taxamount) * parseFloat(base_adult);
							
							if(postingrule == "PERCHILD")
								v_taxamount = parseFloat(v_taxamount) * parseFloat(base_child);
								
							if(postingrule == "PERPAX")
								v_taxamount = parseFloat(v_taxamount) * (parseFloat(base_adult) + parseFloat(base_child));	
						}
						v_tamount = parseFloat(v_tamount) + parseFloat(v_taxamount);
						v_camount = parseFloat(v_camount) + (parseFloat(v_tamount) * parseFloat(exchange_rate1)/parseFloat(exchange_rate2));
						totaltax = parseFloat(totaltax) + parseFloat(v_camount.toFixed(decimalplaces));
						if(multiplereturn==1) rounded_totaltax = parseFloat(rounded_totaltax) + parseFloat(v_camount.toFixed(display_decimalplace));
						taxretarr[v_taxunkid]=new Array(v_taxamount,v_camount);
					}
					else if(postingtype=='SLAB')
					{
						v_taxslab = v_slab.split(",");	
						for(iSlab=0;iSlab<v_taxslab.length;iSlab++)
						{
							v_taxslab1=v_taxslab[iSlab].split("-");
							v_slabstart	  =  v_taxslab1[0];
							v_slabend 	  =  v_taxslab1[1];
							v_slabpercent =  v_taxslab1[2];
						   
							if((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) >= parseFloat(v_slabstart) && (parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) <= parseFloat(v_slabend))
							{
								v_tamount = ((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100;
								v_camount = ((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100;
								v_camount = roundNumber(v_camount,decimalplaces);
								totaltax = parseFloat(totaltax) + parseFloat(v_camount.toFixed(decimalplaces));
								if(multiplereturn==1) rounded_totaltax = parseFloat(rounded_totaltax) + parseFloat(v_camount.toFixed(display_decimalplace));
								
								//Chandrakant - 30 Oct 2019 - START
								//Purpose : RES-2287 - v_taxamount getting 0. After referring Manual Add Reservation logic, I have replace it to v_slabpercent
								//taxretarr[v_taxunkid]=new Array(parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100,parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_taxamount) / 100);
								taxretarr[v_taxunkid]=new Array(parseFloat((parseFloat(v_amount)+parseFloat(v_btaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100,parseFloat((parseFloat(v_amount)+parseFloat(v_ctaxapplyafter)) * parseFloat(exchange_rate2)/parseFloat(exchange_rate1)) * parseFloat(v_slabpercent) / 100);
							}	
						}
					}	
				}//Undefined
			}
			var amt=totaltax;
			if(multiplereturn==1) return rounded_totaltax.toFixed(display_decimalplace).toString()+'<>'+amt.toFixed(decimalplaces).toString();
			return amt.toFixed(decimalplaces);
		}
		else
			return 0;
   }
   catch(err){
		console.log("Error - getTax - ");
		console.log(err);
   }
}
function addCommas(nStr,langcode){
	nStr+="";x=nStr.split(".");x1=x[0];x2=x.length>1?"."+x[1]:"";var rgx=/(\d+)(\d{3})/;while(rgx.test(x1))x1=x1.replace(rgx,"$1"+","+"$2");
	
	if(langcode=='fr')	
	{
		var tmpnum=x1+x2;
		var res = tmpnum.replace(/,/g , " ");
		res=res.replace(".", ",");
		
		return res;
	}
	else
	{
	   return x1+x2;     
	}
}

function b64DecodeUnicode(str) {
	try{
		return decodeURIComponent(atob(str).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}
	catch(err){
		console.log("Error - b64DecodeUnicode : ");
		console.log(err);
	}	
}
function js_stripslashes(str){if(str!=""&&str!=null&&typeof str!="undefined"){str=str.replace(/\\'/g,"'");str=str.replace(/\\"/g,'"');str=str.replace(/\\0/g,"\x00");str=str.replace(/\\\\/g,"\\");return str}}
function js_addslashes(str) { if(str!=""&&str!=null&&typeof str!="undefined"){ return (str + '').replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\0/g, '\\0');}}

function fun_Integer(event){ 

	if ((event.keyCode >= 48 & event.keyCode <= 57) || (event.keyCode >= 96 & event.keyCode <= 105)) {
		return true;
	}
	if (event.keyCode >= 37 & event.keyCode <= 40) {
		if (event.keyCode == 38 )
		{
			if(parseInt(jQuery(this).val()) > 0)
			{
				jQuery(this).val(parseInt(jQuery(this).val())-1);
			}
		}
		if (event.keyCode == 40 )
		{
			if(parseInt(jQuery(this).val()) < 1000)
			{
				jQuery(this).val(parseInt(jQuery(this).val())+1);
			}
		}
		return true;
	}
	if (event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 46) {
		return true;
	}
	return false;
}
function setFocus(id)
{
	$("#"+id).focus();
}

//Pinal - 15 June 2019 - START
//Purpose : Cancel Booking
function valid(value)
{
    var patt=/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
    if(jQuery("input[name='emailmobile']:checked").val()=='email' && patt.test( value ))
    {
        //console.log("valid email");
        return true;
    }
    else if(jQuery("input[name='emailmobile']:checked").val()=='mobile')
    {
        //console.log("valid mobile");
        return true;
    }
    else
    {
        //console.log("elseeee : "+value.length);
        return false;
    }
}
//Pinal - 15 June 2019 - END

//Chinmay Gandhi - Book another property [ RES-1992 ] - Start
function book_another_property_popup(crsaccount,datesetting,timezone,getLocalDateTime,languagecode,pagetype)
{
	try{
		_loader('Show');
		var serverurl=jQuery('#loadingurl').val();
		
		if(crsaccount == 1)
			var param='GroupCode='+jQuery("#groupcode").val()+'&action=Book_Another_Property';
		else
			var param='HotelId='+jQuery("#hotel_code").val()+'&action=Book_Another_Property';
		
		jQuery.ajax({
			url: serverurl+'multibox.php',
			type: "POST",
			dataType: "html",
			data: param,
			success: function(data){
				
			},
			complete: function(data){
				var dom = $(data.responseText);
				var _result = dom.find('.container').html();
				jQuery('#book_another_property_popup').html(_result);

				//Chandrakant - 27 September 2022 - START
				//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
				var chekIndate = moment(jQuery('.src-dates #bap_checkin').val(), datesetting).format('dddd, MMMM D, YYYY');
				jQuery('.src-dates #bap_checkin').attr("aria-label", chekIndate);

				var chekOutdate = moment(jQuery('.src-dates #bap_checkout').val(), datesetting).format('dddd, MMMM D, YYYY');
				jQuery('.src-dates #bap_checkout').attr("aria-label", chekOutdate);
				//Chandrakant - 27 September 2022 - END
				
				languagecode=languagecode || '';
				var currentDate = moment(getLocalDateTime, 'MM-DD-YYYY').format(datesetting);
				jQuery('.src-dates #bap_checkin').daterangepicker({
					timeZone : timezone,
					singleDatePicker: true,
					locale:{format:datesetting,
						daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
						monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
					},
					minDate: currentDate,
					opens: 'right'
				}, function(start, end, label) {
					var diff_co_date = moment(jQuery('.src-dates #bap_checkout').val(), datesetting).format('YYYY-MM-DD');
					var diff = (new Date(diff_co_date) - new Date(start.format('YYYY-MM-DD')));

					//Chandrakant - 27 September 2022 - START
					//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
					ariaDateCheckIn = start.format("dddd, MMMM D, YYYY");
					jQuery('.src-dates #bap_checkin').attr("aria-label", ariaDateCheckIn);
					//Chandrakant - 27 September 2022 - END

					if(diff > 0)
					{
						jQuery('.src-dates #bap_checkin').data('daterangepicker').setStartDate(start.format(datesetting));
						jQuery('.src-dates #bap_checkin').data('daterangepicker').setEndDate(start.format(datesetting));
					}
					else
					{
						var startdate = start.format(datesetting);
						var new_date = moment(startdate, datesetting).add(1, 'd');

						//Chandrakant - 27 September 2022 - START
						//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
						ariaDateCheckout = new_date.format("dddd, MMMM D, YYYY");
						jQuery('.src-dates #bap_checkout').attr("aria-label", ariaDateCheckout);
						//Chandrakant - 27 September 2022 - END

						var date = new_date.format('DD') + '-' + new_date.format('MM') + '-' + new_date.format('YYYY');
						var diffformet = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
						var diff = (new Date(diffformet) - new Date(start.format('YYYY-MM-DD')));
						jQuery('.src-dates #bap_checkin').data('daterangepicker').setStartDate(start.format(datesetting));
						jQuery('.src-dates #bap_checkin').data('daterangepicker').setEndDate(start.format(datesetting));
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(moment(date, 'DD-MM-YYYY').format(datesetting));
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(moment(date, 'DD-MM-YYYY').format(datesetting));
					}
					jQuery('#bap_Nights').html(diff/1000/60/60/24);
				});
				
				jQuery('.src-dates #bap_checkout').daterangepicker({
					timeZone : timezone,
					singleDatePicker: true,
					locale:{format:datesetting,
						daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
						monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
					},
					minDate: currentDate,
					opens: 'left'
				}, function(start, end, label) {
					jQuery("#bap_searchbtnclicked").val(1);
					var diff_ci_date = moment(jQuery('.src-dates #bap_checkin').val(), datesetting).format('YYYY-MM-DD');
					var diff = (new Date(start.format('YYYY-MM-DD')) - new Date(diff_ci_date));
					
					//Chandrakant - 27 September 2022 - START
					//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
					ariaDateCheckout = start.format("dddd, MMMM D, YYYY");
					jQuery('.src-dates #bap_checkout').attr("aria-label", ariaDateCheckout);
					//Chandrakant - 27 September 2022 - END

					if(diff > 0)
					{
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(start.format(datesetting));
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(start.format(datesetting));
					}
					else
					{
						var startdate = start.format(datesetting);
						var new_date = moment(startdate, datesetting).add(1, 'd');
						var date = new_date.format('DD') + '-' + new_date.format('MM') + '-' + new_date.format('YYYY');
						var diffformet = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
						var diff = (new Date(diffformet) - new Date(start.format('YYYY-MM-DD')));
						jQuery('.src-dates #bap_checkin').data('daterangepicker').setStartDate(start.format(datesetting));
						jQuery('.src-dates #bap_checkin').data('daterangepicker').setEndDate(start.format(datesetting));
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(moment(date, 'DD-MM-YYYY').format(datesetting));
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(moment(date, 'DD-MM-YYYY').format(datesetting));
					}
					jQuery('#bap_Nights').html(diff/1000/60/60/24);
				});
				
				jQuery('#bap_checkin').on('hide.daterangepicker', function(ev, picker) {
					jQuery(this).on('apply.daterangepicker', function(ev, picker) {
						var currentDate = moment(jQuery('.src-dates #bap_checkin').val(), datesetting).add(1,'days');
						jQuery("#bap_searchbtnclicked").val(1);
						jQuery('.src-dates #bap_checkout').daterangepicker({
							timeZone : timezone,
							singleDatePicker: true,
							locale:{format:datesetting,
								daysOfWeek:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].daysOfWeek:''),
								monthNames:((datepickerlocale[languagecode]!==undefined)?datepickerlocale[languagecode].monthNames:''),
							},
							minDate: currentDate,
							opens: 'left'
						}, function(start, end, label) {
							var diff_ci_date = moment(jQuery('.src-dates #bap_checkin').val(), datesetting).format('YYYY-MM-DD');
							var diff = (new Date(start.format('YYYY-MM-DD')) - new Date(diff_ci_date));

							//Chandrakant - 27 September 2022 - START
							//Purpose : RES-3133 - Added Aria Label so assistive technology can read for blind people
							ariaDateCheckout = start.format("dddd, MMMM D, YYYY");
							jQuery('.src-dates #bap_checkout').attr("aria-label", ariaDateCheckout);
							//Chandrakant - 27 September 2022 - END

							if(diff > 0)
							{
								jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(start.format(datesetting));
								jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(start.format(datesetting));
							}
							else
							{
								var startdate = start.format(datesetting);
								var new_date = moment(startdate, datesetting).add(1, 'd');
								var date = new_date.format('DD') + '-' + new_date.format('MM') + '-' + new_date.format('YYYY');
								var diffformet = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
								var diff = (new Date(diffformet) - new Date(start.format('YYYY-MM-DD')));
								jQuery('.src-dates #bap_checkin').data('daterangepicker').setStartDate(start.format(datesetting));
								jQuery('.src-dates #bap_checkin').data('daterangepicker').setEndDate(start.format(datesetting));
								jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(moment(date, 'DD-MM-YYYY').format(datesetting));
								jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(moment(date, 'DD-MM-YYYY').format(datesetting));
							}
							jQuery('#bap_Nights').html(diff/1000/60/60/24);
						});
						jQuery('#bap_checkout').trigger( "click" );
					});
				});
				
				jQuery("#book_another_property_popup .dropdown .ctrl-item").click(function (e) {
					if(!jQuery(e.target).hasClass("material-icons"))
					{
						jQuery(this).next(".dropdown-box").slideToggle(150);
					}
				});
				
				jQuery("#book_another_property_popup .lvl2").click(function (e) {
					if(jQuery(e.target).attr("value") != '')
					{
						jQuery('#bap_destination').val(jQuery(e.target).text());
						jQuery('#bap_destination').attr('option',jQuery(e.target).attr('value'));
						jQuery(this).next(".dropdown-box").slideToggle(150);
					}
				});
				
				jQuery("#bap_destination").keypress(function(event){
					var keycode = (event.keyCode ? event.keyCode : event.which);
					if(keycode == '13'){
						jQuery(".dropdown-box").slideUp(150);
						jQuery(this).parent(".ctrl-item").next(".dropdown-box").slideDown(150);
					}
				});
				jQuery(document).keyup(function(e){
					if(jQuery(".start-date").is(":focus")) jQuery(".dropdown-box").slideUp(150);
				});
				
				jQuery(".book-another").click(function(){
					jQuery('.closesearch').click();
				});
				
				if(pagetype == 1){
					jQuery(document).on("click",function(e) {
						if(!jQuery(e.target).hasClass("bap_managedestination") && !jQuery(e.target).hasClass("fz14") && !jQuery(e.target).hasClass("book_another_property_popup") && jQuery('.bap_destinationList:visible').length !== 0)
							jQuery('.dropdown .ctrl-item').next(".bap_destinationList").slideToggle(150);
					});
				}
			}
		});
		_loader('Hide');
	}
	catch(err){
		console.log("Error - book_another_property_popup : ");
		console.log(err);
	}
}

function _redirect_property(crsaccount,destinationtype,folderdetail,datesetting) //Prashant Patel - 21/09/2021 - Purpose : Add datesetting parameter [RES-2881]
{
	try{
		_loader('Show');
		var serverurl=jQuery('#loadingurl').val();
		var HotelId = jQuery('#hotel_code').val();
		var selectedLang = jQuery('#selectedLang').val();
		var groupcode = jQuery('#groupcode').val();
		var destination = jQuery("#bap_destination").attr('option');
	
		if(crsaccount == '1')
		{
			if((destinationtype == '1' || destinationtype == '2') && destination!='')
			{
				var localfolder = '';
				$.each(JSON.parse(folderdetail), function(key, val) {
					if(destination == key)
						localfolder = val;
				});
				
				In_date = jQuery('.src-dates #bap_checkin').val().replace(/-| |,|_/g,'_');
				Out_date = jQuery('.src-dates #bap_checkout').val().replace(/-| |,|_/g,'_');
				var url = serverurl+'roomlisting-'+groupcode+'-'+localfolder+selectedLang;
				//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --START
				var startDate = new Date(moment(In_date,datesetting).format('YYYY-MM-DD'));
				var endDate = new Date(moment(Out_date,datesetting).format('YYYY-MM-DD'));

				var difference = (endDate - startDate) / (86400000);
				if(difference > 90)
				{
					_loader('Hide');
						var message = langjs[0]["SWAL_morenightsnotallowed"];                                     
						var title_message = langjs[0]["SWAL_lblAccessRestricted"];
						swal({
							title: title_message,
							text: message,
							type: 'warning',
							animation:false	
						},function(){          
							var date = startDate;
							date.setDate(date.getDate() + 90);
							jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(moment(startDate).format(datesetting));
							jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(moment(startDate).format(datesetting));
							jQuery("#searchbtnclicked").val(1);
							jQuery('.cnt-nights span').html(90);
						});									 
						return false;
				}
				//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --END
			}
			else
			{
				var In_date = jQuery('.src-dates #bap_checkin').val();
				var Out_date = jQuery('.src-dates #bap_checkout').val();
				var url = serverurl+'chain-'+groupcode+selectedLang;
				//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --START
				var startDate = new Date(moment(In_date,datesetting).format('YYYY-MM-DD'));
				var endDate = new Date(moment(Out_date,datesetting).format('YYYY-MM-DD'));

				var difference = (endDate - startDate) / (86400000);
				
				if(difference > 90)
				{
					_loader('Hide');
						var message = langjs[0]["SWAL_morenightsnotallowed"];                                     
						var title_message = langjs[0]["SWAL_lblAccessRestricted"]; 
						swal({
							title: title_message,
							text: message,
							type: 'warning',
							animation:false	
						},function(){          
							var date = startDate;
							date.setDate(date.getDate() + 90);
							jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(moment(startDate).format(datesetting));
							jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(moment(startDate).format(datesetting));
							jQuery("#searchbtnclicked").val(1);
							jQuery('.cnt-nights span').html(90);
						});									 
						return false;
				}
				//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --END
			}
		}
		else
		{
			In_date = jQuery('.src-dates #bap_checkin').val().replace(/-| |,|_/g,'_');
			Out_date = jQuery('.src-dates #bap_checkout').val().replace(/-| |,|_/g,'_');
			var url = serverurl+'roomlist-'+HotelId+selectedLang;
			//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --START
			var startDate = new Date(moment(In_date,datesetting).format('YYYY-MM-DD'));
			var endDate = new Date(moment(Out_date,datesetting).format('YYYY-MM-DD'));

			var difference = (endDate - startDate) / (86400000);
			if(difference > 90)
			{
				_loader('Hide');
					var message = langjs[0]["SWAL_morenightsnotallowed"];                                     
					var title_message = langjs[0]["SWAL_lblAccessRestricted"];
					swal({
						title: title_message,
						text: message,
						type: 'warning',
						animation:false	
					},function(){          
						var date = startDate;
						date.setDate(date.getDate() + 90);
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setStartDate(moment(startDate).format(datesetting));
						jQuery('.src-dates #bap_checkout').data('daterangepicker').setEndDate(moment(startDate).format(datesetting));
						jQuery("#searchbtnclicked").val(1);
						jQuery('.cnt-nights span').html(90);
					});									 
					return false;
			}
			//Prashant Patel - 21/09/2021 - Purpose: Add restriction for Maxnights [RES-2881] --END
		}
		
		var form =	jQuery('<form action="' + url + '" method="post">' +
					 '<input type="text" name="checkIn" value="' + In_date + '" />' +
					 '<input type="text" name="checkOut" value="' + Out_date + '" />' +
					 '<input type="text" name="destination" value="' + destination + '" />' +
					 '</form>');
		jQuery('body').append(form);
		form.submit();
		
		_loader('Hide');
	}
	catch(err){
		console.log("Error -  Redirect Property : ");
		console.log(err);
	}
}
//Chinmay Gandhi - Book another property [ RES-1992 ] - End

//Chinmay Gandhi - 24th June 2019 - Start
//Purpose : Reviews for MHBE [ RES-2066 ]
function getReviewList(hotelcode,opt,isfilter)
{
	try{
		console.log('-----::');
		_loader('Show')
		var serverurl=jQuery('#loadingurl').val();
		var crsaccount = jQuery("#crsaccount").val();
		
		if(opt == 0){
			var source = stay = '';var sort = 'date_desc';
			
			if(typeof jQuery("#filter_source_"+hotelcode).val() !== "undefined"){
				if(isfilter == 1)
					source = jQuery("#filter_source_"+hotelcode).val();
			}

			if(typeof jQuery("#filter_sort_"+hotelcode).val() !== "undefined"){
				if(isfilter == 1)
					sort = jQuery("#filter_sort_"+hotelcode).val();
			}
				
			if(typeof jQuery("#filter_stay_"+hotelcode).val() !== "undefined"){
				if(isfilter == 1)
					stay = jQuery("#filter_stay_"+hotelcode).val();
			}
			
			if(crsaccount == 1){
				var param='GroupCode='+jQuery('#groupcode').val()+'&hotelcode='+hotelcode+'&offset=0&action=multihotelreview&sort='+sort+'&source='+source+'&Stay='+stay+'&StartDate=';
			}
			else
			{
				var param='HotelId='+jQuery('#hotel_code').val()+'&hotelcode='+hotelcode+'&offset=0&action=multihotelreview&sort='+sort+'&source='+source+'&Stay='+stay+'&StartDate=';
			}
		}
		else
		{
			var offset = jQuery('#offset_'+hotelcode).val();
			offset = parseInt(offset) + 5;
			if(crsaccount == 1){
				var param='GroupCode='+jQuery('#groupcode').val()+'&hotelcode='+hotelcode+'&offset='+offset+'&action=multihotelreview&sort='+jQuery("#filter_sort_"+hotelcode).val()+'&source='+jQuery("#filter_source_"+hotelcode).val()+'&Stay='+jQuery("#filter_stay_"+hotelcode).val()+'&StartDate='+jQuery("#lstdate_"+hotelcode).val();
			}
			else
			{
				var param='HotelId='+jQuery('#hotel_code').val()+'&hotelcode='+hotelcode+'&offset='+offset+'&action=multihotelreview&sort='+jQuery("#filter_sort_"+hotelcode).val()+'&source='+jQuery("#filter_source_"+hotelcode).val()+'&Stay='+jQuery("#filter_stay_"+hotelcode).val()+'&StartDate='+jQuery("#lstdate_"+hotelcode).val();
			}
		}
		
		jQuery.ajax({
			url: serverurl+'review_listing.php',
			type: "POST",
			dataType: "html",
			data: param,
			success: function(response){
				_loader('Hide');
				
				if(opt == 0 && isfilter != 1)
					jQuery('#reviews_'+hotelcode).html(jQuery(response).filter('#evaluations_data'));
				else if(opt == 1 && isfilter != 1)
					jQuery('.reviews_list_'+hotelcode).append(jQuery(response).find('#reviews_list').html());
				else
					jQuery('.reviews_list_'+hotelcode).html(jQuery(response).find('#reviews_list').html());
				
				jQuery('#offset_'+hotelcode).val(jQuery(response).find('#offset_'+hotelcode).val());
				jQuery('#lstdate_'+hotelcode).val(jQuery(response).find('#lstdate_'+hotelcode).val());
				jQuery('#OnlyBE_'+hotelcode).val(jQuery(response).find('#OnlyBE_'+hotelcode).val());
				
				var totReview = jQuery(response).find('#reviews_count_'+hotelcode).val();
				
				if(parseInt(totReview) >= 5)
					jQuery("#loadmore_section_"+hotelcode).show();
				else
					jQuery("#loadmore_section_"+hotelcode).hide();
				
				if(jQuery('#OnlyBE_'+hotelcode).val() == 1)
					jQuery("#loadmore_section_"+hotelcode).hide();
					
				applyfilter(hotelcode);
			},
			complete: function(response){
				
			}
		});
	}
	catch(err){
		console.log("Error - getReviewList : ");
		console.log(err);
	}
}
function helpfulclick(hotelcode,reviewmasterunkid)
{
	try
	{
		if(jQuery("#crsaccount").val() == 1){
			var param='GroupCode='+jQuery('#groupcode').val()+'&hotelcode='+hotelcode+'&action=helpfulclick&upvalue=1&reviewmasterunkid='+reviewmasterunkid;
		}
		else
		{
			var param='HotelId='+jQuery('#hotel_code').val()+'&hotelcode='+hotelcode+'&action=helpfulclick&upvalue=1&reviewmasterunkid='+reviewmasterunkid;
		}
		
		getUrl=jQuery('#loadingurl').val()+'common/multiproperty_function.php';
		jQuery.ajax({
			type: "POST",
			url: getUrl,
			data: param,
			success: function( data ){
				if(jQuery.trim(data)=='Success')
				{
					jQuery("#dismessage_"+reviewmasterunkid).text(js_stripslashes(langjs[0]["L_ReviewReply1"]));
					jQuery("#dismessage_"+reviewmasterunkid).removeClass().addClass('dismessage');
					jQuery("#helpful_"+reviewmasterunkid).hide();
					jQuery("#vote_"+reviewmasterunkid).hide();
				}
				else if(jQuery.trim(data)=='Exists')
				{
					jQuery("#dismessage_"+reviewmasterunkid).text(js_stripslashes(langjs[0]["L_ReviewReply3"]));
					jQuery("#dismessage_"+reviewmasterunkid).removeClass().addClass('dismessageerr');
					jQuery("#helpful_"+reviewmasterunkid).hide();
					jQuery("#vote_"+reviewmasterunkid).hide();
				}
				else
				{
					jQuery("#dismessage_"+reviewmasterunkid).text(js_stripslashes(langjs[0]["L_ReviewReply2"]));
					jQuery("#dismessage_"+reviewmasterunkid).removeClass().addClass('dismessageerr');
				}
			}
		});
	}
	catch(e)
	{
		console.log("helpfulclick - "+e);
	}
}
function applyfilter(hotelcode)
{
	try{
		var filter_val_sourcewise=jQuery("#filter_source_"+hotelcode).val();
		var filter_val_stay=jQuery("#filter_stay_"+hotelcode).val();
		
		jQuery(".client_review_"+hotelcode).hide();
		var filter_class_val='';
		
		if(filter_val_sourcewise === undefined || filter_val_sourcewise === null)
			filter_val_sourcewise = 0;
		
		if(filter_val_sourcewise!='')
			filter_class_val+=".source_"+filter_val_sourcewise;
		
		if(filter_class_val!='')
			jQuery(filter_class_val).show();
		else
			jQuery(".client_review_"+hotelcode).show();
			
		var findvisible=jQuery(".client_review_"+hotelcode+":visible").length;
		
		if(findvisible==0){
			jQuery("#norecordfilter_"+hotelcode).show();
		}
		else{
			jQuery("#norecordfilter_"+hotelcode).hide();
		}
		
		//Chinmay Gandhi - 23rd Aug 2019 - Reviews for MHBE [ RES-2066 ] - Start
		if(parseInt(findvisible) >= 5)
			jQuery("#loadmore_section_"+hotelcode).show();
		else
			jQuery("#loadmore_section_"+hotelcode).hide();
		//Chinmay Gandhi - 23rd Aug 2019 - Reviews for MHBE [ RES-2066 ] - End
	}
	catch(e)
	{
		console.log("Apply Filter - "+e);
	}
}
//Chinmay Gandhi - 24th June 2019 - End
//Chinmay Gandhi - Closest Availability Tool [ RES-2079 ] - Start
function find_closest_availability(param,type,prefixsuffix)
{
	try{
		_loader('Show');
		closest_param = param.split('<:>');
		var serverurl = jQuery('#loadingurl').val();
		var newurlid = closest_param[1];
		var hotelcode = closest_param[5];
		
		if(jQuery("#crsaccount").val() == 1)
			var postData={GroupCode:jQuery("#groupcode").val(),chkin:closest_param[0],HotelId: newurlid,nights:closest_param[2],lang_code:closest_param[3],langtext:closest_param[4],travelid:"",ArrivalDate:closest_param[0],multihotel:'1',HotelCode:hotelcode};
		else
			var postData={chkin:closest_param[0],HotelId: newurlid,nights:closest_param[2],lang_code:closest_param[3],langtext:closest_param[4],travelid:"",ArrivalDate:closest_param[0],multihotel:'1',HotelCode:hotelcode};
		
		$.ajax({
			url: serverurl+'closest_ava_all.php',
			type: "POST",
			data: postData,
			success: function(response){
				if(JSON.parse($.trim(response)).length == 0){
					if(type == 0){
						jQuery('#grid_closest_available_'+hotelcode).html('<span style="color:#FF0000">'+js_stripslashes(langjs[0]["L_Noava2"])+'</span>');
						jQuery('#list_closest_available_'+hotelcode).html('<span style="color:#FF0000">'+js_stripslashes(langjs[0]["L_Noava2"])+'</span>');
					}else{
						jQuery('#closest_available').html('<span style="color:#FF0000">'+js_stripslashes(langjs[0]["L_Noava2"])+'</span>');
					}
				}
				else
				{
					var data = JSON.parse($.trim(response));
					var html_content = '<div class="semibold">'+js_stripslashes(langjs[0]["L_available_dates"])+'</div>';
					var cnt = 0;
					html_content +='<div class="list-alt_date">';
					jQuery.each(data, function(key, val){
						if(cnt <= 2){
							if(type == 0){
								html_content +='<a href="javascript:void(0)" onclick=_redirect_seldate("'+hotelcode+'","'+val.Link.StartDate+'","'+val.Link.EndDate+'","'+type+'") class="alt_date">'+val.Dates+'</a>';
	
								cnt++;
							}
							else
							{
								html_content +='<a href="javascript:void(0)" onclick=_redirect_seldate("'+hotelcode+'","'+val.Link.StartDate+'","'+val.Link.EndDate+'","'+type+'") class="alt_date">'+val.Dates+' <span class="price price d-flex align-items-center"><span class="lbl_pernight">'+js_stripslashes(langjs[0]["L_per_night"])+' </span><span class="amount"><span class="currency '+prefixsuffix+'">'+val.currency_sign+'</span>'+val.Book_Rate+'</span></span></a>';
							}
						}
					});
					html_content +='</div>';

					if(type == 0){
						jQuery('#grid_closest_available_'+hotelcode).html(html_content);
						jQuery('#list_closest_available_'+hotelcode).html(html_content);
					}else{
						jQuery('#closest_available').html(html_content);
					}
				}
			}
		});
		_loader('Hide');
	}
	catch(err){
		console.log("Error - Find_Closest_Availability : ");
		console.log(err);
	}
}
function _redirect_seldate(hotelcode,chkin,chkout,type){
	try{
		_loader('Show');
		var serverurl = jQuery('#loadingurl').val();
			
		In_date = chkin.replace(/-| |,|_/g,'_');
		Out_date = chkout.replace(/-| |,|_/g,'_');
		
		if(jQuery('#crsaccount').val() == 1)
			var url = serverurl+'roomlisting-'+jQuery('#groupcode').val()+'-'+jQuery('.befoldername_'+hotelcode).val()+jQuery('#selectedLang').val();
		else
			var url = serverurl+'roomlist-'+jQuery('#hotel_code').val()+jQuery('#selectedLang').val();
		
		var form =	jQuery('<form action="' + url + '" method="post">' +
					 '<input type="text" name="checkIn" value="' + In_date + '" />' +
					 '<input type="text" name="checkOut" value="' + Out_date + '" />' +
					 '</form>');
		jQuery('body').append(form);
		form.submit();
		
		_loader('Hide');
	}
	catch(err){
		console.log("Error - Redirect Seldate : ");
		console.log(err);
	}
}
//Chinmay Gandhi - Closest Availability Tool [ RES-2079 ] - End
function addDataLayerSearchHotel(checkindate, checkoutdate, destination) {
    var data = {
        event: 'booking_step',
        step: 1,
        step_name: 'search_initiated',
        search_criteria: {
            destination: destination,
            check_in_date: checkindate,
            check_out_date: checkoutdate,
            guests: '',
            rooms: ''
        }
    };

    var scriptContent = 'window.dataLayer = window.dataLayer || []; window.dataLayer.push(' + JSON.stringify(data) + ');';

    var existingScript = document.querySelector('script[data-datalayerscript="step1"]');
    if (existingScript) {
        existingScript.remove();
    }

    var dataLayerScript = document.createElement("script");
    dataLayerScript.dataset.datalayerscript = "step1";
    dataLayerScript.textContent = scriptContent;
    document.head.appendChild(dataLayerScript);
}

function addDataLayerRoomSelection(selected_currency) {
    var hotelData = [];
    var currentHotel = null;

    jQuery('.itn-summ > div').each(function () {
        if (jQuery(this).hasClass('itinerary-hotelname')) {
            if (currentHotel) {
                hotelData.push(currentHotel);
            }
            currentHotel = {
                hotelName: jQuery(this).text().trim(),
                rooms: []
            };
        } else if (jQuery(this).hasClass('itinerary-roomwrap') && currentHotel) {
            var roomInfo = jQuery(this).find('.itn-room-info');
            var priceInfo = jQuery(this).find('.itn-price');

            var roomType = roomInfo.find('.itn-room-type').text().trim().replace(' - ', '');
            var ratePlan = roomInfo.find('.itn-rate-plan').text().trim();
            var nights = roomInfo.find('.itn-nights').text().trim().split(' ')[0];
            var price = priceInfo.find('.cartprice').text().trim();

            currentHotel.rooms.push({
                roomType: roomType,
                ratePlan: ratePlan,
                nights: nights,
                price: price
            });
        }
    });

    if (currentHotel) {
        hotelData.push(currentHotel);
    }

    var hotelDataString = JSON.stringify(hotelData);

    var data = {
        event: 'booking_step',
        step: 2,
        step_name: 'room_selection',
        currency: selected_currency,
        hotel_data: hotelData
    };

    var scriptContent = 'window.dataLayer = window.dataLayer || []; window.dataLayer.push(' + JSON.stringify(data) + ');';

    var existingScript = document.querySelector('script[data-datalayerscript="step2"]');
    if (existingScript) {
        existingScript.remove();
    }

    var dataLayerScript = document.createElement("script");
    dataLayerScript.dataset.datalayerscript = "step2";
    dataLayerScript.textContent = scriptContent;
    document.head.appendChild(dataLayerScript);
}

function addDataLayerGuestDetails(guestname, email, phone) {
    if (!guestname) {
        var firstname = jQuery('#first_name_0_0').val();
        var lastname = jQuery('#last_name_0_0').val();
        guestname = firstname + ' ' + lastname;
    }

    var special_requests = jQuery('#request_0_0').val();
    if (!special_requests) {
        special_requests = '';
    }

    var data = {
        event: 'booking_step',
        step: 3,
        step_name: 'guest_details',
        guest_name: guestname,
        guest_email: email,
        guest_phone: phone,
        special_requests: special_requests
    };

    var scriptContent = 'window.dataLayer = window.dataLayer || []; window.dataLayer.push(' + JSON.stringify(data) + ');';

    var existingScript = document.querySelector('script[data-datalayerscript="step3"]');
    if (existingScript) {
        existingScript.remove();
    }

    var dataLayerScript = document.createElement("script");
    dataLayerScript.dataset.datalayerscript = "step3";
    dataLayerScript.textContent = scriptContent;
    document.head.appendChild(dataLayerScript);
}

function addDataLayerPaymentDetails(paymentmethod) {
    var paymentMethodText = '';

    if (paymentmethod === '1') {
        paymentMethodText = "Booking Enquiry";
    } else if (paymentmethod === '2') {
        paymentMethodText = "Credit/Debit Card";
    } else if (paymentmethod === '3') {
        paymentMethodText = "Online Payment";
    } else {
        paymentMethodText = "Unknown";
    }

    var totalPaymentElement = document.getElementById('_totalpayment');
    var amountstring = '';

    if (totalPaymentElement && totalPaymentElement.textContent) {
        var amountText = totalPaymentElement.textContent.trim();
        var parts = amountText.split(' ');
        if (parts.length > 1) {
            amountstring = parts[1];
        }
    }

    var data = {
        event: 'booking_step',
        step: 4,
        step_name: 'payment_page',
        total_price: amountstring,
        payment_method: paymentMethodText
    };

    var scriptContent = 'window.dataLayer = window.dataLayer || []; window.dataLayer.push(' + JSON.stringify(data) + ');';

    var existingScript = document.querySelector('script[data-datalayerscript="step4"]');
    if (existingScript) {
        existingScript.remove();
    }

    var dataLayerScript = document.createElement("script");
    dataLayerScript.dataset.datalayerscript = "step4";
    dataLayerScript.textContent = scriptContent;
    document.head.appendChild(dataLayerScript);
}

function addDataLayerBookingStatus(status, currency, bookingData) {
    var event = '';
    var step_name = '';
    var payment_status = '';
    var failure_reason = '';

    if (status === 'Confirm') {
        event = 'booking_complete';
        step_name = 'booking_success';
        payment_status = 'Success';
        failure_reason = '';
    } else if (status === 'Fail') {
        event = 'payment_failed';
        step_name = 'payment_failure';
        payment_status = 'Failed';
        failure_reason = 'Payment Failed';
    } else if (status === 'Pending') {
        event = 'booking_complete';
        step_name = 'booking_success';
        payment_status = 'Pending';
        failure_reason = '';
    }

    var bookingDataString = 'Blank Booking Data';
    if (bookingData && typeof bookingData === 'object') {
        try {
            bookingDataString = JSON.stringify(bookingData);
        } catch (e) {
            console.error('Invalid booking data:', e);
        }
    }

    var totalRoomCharges = jQuery('.price-summery .item:first .amount').text().trim().split(' ')[1] || '';

    var data = {
        event: event,
        step: 5,
        step_name: step_name,
        total_price: totalRoomCharges,
        currency: currency,
        booking_data: bookingData,
        payment_status: payment_status,
        failure_reason: failure_reason
    };

    var scriptContent = 'window.dataLayer = window.dataLayer || []; window.dataLayer.push(' + JSON.stringify(data) + ');';

    var existingScript = document.querySelector('script[data-datalayerscript="step5"]');
    if (existingScript) {
        existingScript.remove();
    }

    var dataLayerScript = document.createElement("script");
    dataLayerScript.dataset.datalayerscript = "step5";
    dataLayerScript.textContent = scriptContent;
    document.head.appendChild(dataLayerScript);
}